


























































































































// 定数
import {
  PartsListHeaders,
  PartsListHeadersFJapan,
  DetailsAdditionalInputListHeaders,
  EstimateInputDataColumns,
  EstimateListDisplayButtonItems,
  EstimateListDisplayButtonDisabledItems,
  EstimateTableSearchLargeItemData,
  EstimateTableSearchSmallItemData,
  EstimateTableTaxClassificationSearchLargeItemData,
  EstimateTableTaxClassificationSearchSmallItemData,
  EstimateCommodityMasterDatas,
  EstimateDatailAddInputBaseFormat,
  EstimateMasterDatas,
  EstimateDatailBaseFormat,
  EstimateListDisplayInputFormatItemsPartsList,
  EstimateListDisplayInputFormatItemsDetailAddList,
  EstimateListDisplayInputFormatItemsEstimateDetailList,
  EstimateDeleteActionId,
  ExceptionHeaderItem,
  EstimateMonthlyLeaseFeeWording,
  EstimateFixedMatterWording,
  EstimateFractionRoundWording,
  EstimateCreditCheckWording,
  ZeroVisibleCheckBoxsData,
  TemplateWarningMessage
} from '@/constants/estimate/estimate';

// コンポーネント
import { Component, Vue } from 'vue-property-decorator';
import { Route } from 'vue-router';
import hexabaseState from '@/store/hexabase';
import userState from '@/store/user';
import {
  FieldsInfo,
  StatusList,
  StatusActions,
  ItemActions,
  ActionButtons,
  HexaFileFieldResponse,
  FieldChildrenProp,
  ApiData,
  GetInputFieldsActons
} from '@/services/hexabase/types';
import Header from '@/components/common/modules/Header.vue';
import SideMenu from '@/components/common/modules/SideMenu.vue';
import PageInfoBar from '@/components/common/modules/PageInfoBar.vue';
import ActionButtonPanel from '@/components/common/modules/ActionButtonPanel.vue';
import TransitionDialog from '@/components/common/modules/TransitionDialog.vue';
import DialogFormOutput from '@/components/common/modules/DialogFormOutput.vue';
import ExecAction from '@/components/common/modules/ExecAction.vue';
import IconTextLink from '@/components/common/elements/IconTextLink.vue';

import HeaderPanel from '@/components/common/modules/HeaderPanel.vue';
import AutoCreateForm from '@/components/form/AutoCreateForm.vue';
import TabPanel from '@/components/common/modules/TabPanel.vue';
import Dialog from '@/components/common/modules/Dialog.vue';

// Model
import Estimate from '@/models/estimateModel';
import CalculationModel from '@/models/calculationModel';
import Matter from '@/models/matterModel';

// Form
import {
  estimateInfomationHeader,
  estimateSubjectNames,
  estimateOAInformations,
  estimateGeneralInformations,
  estimateFJapanInformations,
  estimateInformationSummary,
  estimateDetailSummary
} from '@/constants/form/estimateForm';

import { CheckBoxProps } from '@/constants/form/types';
import { DSNames } from '@/constants/dataStore';

import { estimateApplyAbove } from '@/constants/form/inputCheck';
import { inputNames } from '@/constants/docurain/docurain';
import { optionalOutPutFormPO, materialOptionalOutPutFormPO } from '@/constants/form/form';
import { DateTime } from 'luxon';
import appState from '@/store/app';

Component.registerHooks(['beforeRouteEnter', 'beforeRouteUpdate']);

/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-non-null-assertion */

/** ワーク用 インターフェース ToDo: 外出しを検討する！ */
interface PartsListDataFormat {
  Status: string;
  classification_id: string;
  commodity_id: string;
  created_at: any;
  created_by: any;
  d_id: string;
  display_material_id: string;
  i_id: string;
  id: any;
  item: string;
  item_code: string;
  model_number: string;
  p_id: string;
  parts_supplier_id: string;
  remarks: string;
  rev_no: number;
  standard_unit_price: number;
  unit_lower_limit?: number;
  unit_upper_limit?: number;
  status_id: string;
  title: string;
  transfer_unit_price: number;
  type_id: string;
  unread: any;
  updated_at: any;
  updated_by: any;
  No: number;
  quantity: number;
  quantity_lower_limit?: number;
  quantity_upper_limit?: number;
  reference_transfer_unit_price: number;
  sale_price: number;
  transfer_amount_price: number;
  operating_income: number;
  profit_rate: any;
  lookup_items: any;
  purchasing_price: number;
  edit_price_flag?: string | boolean;
  edit_material_flag?: string | boolean;
  buttonDisabled?: string | boolean;
}

@Component({
  components: {
    Header,
    SideMenu,
    PageInfoBar,
    ActionButtonPanel,
    TransitionDialog,
    DialogFormOutput,
    ExecAction,
    TabPanel,
    HeaderPanel,
    AutoCreateForm,
    IconTextLink,
    Dialog
  },
  beforeRouteEnter(to: Route, from: Route, next: any): void {
    next((vm: any) => {
      vm.prevRoute = from;
      next();
    });
  },
  beforeRouteUpdate(to, from, next) {
    // URL変更前
    next();
    // URL変更後
    // URL変更のタイミングで再描画する
    if (to.path !== from.path) {
      this.$router.go(0);
    }
  }
})

/* eslint-disable @typescript-eslint/camelcase */
export default class EstimateEdit extends Vue {
  private matter = new Matter();
  private self: any = this;
  private prevRoute: any = null;
  private urlParams: any = {};

  private estimate = new Estimate();
  // 計算関係のモデル
  private calculationModel = new CalculationModel();
  // 本画面で使用する小数点を四捨五入する際のデフォルト値
  private defaultRoundingType = { calculationType: 'decimalRound', digit: 1 };
  // 案件基本情報共通ヘッダー
  private estimateHeaderData = { cols: {}, datas: {} as { [k: string]: any } };
  // 見積件名、見積版名
  private estimateSubjectData = { cols: {}, datas: {} as { [k: string]: any } };
  // 見積情報
  private estimateInformationPanel = { cols: {}, datas: {} as { [k: string]: any } };
  private estimateInformationsData = {};
  // 見積集計情報
  private estimateInformationSummary = { cols: {}, datas: {} as { [k: string]: any } };
  private estimateDetailSummary = { cols: {}, datas: {} as { [k: string]: any } };
  private estimateDetailSummaryLength = 0;
  // dbID格納プロパティ
  private matterDsId = '';
  private matterServiceDsId = '';
  private estimateDsId = '';
  // 案件基本情報のi_id
  private matterItemId = '';
  // 登録先となる案件サービス(OA、汎用)のi_id
  private projectServiceItemId = '';
  // APIレスポンス
  private matterServiceInformationResult: any = [];
  private estimateInformationResult: any = [];
  // 発注の初期ステータス
  private displayStatus = '';
  // アイテム登録後ダイアログ
  private dialogStatus = false;
  private isLoading = false;
  private transitionDialogTitle = '実行完了';
  private registerText = '登録が完了いたしました';
  private buttons: Array<{ [k: string]: string | number }> = [
    {
      id: 1,
      color: 'primary',
      type: 'routing',
      name: 'toEdit',
      value: '詳細画面へ',
      route: '/estimate/edit/:datastoreId/:id'
    }
  ];
  // TODO:入力制限などがないのでひとまず、登録ボタンを押下可能に変更(true → false)
  private registAuthority = false;
  private guideMessage = '';

  // 案件詳細から受け渡された案件情報のアイテムID
  private passedItemId = this.$route.params.id;
  private passedDatastoreId = this.$route.params.datastoreId;

  private serviceTypeItemId = '';
  private serviceTypeId = '';
  private serviceType = 'OAリース';
  private serviceTypeItems: any = {};
  private screenStructureType = '1';
  private showDetailAddListFlag = true;
  private nextItemId = '';

  // マスタデータ関連格納プロパティ
  private masterData: { [k: string]: { [k: string]: Array<{ [k: string]: string }> } } = {};

  // マスター参照系の変数
  // 商材
  private masterCommoditySelectData: any = [];
  // 明細追加入力マスタ
  private mastermEstimateDetailAddInputSelectData: any = [];
  private masterEstimateDetailAddInputSelectItem = {
    title: '明細追加入力マスタ',
    column: EstimateMasterDatas.DatailAddInputColumns,
    data: this.mastermEstimateDetailAddInputSelectData,
    searchItemData: {
      // 区分、種別、品名
      searchLargeItemData: EstimateTableSearchLargeItemData,
      searchSmallItemData: EstimateTableSearchSmallItemData,
      freeFormatLabelName: '品名',
      freeFormatLabelDisplayId: 'item',
      labelName: ['区分', '種類']
    }
  };
  // 見積明細マスタ
  private mastermEstimateDetailSelectData: any = [];
  private masterEstimateDetailSelectItem = {
    title: '見積明細マスタ',
    column: EstimateMasterDatas.DatailColumns,
    data: this.mastermEstimateDetailSelectData,
    searchItemData: {
      // 区分、種別、項目
      searchLargeItemData: EstimateTableSearchLargeItemData,
      searchSmallItemData: EstimateTableSearchSmallItemData,
      freeFormatLabelName: '項目',
      freeFormatLabelDisplayId: 'item',
      labelName: ['区分', '種類']
    }
  };
  // 料率マスタ
  private mastermEstimateRateData: any = [];
  // 課税区分マスタ
  private masterTaxData: any = [];
  private masterTaxSelectItem = {
    title: '課税区分マスタ',
    column: EstimateMasterDatas.masterTaxColumns,
    data: this.masterTaxData,
    searchItemData: {
      // 区分、種別、品名
      searchLargeItemData: EstimateTableTaxClassificationSearchLargeItemData,
      searchSmallItemData: EstimateTableTaxClassificationSearchSmallItemData,
      freeFormatLabelName: '',
      freeFormatLabelDisplayId: '',
      labelName: ['名称', '税率']
    }
  };
  // 構成表、見積表タブ内一覧
  private partsListColumn: any = [];
  // 表示用構成表
  private partsListViewData: any = [];
  // ベースとなる構成表
  private partsListBaseData: any = [];
  private detailAddListColumn: any = [];
  private detailAddListData: any = [];
  private detailListColumn: any = [];
  private detailListData: any = [];

  private deletePartsListData: any = [];

  private styleData = '';
  private setStyleData = 'margin-bottom: 100px;';
  // 商材マスタ参照選択のバリデーションルール
  private commodityRules = '';
  // TabPanelのオプションにEagerを付けて、タブの子要素をマウント時にレンダリングさせる
  private isEager = true;

  private registFieldType: any = {};
  private registPartsListFieldType: any = {};
  private registDetailAddListCFieldType: any = {};
  private registEstimateDetailListFieldType: any = {};

  // 「数量がゼロの行を非表示」チェックボックスデータ
  private checkBoxsData: Array<CheckBoxProps> = ZeroVisibleCheckBoxsData;
  // 「数量がゼロの行を非表示」チェックボックス状態
  private checkBoxsStatus = false;

  private mtempleteSelectDataOption: Array<{
    text: string;
    value: string | number;
  }> = [];
  private mtempleteSelectData = {
    label: '',
    name: 'select',
    disabled: false,
    dense: true,
    options: this.mtempleteSelectDataOption
  };
  private mtempleteSelectValue: any = {};

  //  税率毎サマリパネル
  private taxSummaryColumns: Array<{ [k: string]: string | number }> = [
    { value: 'name', text: '課税区分', order: 0, width: '15%' },
    { value: 'tax_rate', text: '税率（％）', order: 1, width: '15%' },
    { value: 'amount', text: '金額', order: 2, width: '15%' },
    { value: 'tax', text: '税額', order: 3, width: '15%' },
    { value: 'tax_included_amount', text: '合計', order: 4, width: '15%' }
  ];
  private taxData: Array<{ [k: string]: string | number }> = [];
  private defaultTaxData: any = {};

  private estimateTabData: any = [
    {
      title: '構成表',
      configurationTableData: {
        masterSelectDataCommodity: {
          columns: EstimateCommodityMasterDatas.Columns,
          body: this.masterCommoditySelectData,
          dialogTitle: '商材マスタ',
          outPutData: [
            { label: '商材', name: 'commodity', isReadOnly: true, value: ' ', isDisabled: true },
            { label: '商材仕入先', name: 'supplier_id', isReadOnly: true, isDisabled: true }
          ],
          searchLargeItemData: {
            findItemName: 'commodity',
            setItemValue: 'commodity',
            setItemText: 'commodity'
          },
          searchSmallItemData: {
            findItemName: 'supplier_id',
            setItemValue: 'supplier_id',
            setItemText: 'supplier_id'
          },
          freeFormatLabelName: 'サービス種別',
          freeFormatLabelDisplayId: 'service_type_id',
          labelName: ['商材', '商材仕入先'],
          rules: this.commodityRules,
          isBtnVisible: false,
          isShow: true
        },
        vmSelectDataTemplete: {
          selectData: this.mtempleteSelectData,
          selectValue: this.mtempleteSelectValue,
          isDisabled: true,
          isBtnVisible: true,
          isShow: true,
          isLoadingFlag: false,
          isParentDialogControlFlag: true,
          displayInfomation: ''
        },
        partsList: {
          listName: '構成明細',
          checkBoxsData: this.checkBoxsData,
          formOutputButtonName: '構成表出力',
          isAddItemButtonFlag: false,
          tableParameters: {
            isDisabledFormOutputButton: false,
            isDisabledNoteEdit: true,
            buttonItems: EstimateListDisplayButtonDisabledItems,
            inputItems: [],
            columns: this.partsListColumn,
            body: this.partsListViewData,
            tableText: '商材が選択されていません'
          },
          subHeadersScrollWidthData: 0,
          masterSelectItem: this.masterTaxSelectItem
        },
        detailAddList: {
          listName: '明細追加入力一覧',
          isAddItemButtonFlag: true,
          isShow: false,
          tableParameters: {
            isDisabledNoteEdit: true,
            isDisabledAddItemButtonFlag: true,
            buttonItems: EstimateListDisplayButtonDisabledItems,
            inputItems: [],
            columns: this.detailAddListColumn,
            body: this.detailAddListData,
            tableText: '項目が選択されていません'
          },
          masterSelectItem: {
            selectButtonIndex: this.masterEstimateDetailAddInputSelectItem,
            taxClassificationButton: this.masterTaxSelectItem
          }
        }
      },
      component: 'ConfigurationTable'
    },
    {
      title: '見積情報',
      estimateInformationData: {
        estimateRateData: {
          estimateInformationPanel: this.estimateInformationPanel,
          isStatusConfirmed: false,
          isFractionRoundingDisabled: true,
          isUndoFractionRoundingDisabled: true,
          isRecalcDisabled: true
        },
        estimateDetailInformation: {
          estimateInformationPanel: this.estimateInformationPanel
        },
        estimateDetailList: {
          listName: '見積表',
          formOutputButtonName: '見積表出力',
          isEstimateAddItemButtonFlag: true,
          tableParameters: {
            isDisabledFormOutputButton: false,
            isDisabledNoteEdit: true,
            isDisabledAddItemButtonFlag: true,
            buttonItems: EstimateListDisplayButtonDisabledItems,
            inputItems: [],
            columns: this.detailListColumn,
            body: this.detailListData,
            tableText: '項目が選択されていません'
          },
          masterSelectItem: {
            selectButtonIndex: this.masterEstimateDetailSelectItem,
            taxClassificationButton: this.masterTaxSelectItem
          }
        },
        estimateDetailSummary: {
          estimateDetailSummary: this.estimateDetailSummary,
        },
        createTaxSummary: {
          taxSummaryColumns: this.taxSummaryColumns,
          taxData: this.taxData
        },
        assistNotification: {
          changeCurrentField: '',
          changeCurrentFieldValue: '',
          calculateContractMonthsMonthlyLeaseFee: '',
          calculateMonthlyLeaseFeeRate: '',
          monthlyLeaseFee: '',
          rate: '',
          discountAmountContractMonthsMonthlyLeaseFee: '',
          discountAmountMonthlyLeaseFeeRate: '',
          contractMonths: ''
        },
        isGeneral: false,
        isEstimateFixedDisabled: false
      },
      component: 'EstimateInformation'
    }
  ];

  // 登録用情報格納プロパティ
  private registData: any = {
    'use_display_id': true,
    'ensure_transaction': true,
    'action_id': '',
    'item': {},
    'related_ds_items': {}
  };
  // 更新用情報格納プロパティ
  private updateData: any = {
    'use_display_id': true,
    'ensure_transaction': true,
    'action_id': '',
    'item': {},
    'related_ds_items': {}
  };

  // 各一覧用登録データ
  private registMaterialItemData: any = [];
  private registDatailAddInputItemData: any = [];
  private registEstimateDetailItemData: any = [];

  // 各一覧用登録データのバックアップ
  private registDataBackup: any = {};
  private registMaterialItemDataBackup: any = [];
  private registDatailAddInputItemDataBackup: any = [];
  private registEstimateDetailItemDataBackup: any = [];

  // 各一覧用削除データ
  private registMaterialItemDeleteData: any = [];
  private registDatailAddInputItemDeleteData: any = [];
  private registEstimateDetailItemDeleteData: any = [];

  private projectId = hexabaseState.applicationId;

  private selectOptions: any = {};
  //////////////////////////////////////////////////////////////////////////////////////////
  // dbID格納プロパティ
  private relatedDsId = '';

  private editText = '';

  private subHeadersScrollWidthDatas: any = {
    構成明細: { targetName: '構成明細', width: 0 }
  };

  // 編集対象アイテム情報
  private revNumber = 0;
  private currentData: Array<FieldsInfo> = [];
  private currentDetailData: any = [];

  // アクション情報格納プロパティ
  private statusButton: Array<StatusActions> = [];
  private statusAction: Array<StatusActions> = [];
  private itemActions: Array<ItemActions> = [];
  private detailStatusAction: Array<StatusActions> = [];
  private detailItemActions: Array<ItemActions> = [];
  private execAllowActions: Array<ActionButtons> = [];
  private execAllowActionsByDetail: Array<ActionButtons> = [];
  private selectAction = '';

  // ステータス情報格納プロパティ
  private statusList: Array<StatusList> = [];

  private buttonCrudType = '';

  private noteDialog = false;
  private noteName = '備考';
  private noteValue = '';
  private noteOpenIndex = 0;
  private exceptionHeaderItem = ExceptionHeaderItem;

  // 帳票出力ダイアログ
  private formOutputDsId = '';
  private formOutputDialogStatus = false;
  private formOutputFieldsData: Array<FieldChildrenProp> = [];
  private formOutputFieldCols = '30% 30% 30% 10%';
  private formType: { [k: string]: any }[] = [];
  private formTemplateList: { [k: string]: any }[] = [];
  private pushFormButtonType = '';
  private isAlert = false;
  private alertMessage = '';
  private isformOutputLoading = false;

  // グルーピングルール
  private groupingRule: any = null;

  // 月額リース料に端数が発生した場合、登録時にワーニング表示する内容
  private isExecDialog = false;
  private execDialogMessage = EstimateMonthlyLeaseFeeWording.execDialog.message;
  private execDialogTitle = EstimateMonthlyLeaseFeeWording.execDialog.title;
  private fractionValue = 0;
  private execActionType = '';

  // 見積確定ボタンを押下した場合に表示する内容
  private isFixedMatterDialog = false;
  private fixedMatterDialogMessage = '';
  private fixedMatterDialogTitle = EstimateFixedMatterWording.fixedMatterDialog.title;
  private fixedMatterbuttonTextOK = EstimateFixedMatterWording.fixedMatterDialog.buttonTextOK;
  private isFixedMatterLoading = false;

  // アラートダイアログに表示する内容
  private isAlertDialog = false;
  private alertDialogMessage = '';
  private alertDialogTitle = '';

  // 金額調整ボタンを押下した場合に表示する内容
  private isRecalcDialog = false;
  private recalcDialogMessage = EstimateFractionRoundWording.confirmRecalc.message;
  private recalcDialogTitle = EstimateFractionRoundWording.confirmRecalc.title;

  // 事前与信比較チェックで表示する内容
  private isCreditCheckDialog = false;
  private creditCheckDialogMessage = EstimateCreditCheckWording.alertCreditCheck.message;
  private creditCheckDialogTitle = EstimateCreditCheckWording.alertCreditCheck.title;
  private isCreditCheckDialogDisplayed = false; // ダイアログ表示済み判定フラグ

  private btnDisabledStatus: any = [
    'estimate_basic_infomation_OA_temporarily_saved',
    'estimate_basic_infomation_general_temporarily_saved',
    'estimate_basic_infomation_fjapan_temporarily_saved'
  ];

  // Field
  private projectServiceFields: any = {};
  private selectCreditStatusItem: any = [];

  // 端数調整用項目
  // 端数調整実施フラグ
  private fractionRoundingFlag = false;
  // 算出調整金額
  private adjustmentAmount = 0;
  // 端数調整値引き用見積明細マスタ情報
  private mastermEstimateDetailFractionDiscount: any = {};
  // 端数調整増額用見積明細マスタ情報
  private mastermEstimateDetailFractionIncrease: any = {};
  // 「料率変更する」アクションフラグ
  private isRateUpadateAction = false;
  // 料率変更フラグ
  private rateChangeFlag = false;
  // 構成明細一覧入力データ退避
  private saveMaterialInputItems: any = {};
  // 明細追加入力一覧入力データ退避
  private saveDetailAddInputItems: any = {};
  // 選択されたステータスアクションのID
  private selectActionDisplayId = '';
  // 見積確定ステータスかを保持
  private isEstimateConfirmed = false;

  // 事前与信チェック用項目
  // 承認された案件与信OAデータ情報
  private approvedProjectCreditOaItems: any = [];

  private totalSalePrice: any = 0;
  private outputData: any = [];
  private outputDataItems: any = [];

  private editMode = false;

  async created(): Promise<void> {
    try {
      // ローディングをセット
      this.$store.commit('hexabase/setIsLoading', true);

      // 既存アイテムを取得しアイテム情報・アクション情報を保持
      // 帳票マスタを設定
      this.formOutputDsId = hexabaseState.datastoreIds['帳票マスタ'];
      const searchScene = '見積書出力';
      const [
        estimateInformationResult,
        masterData,
        estimateFieldsListData,
        estimateDetailMasterHeaderFieldSetting,
        estimateDetailListHeaderFieldSetting,
        formOutputFieldsData
      ] = await Promise.all([
        this.estimate.getLinkedItems(
          hexabaseState.applicationId,
          this.passedDatastoreId,
          this.passedItemId,
          '&use_display_id=true'
        ),
        this.estimate.getEditMasterData(),
        this.estimate.makeFieldsList(this.projectId, this.passedDatastoreId),
        this.estimate
          .getFieldsData(this.projectId, hexabaseState.datastoreIds['見積明細マスタ'])
          .then(response => {
            this.setHeaderListColumn(
              response,
              EstimateMasterDatas.DatailColumns,
              this.estimateTabData[1].estimateInformationData.estimateDetailList.masterSelectItem,
              'column',
              this.exceptionHeaderItem
            );
          }),
        this.estimate
          .getFieldsData(this.projectId, hexabaseState.datastoreIds['見積明細'])
          .then(response => {
            this.setHeaderListColumn(
              response,
              EstimateInputDataColumns,
              this.estimateTabData[1].estimateInformationData.estimateDetailList.tableParameters,
              'columns',
              this.exceptionHeaderItem
            );
          }),
        this.estimate.outputFormDialogFieldData(
          searchScene,
          this.projectId,
          this.formOutputDsId,
          optionalOutPutFormPO
        )
      ]);
      this.estimateInformationResult = estimateInformationResult;
      this.formOutputFieldsData = formOutputFieldsData;

      // 見積基本情報OAまたは見積基本情報汎用からAPI取得する案件情報を判別し、API取得する
      if (this.estimateInformationResult !== []) {
        //let itemId = '';
        if (
          this.estimateInformationResult.linked_items['t_project_service_general'] !== undefined
        ) {
          this.screenStructureType = '99';
          this.matterServiceDsId = hexabaseState.datastoreIds['案件サービス別汎用'];
          this.estimateDsId = hexabaseState.datastoreIds['見積基本情報汎用'];
          this.projectServiceItemId = this.estimateInformationResult.linked_items[
            't_project_service_general'
          ].items[0].i_id;
        } else if (
          this.estimateInformationResult.linked_items['t_project_service_OA'] !== undefined
        ) {
          this.screenStructureType = '1';
          this.matterServiceDsId = hexabaseState.datastoreIds['案件サービス別OA'];
          this.estimateDsId = hexabaseState.datastoreIds['見積基本情報OA'];
          this.projectServiceItemId = this.estimateInformationResult.linked_items[
            't_project_service_OA'
          ].items[0].i_id;
        } else if (
          this.estimateInformationResult.linked_items['t_project_service_fjapan'] !== undefined
        ) {
          this.screenStructureType = '2';
          this.matterServiceDsId = hexabaseState.datastoreIds[DSNames[this.screenStructureType].PROJECT_SERVICE];
          this.estimateDsId = hexabaseState.datastoreIds[DSNames[this.screenStructureType].ESTIMATE_BASIC_INFOMATION];
          this.projectServiceItemId = this.estimateInformationResult.linked_items[
            't_project_service_fjapan'
          ].items[0].i_id;
        }

        if (this.screenStructureType === '2') {
          // F-Japanの場合、「数量がゼロの行を非表示」のチェックボックスを隠す
          this.checkBoxsData.splice(0, 1)
        } else {
          // 数量がゼロの行を非表示のチェックボックス初期値と状態を(false)に設定
          this.checkBoxsData = ZeroVisibleCheckBoxsData;
          this.checkBoxsData[0].default = true;
          this.checkBoxsStatus = true;
        }

        if (this.estimate.isNullOrUndefined(this.estimateInformationResult.status_actions)) {
          Object.keys(this.estimateInformationResult.status_actions).forEach(key => {
            this.statusAction.push(this.estimateInformationResult.status_actions[key]);
          });
        }
        if (this.estimate.isNullOrUndefined(this.estimateInformationResult.item_actions)) {
          Object.keys(this.estimateInformationResult.item_actions).forEach(key => {
            this.itemActions.push(this.estimateInformationResult.item_actions[key]);
          });
        }
        if (this.estimate.isNullOrUndefined(this.estimateInformationResult.status_list)) {
          Object.keys(this.estimateInformationResult.status_list).forEach(key => {
            this.statusList.push(this.estimateInformationResult.status_list[key]);
          });
        }

        this.selectOptions['orderAccuracy'] = estimateFieldsListData.find(
          v => v.display_id === 'order_accuracy'
        );

        // 案件基本情報OAまたは汎用の取得
        this.estimateHeaderData = this.getHeaderFields(estimateInfomationHeader);
        this.estimateSubjectData = this.getHeaderFields(estimateSubjectNames);
        // 帳票ダイヤログで使用する内容の抽出
        this.formTemplateList = this.formOutputFieldsData
          .map(field => {
            return field.display_id === inputNames.templateName
              ? field.props!.selectData.options
              : undefined;
          })
          .filter(value => value)[0];

        // 構成表、明細追加情報の取得
        const addPromises: any = [];

        if (this.screenStructureType === '2') {
          addPromises.push(
            this.estimate
              .getFieldsData(this.projectId, hexabaseState.datastoreIds['構成表'])
              .then(response => {
                this.setHeaderListColumn(
                  response,
                  PartsListHeadersFJapan,
                  this.estimateTabData[0].configurationTableData.partsList.tableParameters,
                  'columns',
                  this.exceptionHeaderItem
                );
              })
          );
        } else {
          addPromises.push(
            this.estimate
              .getFieldsData(this.projectId, hexabaseState.datastoreIds['構成表'])
              .then(response => {
                this.setHeaderListColumn(
                  response,
                  PartsListHeaders,
                  this.estimateTabData[0].configurationTableData.partsList.tableParameters,
                  'columns',
                  this.exceptionHeaderItem
                );
              })
          );
        }
        addPromises.push(
          this.estimate
            .getFieldsData(this.projectId, hexabaseState.datastoreIds['明細追加入力マスタ'])
            .then(response => {
              this.setHeaderListColumn(
                response,
                EstimateMasterDatas.DatailAddInputColumns,
                this.estimateTabData[0].configurationTableData.detailAddList.masterSelectItem,
                'column',
                this.exceptionHeaderItem
              );
            })
        );
        addPromises.push(
          this.estimate
            .getFieldsData(this.projectId, hexabaseState.datastoreIds['明細追加入力'])
            .then(response => {
              this.setHeaderListColumn(
                response,
                DetailsAdditionalInputListHeaders,
                this.estimateTabData[0].configurationTableData.detailAddList.tableParameters,
                'columns',
                this.exceptionHeaderItem
              );
            })
        );
        // 見積情報タブ内の見積情報を設定
        if (estimateInformationResult.linked_items.t_project_service_OA) {
          await Promise.all(addPromises);
        } else if (estimateInformationResult.linked_items.t_project_service_general) {
          await Promise.all(addPromises);
        }
        switch (this.screenStructureType) {
          case '1': {
            // OAリース
            if (this.btnDisabledStatus.includes(this.estimateInformationResult.field_values.Status.value)) {
              this.estimateTabData[1].estimateInformationData.isEstimateFixedDisabled = true;
            }
            this.estimateInformationPanel = this.getHeaderFields(estimateOAInformations);
            break;
          }
          case '99': {
            // 汎用
            this.estimateTabData[1].estimateInformationData.isGeneral = true;
            if (this.btnDisabledStatus.includes(this.estimateInformationResult.field_values.Status.value)) {
              this.estimateTabData[1].estimateInformationData.isEstimateFixedDisabled = true;
            }
            this.estimateInformationPanel = this.getHeaderFields(estimateGeneralInformations);
            break;
          }
          case '2': {
            // F-Japan
            this.estimateTabData[1].estimateInformationData.isGeneral = true;
            if (this.btnDisabledStatus.includes(this.estimateInformationResult.field_values.Status.value)) {
              this.estimateTabData[1].estimateInformationData.isEstimateFixedDisabled = true;
            }
            this.estimateInformationPanel = this.getHeaderFields(estimateFJapanInformations);
            break;
          }
        }
        // 編集した見積集計情報パネルを設定
        this.estimateInformationSummary = this.getHeaderFields(estimateInformationSummary);
        this.estimateDetailSummary = this.getHeaderFields(estimateDetailSummary);
        // 見積詳細画面で初期表示用のアクションはアイテムアクションの内容を更新する('update')を参照
        const initialAction = this.estimate.getFormDisplayAction(this.itemActions, 'update');

        const [matterServiceInformationResult, groupingRule] = await Promise.all([
          this.estimate.getLinkedItems(
            hexabaseState.applicationId,
            this.matterServiceDsId,
            this.projectServiceItemId,
            '&use_display_id=true'
          ),
          this.estimate.getItemList(
            hexabaseState.applicationId,
            hexabaseState.datastoreIds['グループ化マスタ'],
            {
              conditions: [
                {
                  id: 'Status',
                  search_value: ['grouping_valid']
                }
              ],
              sort_field_id: 'display_order',
              sort_order: 'asc',
              page: 1,
              per_page: 0,
              use_display_id: true,
              return_number_value: true,
              include_lookups: true
            }
          ),
          this.estimate
            .getFieldsByActionId(this.estimateDsId, initialAction!.action_id)
            .then(response => {
              const inputFields = response;
              this.setRegistFieldType(inputFields, this.registFieldType);
              this.inputFieldChange(this.estimateHeaderData.datas, inputFields, true);
              this.inputFieldChange(this.estimateSubjectData.datas, inputFields, true);
              this.inputFieldChange(this.estimateInformationPanel.datas, inputFields, true);
              this.inputFieldChange(this.estimateInformationSummary.datas, inputFields, true);
              // 商材マスタの必須入力チェック
              for (const index in inputFields.action_fields) {
                if (inputFields.action_fields[index].display_id === 'commodity_id') {
                  Object.keys(inputFields.action_field_settings).forEach(key => {
                    if (
                      inputFields.action_field_settings[key].field_id ===
                      inputFields.action_fields[index].field_id
                    ) {
                      // 入力可、必須のチェックは行わない(編集するなどのステータスアクションで行う)
                      if (
                        inputFields.action_field_settings[key].show !== null ||
                        inputFields.action_field_settings[key].show !== undefined
                      ) {
                        this.$set(
                          this.estimateTabData[0].configurationTableData.masterSelectDataCommodity,
                          'isShow',
                          inputFields.action_field_settings[key].show
                        );
                      }
                    }
                  });
                }
              }
              return response;
            })
        ]);
        this.matterServiceInformationResult = matterServiceInformationResult;
        this.groupingRule = groupingRule;
        // サービス種別や画面構成情報などを取得
        this.matterItemId = this.matterServiceInformationResult.linked_items[
          't_project_basic_infomation'
        ].items[0].i_id;
        this.serviceTypeItemId = this.matterServiceInformationResult.linked_items[
          't_project_basic_infomation'
        ].items[0].lookup_items.service_type_id['i_id'];
        this.serviceType = this.matterServiceInformationResult.linked_items[
          't_project_basic_infomation'
        ].items[0].lookup_items.service_type_id['service_type'];
        this.screenStructureType = this.matterServiceInformationResult.linked_items[
          't_project_basic_infomation'
        ].items[0].lookup_items.service_type_id['screen_structure_type'];
        // データベース参照のサービス種別
        this.serviceTypeItems = this.matterServiceInformationResult.linked_items[
          't_project_basic_infomation'
        ].items[0].lookup_items.service_type_id;

        // 明細追加入力表示/非表示フラグ値を取得してセット
        // （文字列となっているので変換）
        this.showDetailAddListFlag = JSON.parse(
          this.matterServiceInformationResult.linked_items[
            't_project_basic_infomation'
          ].items[0].lookup_items.service_type_id['show_detail_add_list_flag'].toLowerCase()
        );
        this.estimateTabData[0].configurationTableData.detailAddList.isShow = this.showDetailAddListFlag;

        if (this.screenStructureType === '1') {
          // 案件与信OAの情報を取得（OAリースの場合のみ）
          const projectCreditOaData = this.matterServiceInformationResult.linked_items[
            't_project_credit_OA'
          ];
          if (projectCreditOaData) {
            // 案件与信OAの情報があれば比較用に成型
            // 「承認」データのみ抽出
            const approvedItems = projectCreditOaData.items.filter(
              (v: { check_status: string }) => v.check_status === '承認'
            );
            // 「承認」データループ
            for (const index in approvedItems) {
              // 与信商品が選択されていない場合は対象外
              if (approvedItems[index]['lookup_items']['credit_product_id']) {
                // リース会社（マスタのi_id）および承認金額を取得
                const baseItem: any = {
                  leasing_company_id: '',
                  approval_monthly_lease_fee: 0
                };
                baseItem['leasing_company_id'] =
                  approvedItems[index]['lookup_items']['credit_product_id']['lookup_items'][
                    'leasing_company_id'
                  ]['i_id'];
                baseItem['approval_monthly_lease_fee'] =
                  approvedItems[index]['approval_monthly_lease_fee'];

                this.approvedProjectCreditOaItems.push(baseItem);
              }
            }
          }
        }
      }

      // 帳票出力ボタン表示判定
      const outputActions = this.itemActions.find(v => v.display_id === 'output');
      if (outputActions === undefined) {
        this.estimateTabData[0].configurationTableData.partsList.formOutputButtonName = '';
        this.estimateTabData[1].estimateInformationData.estimateDetailList.formOutputButtonName =
          '';
      }

      // ステータスリストを取得
      const currentStatus = this.estimateInformationResult.field_values.Status;
      const currentStatusData = this.statusList.find(function(recode: any) {
        if (recode.display_id === currentStatus.value) {
          return recode;
        }
      });
      this.displayStatus = currentStatusData ? currentStatusData.status_name : 'ステータス取得失敗';
      if (this.displayStatus === '見積確定') {
        // 見積確定ステータスであれば金額調整ボタンを表示、端数調整系ボタンを非表示
        this.estimateTabData[1].estimateInformationData.estimateRateData.isStatusConfirmed = true;
        this.isEstimateConfirmed = true;
      }

      // ステータス移管に使用するためリビジョン番号を格納
      this.revNumber = this.estimateInformationResult.rev_no;

      // DB登録用データを作成
      this.currentData = this.estimateInformationResult.field_values;
      for (const key in this.currentData) {
        if (this.currentData[key].value !== undefined && this.currentData[key].value !== null) {
          let value = this.currentData[key].value;
          if (
            this.currentData[key].dataType === 'dslookup' &&
            typeof this.currentData[key].value === 'object' &&
            this.currentData[key].value !== null &&
            this.currentData[key].value.item_id !== undefined
          ) {
            value = this.currentData[key].value.item_id;
          }
          if (this.currentData[key].dataType === 'file') {
            value =
              this.currentData[key].value.length === 0
                ? []
                : (this.currentData[key].value as HexaFileFieldResponse[])
                    .map(file => file.file_id)
                    .filter(v => v);
          }
          this.registData.item[this.currentData[key].field_id] = value;
        }
      }
      this.registDataBackup = JSON.parse(JSON.stringify(this.registData));
      this.execAllowActions = this.statusAction.filter(
        v => !v.display_id!.indexOf('estimate_basic_info')
      ) as Array<ActionButtons>;
      this.statusButton = this.estimate.statusButtonList(this.execAllowActions, this.currentData);

      // 共通ヘッダー情報の作成
      const matterBasicInformation = this.matterServiceInformationResult.linked_items[
        't_project_basic_infomation'
      ].items[0];
      const headerData = {
        // 顧客番号、顧客名、案件名、見積番号、サービス種別、支払情報、見積作成者
        0: matterBasicInformation.lookup_items.customer_id.customer_id,
        1: matterBasicInformation.lookup_items.customer_id.customer_name,
        2: matterBasicInformation.project_name,
        3: this.estimateInformationResult.field_values.estimate_id.value,
        4: this.serviceType,
        5: matterBasicInformation.lookup_items.payment_information.payment_information,
        6: this.estimateInformationResult.created_by,
        7: this.estimate.editDatetype(
          this.estimateInformationResult.created_at,
          'Asia/Tokyo',
          'yyyy/MM/dd'
        )
      } as { [key: string]: any };
      this.getHeaderData(headerData, this.estimateHeaderData);
      // 見積件名、見積版名の設定
      const subjectData = {
        // 見積件名、見積版名
        0: this.estimateInformationResult.field_values.estimate_subject.value,
        1: this.estimateInformationResult.field_values.estimate_version_name.value
      };
      this.getHeaderData(subjectData, this.estimateSubjectData);

      // マスターデータを取得しグローバル変数に格納
      this.masterData = this.estimate.getMaster();
      // 課税区分に登録がない場合のデフォルト値
      this.defaultTaxData = this.masterData['m_tax'].body.find(
        (v: any) => v.current_tax_flag === 1
      );

      // 商材マスタのマスタ参照用データ作成
      // (ヘッダーはestimate.tsから取得)
      // 商材マスタをサービス種別で絞り込む
      const serviceType = this.serviceType;
      const commodityItemResult = this.masterData['m_commodity'].body.filter(function(recode) {
        if (serviceType === recode.service_type_id) {
          return recode;
        }
      });

      for (const key in commodityItemResult) {
        this.masterCommoditySelectData.push(commodityItemResult[key]);
      }
      // 商材の表示設定
      let baseCommodityId = '';
      if (
        this.estimateInformationResult.field_values.commodity_id.value !== null &&
        this.estimateInformationResult.field_values.commodity_id.value !== undefined
      ) {
        baseCommodityId = this.estimateInformationResult.field_values.commodity_id.value.lookup_item
          .id;
      }
      const setMaterialData = this.masterCommoditySelectData.find(function(recode: any) {
        if (baseCommodityId === recode.id) {
          return recode;
        }
      });

      if (setMaterialData !== undefined) {
        this.estimateTabData[0].configurationTableData.masterSelectDataCommodity.outPutData[0].value =
          setMaterialData['commodity'];
        this.estimateTabData[0].configurationTableData.masterSelectDataCommodity.outPutData[1].value =
          setMaterialData['supplier_id'];

        //見積表、項目追加ボタン表示フラグ制御
        this.estimateTabData[1].estimateInformationData.estimateDetailList.isEstimateAddItemButtonFlag = JSON.parse(setMaterialData.edit_estimate_flag.toLowerCase());
      }

      // 初期ロード？に合わせてテンプレートを活性
      const getBody = this.masterData['m_materialtemplate'].body.filter(
        v => v.commodity_id === setMaterialData['commodity']
      );
      if (getBody !== undefined && getBody.length > 0) {
        this.mtempleteSelectDataOption.splice(0, this.mtempleteSelectDataOption.length);
        getBody.forEach(v => {
          this.mtempleteSelectDataOption.push({ text: v.template_name, value: v.i_id });
        });
      }

      // 構成表取得
      this.estimateInformationResult.linked_items['t_material'].items.sort(
        (a: any, b: any) => a.display_order - b.display_order
      );
      for (const index in this.estimateInformationResult.linked_items['t_material'].items) {
        const baseItems = this.estimateInformationResult.linked_items['t_material'].items[index];
        baseItems['No'] = Number(index) + 1;
        // lookup_itemsから各データを設定
        baseItems['item'] = baseItems.lookup_items.material_id.item;
        baseItems['model_number'] = baseItems.lookup_items.material_id.model_number;
        baseItems['classification_id'] =
          baseItems.lookup_items.material_id.lookup_items.classification_id.classification;
        baseItems['classification'] =
          baseItems.lookup_items.material_id.lookup_items.classification_id.classification;
        baseItems['type_id'] = baseItems.lookup_items.material_id.lookup_items.type_id.type;
        baseItems['type'] = baseItems.lookup_items.material_id.lookup_items.type_id.type;
        baseItems['item_code'] = baseItems.lookup_items.material_id.item_code;
        baseItems['quantity'] = Number(baseItems['quantity']);
        baseItems['quantity_lower_limit'] = Number(baseItems['quantity_lower_limit']);
        baseItems['quantity_upper_limit'] = Number(baseItems['quantity_upper_limit']);
        baseItems['unit_lower_limit'] = Number(baseItems['unit_lower_limit']);
        baseItems['unit_upper_limit'] = Number(baseItems['unit_upper_limit']);
        if (baseItems.lookup_items.material_id.transfer_unit_price !== undefined) {
          baseItems['reference_transfer_unit_price'] = baseItems.lookup_items.material_id.transfer_unit_price;
        }
        baseItems['tax_classification_id'] = baseItems.lookup_items.tax_classification_id
          ? baseItems.lookup_items.tax_classification_id.i_id
          : this.defaultTaxData.i_id;
        baseItems['tax_classification'] = baseItems.lookup_items.tax_classification_id
          ? baseItems.lookup_items.tax_classification_id.name
          : this.defaultTaxData.name;
        baseItems['tax_rate'] = baseItems.lookup_items.tax_classification_id
          ? baseItems.lookup_items.tax_classification_id.tax_rate
          : this.defaultTaxData.tax_rate;
        // 課税区分編集可否フラグ
        baseItems['tax_classification_edit_flag'] = baseItems.lookup_items.material_id.tax_classification_edit_flag
          ? baseItems.lookup_items.material_id.tax_classification_edit_flag
          : 'true';
        // 振替単価がundefinedの場合は0を設定する
        if (baseItems.transfer_unit_price === undefined) {
          baseItems['transfer_unit_price'] = 0;
        }
        // 計算
        baseItems['sale_price'] = baseItems['standard_unit_price'] * baseItems['quantity'];
        baseItems['transfer_amount_price'] =
          baseItems['transfer_unit_price'] * baseItems['quantity'];
        baseItems['operating_income'] = this.calculationModel.operatingIncome(
          baseItems['sale_price'],
          baseItems['transfer_amount_price']
        );
        baseItems['profit_rate'] = this.calculationModel.profitRate(
          this.calculationModel.operatingIncome(
            baseItems['sale_price'],
            baseItems['transfer_amount_price']
          ),
          baseItems['sale_price'],
          this.defaultRoundingType
        );
        this.partsListBaseData.push(baseItems);
        // 構成明細用登録データの作成
        this.registMaterialItemData.push({
          'operation': 2, // update
          'action_id': 'material_valid_update',
          'link_to_parent': true, // 親Itemとのデータリンクを作成する（双方のリンクが作成される） default: false(親→指定したi_idへのリンクのみ)
          'rev_no': Number(baseItems['rev_no']),
          'i_id': baseItems['i_id'], // 対象アイテムID
          'item': {
            'estimate_id': baseItems['estimate_id'],
            'service_type_id': this.serviceTypeItemId,
            'material_id': baseItems.lookup_items.material_id.i_id,
            'standard_unit_price': Number(baseItems['standard_unit_price']),
            'unit_lower_limit': Number(baseItems['unit_lower_limit']),
            'unit_upper_limit': Number(baseItems['unit_upper_limit']),
            'transfer_unit_price': Number(baseItems['transfer_unit_price']),
            'quantity': Number(baseItems['quantity']),
            'quantity_lower_limit': Number(baseItems['quantity_lower_limit']),
            'quantity_upper_limit': Number(baseItems['quantity_upper_limit']),
            'remarks': baseItems['remarks'],
            'display_order': Number(baseItems['display_order']),
            'tax_classification_id': baseItems['tax_classification_id'],
            'edit_price_flag': baseItems['edit_price_flag'],
            'edit_material_flag': baseItems['edit_material_flag']
          }
        });
        // 登録用データのバックアップを作成
        this.registMaterialItemDataBackup = JSON.parse(JSON.stringify(this.registMaterialItemData));
      }
      // 構成表 構成明細
      let partsListDataParse = this.partsListBaseData.map((list: any) => ({...list}));

      // 明細追加入力一覧の作成
      const detailAddListData = [];
      estimateInformationResult.linked_items['t_datail_add_input'].items.sort(
        (a: any, b: any) => a.display_order - b.display_order
      );

      for (const index in estimateInformationResult.linked_items['t_datail_add_input'].items) {
        const baseItems = estimateInformationResult.linked_items['t_datail_add_input'].items[index];
        baseItems['No'] = Number(index) + 1;
        // lookup_itemsから各データを設定
        baseItems['classification_id'] =
          baseItems.lookup_items.datail_add_input_id.lookup_items.classification_id.classification;
        baseItems['classification'] =
          baseItems.lookup_items.datail_add_input_id.lookup_items.classification_id.classification;
        baseItems['type_id'] = baseItems.lookup_items.datail_add_input_id.lookup_items.type_id.type;
        baseItems['type'] = baseItems.lookup_items.datail_add_input_id.lookup_items.type_id.type;
        baseItems['item_code'] = baseItems.lookup_items.datail_add_input_id.item_code;
        if (baseItems.lookup_items.datail_add_input_id.purchase_unit_price !== undefined) {
          baseItems['reference_purchase_unit_price'] = JSON.parse(
            JSON.stringify(baseItems.lookup_items.datail_add_input_id.purchase_unit_price)
          );
        }
        // 課税区分編集可否フラグ
        baseItems['tax_classification_edit_flag'] = baseItems.lookup_items.datail_add_input_id.tax_classification_edit_flag
          ? baseItems.lookup_items.datail_add_input_id.tax_classification_edit_flag
          : 'true';
        // 計算
        baseItems['sale_price'] = baseItems['standard_unit_price'] * baseItems['quantity'];
        baseItems['purchasing_price'] = baseItems['purchase_unit_price'] * baseItems['quantity'];
        baseItems['operating_income'] = this.calculationModel.operatingIncome(
          baseItems['sale_price'],
          baseItems['purchasing_price']
        );
        baseItems['profit_rate'] = this.calculationModel.profitRate(
          this.calculationModel.operatingIncome(
            baseItems['sale_price'],
            baseItems['purchasing_price']
          ),
          baseItems['sale_price'],
          this.defaultRoundingType
        );
        detailAddListData.push(baseItems);
      }

      // 構成表 明細追加入力
      let detailAddListDataParse = detailAddListData.map((list: any) => ({...list}));

      // 選択された帳票種別を判定
      // 選択された帳票種別からグループ化マスタのデータをAPIから取得
      const ex = optionalOutPutFormPO.find(
        (data: { display_id: string }) => data.display_id === 'issued_date'
      ) as any;
      this.formOutputFieldsData.push(ex);

      // 構成表のグルーピング確認
      if (this.serviceTypeItems.estimate_list_in_parts_list_grouping_flag === 'true') {
        if (this.groupingRule.length > 0) {
          const partsListGroupingData = partsListDataParse;
          this.addGroupId(
            partsListGroupingData,
            this.groupingRule.filter((v:any) => v.item_classification === '構成表')
          );
          partsListDataParse = this.createGroupByGroupId(partsListGroupingData);
        }
      }
      // 見積表内構成表アイテム生成
      for (const index in partsListDataParse) {
        const baseItems = partsListDataParse[
          index
        ];
        baseItems['No'] = Number(index) + 1;
        baseItems['operating_income'] = 0;
        baseItems['profit_rate'] = 0 + "%";
        baseItems['input_flag'] = false;
        baseItems['isDisabledAddButton'] = true;
        baseItems['isDisabledInput'] = true;

        this.detailListData.push(baseItems);
      }

      // 追加明細入力のグルーピング確認
      if (this.serviceTypeItems.estimate_list_in_detail_add_list_grouping_flag === 'true') {
        if (this.groupingRule.length > 0) {
          const detailAddListGroupingData = detailAddListDataParse;
          this.addGroupId(
            detailAddListGroupingData,
            this.groupingRule.filter((v:any) => v.item_classification === '明細追加入力')
          );
          detailAddListDataParse = this.createGroupByGroupId(detailAddListGroupingData);
        }
      }

      // 見積表内追加明細入力アイテム生成
      for (const index in detailAddListDataParse) {
        const baseItems = detailAddListDataParse[
          index
        ];
        baseItems['No'] = Number(index) + Number(partsListDataParse.length) + 1;
        baseItems['operating_income'] = 0;
        baseItems['profit_rate'] = 0 + "%";
        baseItems['input_flag'] = false;
        baseItems['isDisabledAddButton'] = true;
        baseItems['isDisabledInput'] = true;
        // 見積表の単価が販売単価(unit_price)なので追加明細入力の標準単価(standard_unit_price)を転記
        baseItems['unit_price'] = baseItems['standard_unit_price'];
        // 見積表の単価が振替単価(transfer_unit_price)なので追加明細入力の仕入単価(purchase_unit_price)を転記
        baseItems['transfer_unit_price'] =  baseItems['purchase_unit_price'];

        this.detailListData.push(baseItems);
      }

      this.estimateDetailSummaryLength = partsListDataParse.length + detailAddListDataParse.length;

      // チェックボックスの状態に合わせて、
      // 構成表内の各項目で数量がゼロの行を表示・非表示にする
      if (this.checkBoxsStatus === true) {
        this.partsListViewData = this.filterDataItem(
          JSON.parse(JSON.stringify(this.partsListBaseData)),
          'quantity',
          0,
          false
        );
        for (const index in this.partsListViewData) {
          this.partsListViewData[index]['No'] = Number(index) + 1;
        }
      } else {
        this.partsListViewData = JSON.parse(JSON.stringify(this.partsListBaseData));
      }
      this.$set(
        this.estimateTabData[0].configurationTableData.partsList.tableParameters,
        'body',
        this.partsListViewData
      );

      // 明細追加入力マスタのマスタ参照用データ作成
      for (const key in this.masterData['m_datail_add_input'].body) {
        this.mastermEstimateDetailAddInputSelectData.push(
          this.masterData['m_datail_add_input'].body[key]
        );
      }

      // 明細追加入力一覧の作成
      this.estimateInformationResult.linked_items['t_datail_add_input'].items.sort(
        (a: any, b: any) => a.display_order - b.display_order
      );

      for (const index in this.estimateInformationResult.linked_items['t_datail_add_input'].items) {
        const baseItems = this.estimateInformationResult.linked_items['t_datail_add_input'].items[
          index
        ];
        baseItems['No'] = Number(index) + 1;
        // lookup_itemsから各データを設定
        baseItems['classification_id'] =
          baseItems.lookup_items.datail_add_input_id.lookup_items.classification_id.classification;
        baseItems['classification'] =
          baseItems.lookup_items.datail_add_input_id.lookup_items.classification_id.classification;
        baseItems['type_id'] = baseItems.lookup_items.datail_add_input_id.lookup_items.type_id.type;
        baseItems['type'] = baseItems.lookup_items.datail_add_input_id.lookup_items.type_id.type;
        baseItems['item_code'] = baseItems.lookup_items.datail_add_input_id.item_code;
        if (baseItems.lookup_items.datail_add_input_id.purchase_unit_price !== undefined) {
          baseItems['reference_purchase_unit_price'] = JSON.parse(
            JSON.stringify(baseItems.lookup_items.datail_add_input_id.purchase_unit_price)
          );
        }
        // 課税区分編集可否フラグ
        baseItems['tax_classification_edit_flag'] = baseItems.lookup_items.datail_add_input_id.tax_classification_edit_flag
          ? baseItems.lookup_items.datail_add_input_id.tax_classification_edit_flag
          : true;
        baseItems['tax_classification_id'] = baseItems.lookup_items.tax_classification_id
          ? baseItems.lookup_items.tax_classification_id.i_id
          : this.defaultTaxData.i_id;
        baseItems['tax_classification'] = baseItems.lookup_items.tax_classification_id
          ? baseItems.lookup_items.tax_classification_id.name
          : this.defaultTaxData.name;
        baseItems['tax_rate'] = baseItems.lookup_items.tax_classification_id
          ? baseItems.lookup_items.tax_classification_id.tax_rate
          : this.defaultTaxData.tax_rate;

        // 仕入単価がundefinedの場合は0を設定する
        if (baseItems.purchase_unit_price === undefined) {
          baseItems['purchase_unit_price'] = 0;
        }

        // 計算
        baseItems['sale_price'] = baseItems['standard_unit_price'] * baseItems['quantity'];
        baseItems['purchasing_price'] = baseItems['purchase_unit_price'] * baseItems['quantity'];
        baseItems['operating_income'] = this.calculationModel.operatingIncome(
          baseItems['sale_price'],
          baseItems['purchasing_price']
        );
        baseItems['profit_rate'] = this.calculationModel.profitRate(
          this.calculationModel.operatingIncome(
            baseItems['sale_price'],
            baseItems['purchasing_price']
          ),
          baseItems['sale_price'],
          this.defaultRoundingType
        );

        // 文字列となっているので変換
        baseItems['input_flag'] = JSON.parse(
          baseItems['lookup_items']['datail_add_input_id']['input_flag'].toLowerCase()
        );
        this.detailAddListData.push(baseItems);
        // 明細追加入力一覧用登録済データの作成
        this.registDatailAddInputItemData.push({
          'operation': 2, // update
          'action_id': 'datail_add_input_valid_update',
          'link_to_parent': true, // 親Itemとのデータリンクを作成する（双方のリンクが作成される） default: false(親→指定したi_idへのリンクのみ)
          'rev_no': Number(baseItems['rev_no']),
          'i_id': baseItems['i_id'], // 対象アイテムID
          'item': {
            'estimate_id': baseItems['estimate_id'],
            'item': baseItems['item'],
            'datail_add_input_id': baseItems.lookup_items.datail_add_input_id.i_id,
            'standard_unit_price': Number(baseItems['standard_unit_price']),
            'purchase_unit_price': Number(baseItems['purchase_unit_price']),
            'quantity': Number(baseItems['quantity']),
            'remarks': baseItems['remarks'],
            'display_order': Number(baseItems['display_order']),
            'tax_classification_id': baseItems['tax_classification_id']
          }
        });
        // 登録用データのバックアップを作成
        this.registDatailAddInputItemDataBackup = JSON.parse(
          JSON.stringify(this.registDatailAddInputItemData)
        );
      }

      // 明細追加入力トランの情報が0件の場合は明細追加入力一覧に空行を1行追加する
      if (this.detailAddListData.length === 0) {
        const estimateDatailAddInputItem = JSON.parse(
          JSON.stringify(EstimateDatailAddInputBaseFormat)
        );
        estimateDatailAddInputItem['No'] = 1;
        estimateDatailAddInputItem['id'] = 1;
        this.detailAddListData.push(estimateDatailAddInputItem);
        // 明細追加入力一覧用登録データの作成
        this.registDatailAddInputItemData.push({
          item: {
            'item': '',
            'standard_unit_price': 0,
            'purchase_unit_price': 0,
            'quantity': 0,
            'remarks': ''
          }
        });
        // 登録用データのバックアップを作成
        this.registDatailAddInputItemDataBackup = JSON.parse(
          JSON.stringify(this.registDatailAddInputItemData)
        );
      }

      // 見積情報タブ内の見積情報を設定
      switch (this.screenStructureType) {
        case '1': {
          // OAリース
          this.estimateInformationsData = {
            0: this.estimateInformationResult.field_values.estimate_expiration_date.value,
            1: '',
            2: this.estimate.editDatetype(
              this.estimateInformationResult.field_values.estimate_registration_date.value,
              'Asia/Tokyo',
              'yyyy/MM/dd'
            ),
            3: this.estimate.editDatetype(
              this.estimateInformationResult.field_values.estimate_update_date.value,
              'Asia/Tokyo',
              'yyyy/MM/dd'
            ),
            4: '',
            5: '',
            6: '',
            7: '',
            8: ''
          };
          // 見積情報内のリース会社(マスタ参照：料率マスタ)を設定
          for (const key in this.masterData['m_rate'].body) {
            this.mastermEstimateRateData.push(this.masterData['m_rate'].body[key]);
          }
          this.estimateInformationPanel.datas[5].props.columns =
            EstimateMasterDatas.masterRateColumns;
          this.estimateInformationPanel.datas[5].props.body = this.mastermEstimateRateData;
          break;
        }
        case '99': {
          // 汎用
          this.estimateInformationsData = {
            0: this.estimateInformationResult.field_values.estimate_expiration_date.value,
            1: '',
            2: this.estimate.editDatetype(
              this.estimateInformationResult.field_values.estimate_registration_date.value,
              'Asia/Tokyo',
              'yyyy/MM/dd'
            ),
            3: this.estimate.editDatetype(
              this.estimateInformationResult.field_values.estimate_update_date.value,
              'Asia/Tokyo',
              'yyyy/MM/dd'
            ),
            4: ''
          };
          break;
        }
        case '2': {
          // F-Japan
          this.estimateInformationsData = {
            0: this.estimateInformationResult.field_values.estimate_expiration_date.value,
            1: '',
            2: this.estimate.editDatetype(
              this.estimateInformationResult.field_values.estimate_registration_date.value,
              'Asia/Tokyo',
              'yyyy/MM/dd'
            ),
            3: this.estimate.editDatetype(
              this.estimateInformationResult.field_values.estimate_update_date.value,
              'Asia/Tokyo',
              'yyyy/MM/dd'
            ),
            4: ''
          };
          break;
        }
      }
      // 見積ステータス、受注確度の設定
      this.getHeaderData(this.estimateInformationsData, this.estimateInformationPanel);
      this.estimateInformationPanel.datas[1]['props']['displayStatus'] = this.displayStatus;
      const item = this.selectOptions['orderAccuracy'].options.find(
        (recode: any) => {
          if (recode.display_id === this.estimateInformationResult.field_values.order_accuracy.value) {
            return recode;
          }
        }
      );
      // 受注確度が空（初期状態）の場合を考慮し、undefined判定を実施
      if (item !== undefined) this.estimateInformationPanel.datas[4].props.value = item.value;
      this.estimateInformationPanel.datas[4].props.selectData.options = this.selectOptions[
        'orderAccuracy'
      ].options;
      this.$set(
        this.estimateTabData[1].estimateInformationData.estimateDetailInformation,
        'estimateInformationPanel',
        this.estimateInformationPanel
      );
      this.$set(
        this.estimateTabData[1].estimateInformationData.estimateRateData,
        'estimateInformationPanel',
        this.estimateInformationPanel
      );
      this.$set(
        this.estimateTabData[1].estimateInformationData.estimateDetailSummary,
        'estimateDetailSummary',
        this.estimateDetailSummary
      );
      this.$set(
        this.estimateTabData[1].estimateInformationData.createTaxSummary,
        'taxSummaryColumns',
        this.taxSummaryColumns
      );
      switch (this.screenStructureType) {
        case '1': {
          // OAリース
          // リース会社

          // 見積作成の各フィールドへの値格納
          if (this.estimateInformationResult.field_values.leasing_company_id.value !== null) {
            const leasingCompanyId = this.estimateInformationPanel.datas[5].props.body.find(
              (v:any) => v.leasing_company_id ===
              this.estimateInformationResult.field_values.leasing_company_id.value.lookup_item.leasing_company
            );
            this.estimateInformationPanel.datas[5].props.value = leasingCompanyId.i_id;
            this.estimateInformationPanel.datas[6].props.value = this.estimateInformationResult.field_values.contract_months.value;
            this.estimateInformationPanel.datas[7].props.value = this.estimateInformationResult.field_values.rate.value;
            this.estimateInformationPanel.datas[8].props.value = this.estimateInformationResult.field_values.monthly_lease_fee.value;
          } else {
            this.estimateInformationPanel.datas[5].props.value = '';
            this.estimateInformationPanel.datas[6].props.value = '';
            this.estimateInformationPanel.datas[7].props.value = '';
            this.estimateInformationPanel.datas[8].props.value = '';
          }

          // 端数調整実施フラグセット
          if (this.estimateInformationResult.field_values.fraction_rounding_flag.value !== null) {
            // DB値をBoolean値に変換してセット
            this.fractionRoundingFlag = JSON.parse(
              this.estimateInformationResult.field_values.fraction_rounding_flag.value.toLowerCase()
            );
          } else {
            // DB値がnullの場合は初期値falseとし、登録データにもセット
            this.fractionRoundingFlag = false;
            this.registData.item['fraction_rounding_flag'] = this.fractionRoundingFlag.toString();
          }
          break;
        }
      }

      // 課税区分マスタを設定
      for (const key in this.masterData['m_tax'].body) {
        this.masterTaxData.push(this.masterData['m_tax'].body[key]);
      }

      // 見積明細マスタのマスタ参照用データ作成
      for (const key in this.masterData['m_estimate_detail'].body) {
        const type = this.masterData['m_estimate_detail'].body[key].type_id;
        if (type === '端数調整値引') {
          this.mastermEstimateDetailFractionDiscount = this.masterData['m_estimate_detail'].body[key];
        } else if (type === '端数調整増額') {
          this.mastermEstimateDetailFractionIncrease = this.masterData['m_estimate_detail'].body[key];
        } else {
          // 端数調整用明細データ以外をマスタ参照用データとする
          this.mastermEstimateDetailSelectData.push(this.masterData['m_estimate_detail'].body[key]);
        }
      }

      // 見積表の作成
      const estimateNo = this.detailListData.length;
      this.estimateInformationResult.linked_items['t_estimate_detail'].items.sort(
        (a: any, b: any) => a.display_order - b.display_order
      );
      for (const index in this.estimateInformationResult.linked_items['t_estimate_detail'].items) {
        const baseItems = this.estimateInformationResult.linked_items['t_estimate_detail'].items[
          index
        ];
        baseItems['No'] = Number(index) + 1 + estimateNo;
        // lookup_itemsから各データを設定
        baseItems['classification_id'] =
          baseItems.lookup_items.estimate_detail_id.lookup_items.classification_id.classification;
        baseItems['classification'] =
          baseItems.lookup_items.estimate_detail_id.lookup_items.classification_id.classification;
        baseItems['type_id'] = baseItems.lookup_items.estimate_detail_id.lookup_items.type_id.type;
        baseItems['type'] = baseItems.lookup_items.estimate_detail_id.lookup_items.type_id.type;
        baseItems['item_code'] = baseItems.lookup_items.estimate_detail_id.item_code;
        if (baseItems.lookup_items.estimate_detail_id.purchase_unit_price !== undefined) {
          baseItems['reference_purchase_unit_price'] = JSON.parse(
            JSON.stringify(baseItems.lookup_items.estimate_detail_id.purchase_unit_price)
          );
        }
        // 課税区分編集可否フラグ
        baseItems['tax_classification_edit_flag'] = baseItems.lookup_items.estimate_detail_id.tax_classification_edit_flag
          ? baseItems.lookup_items.estimate_detail_id.tax_classification_edit_flag
          : true;
        baseItems['tax_classification_id'] = baseItems.lookup_items.tax_classification_id
          ? baseItems.lookup_items.tax_classification_id.i_id
          : this.defaultTaxData.i_id;
        baseItems['tax_classification'] = baseItems.lookup_items.tax_classification_id
          ? baseItems.lookup_items.tax_classification_id.name
          : this.defaultTaxData.name;
        baseItems['tax_rate'] = baseItems.lookup_items.tax_classification_id
          ? baseItems.lookup_items.tax_classification_id.tax_rate
          : this.defaultTaxData.tax_rate;

        // 仕入単価がundefinedの場合は0を設定する
        if (baseItems.purchase_unit_price === undefined) {
          baseItems['purchase_unit_price'] = 0;
        }

        // 計算
        baseItems['sale_price'] = baseItems['unit_price'] * baseItems['quantity'];
        baseItems['purchasing_price'] = baseItems['purchase_unit_price'] * baseItems['quantity'];
        baseItems['operating_income'] = this.calculationModel.operatingIncome(
          baseItems['sale_price'],
          baseItems['purchasing_price']
        );
        baseItems['profit_rate'] = this.calculationModel.profitRate(
          this.calculationModel.operatingIncome(
            baseItems['sale_price'],
            baseItems['purchasing_price']
          ),
          baseItems['sale_price'],
          this.defaultRoundingType
        );
        // 文字列となっているので変換
        baseItems.input_flag = JSON.parse(
          baseItems['lookup_items']['estimate_detail_id']['input_flag'].toLowerCase()
        );
        this.detailListData.push(baseItems);
        // 見積表用登録データの作成
        this.registEstimateDetailItemData.push({
          'operation': 2, // update
          'action_id': 'estimate_detail_valid_update',
          'link_to_parent': true, // 親Itemとのデータリンクを作成する（双方のリンクが作成される） default: false(親→指定したi_idへのリンクのみ)
          'rev_no': Number(baseItems['rev_no']),
          'i_id': baseItems['i_id'], // 対象アイテムID
          'item': {
            'estimate_id': baseItems['estimate_id'],
            'item': baseItems['item'],
            'estimate_detail_id': baseItems.lookup_items.estimate_detail_id.i_id,
            'unit_price': Number(baseItems['unit_price']),
            'purchase_unit_price': Number(baseItems['purchase_unit_price']),
            'quantity': Number(baseItems['quantity']),
            'remarks': baseItems['remarks'],
            'display_order': Number(baseItems['display_order'])
          }
        });
        // 登録用データのバックアップを作成
        this.registEstimateDetailItemDataBackup = JSON.parse(
          JSON.stringify(this.registEstimateDetailItemData)
        );
      }

      // 見積明細トランの情報が0件の場合は明細追加入力一覧に空行を1行追加する
      if (this.detailListData.length === 0) {
        // 見積表に空行を1行追加する
        const estimateDatailItem = JSON.parse(JSON.stringify(EstimateDatailBaseFormat));
        estimateDatailItem['No'] = 1;
        estimateDatailItem['id'] = 1;
        this.detailListData.push(estimateDatailItem);
        // 見積表用登録データの作成
        this.registEstimateDetailItemData.push({
          item: {
            'item': '',
            'unit_price': 0,
            'purchase_unit_price': 0,
            'quantity': 0,
            'remarks': ''
          }
        });
        // 登録用データのバックアップを作成
        this.registEstimateDetailItemDataBackup = JSON.parse(
          JSON.stringify(this.registEstimateDetailItemData)
        );
      }

      // 見積集計情報パネル
      // 例外リストに営業利益が存在しない場合は見積集計情報パネル内の営業利益合計は表示しない
      this.deletePanelItem(estimateInformationSummary, '営業利益合計', 'transfer_amount_price');
      // 例外リストに利益率が存在しない場合は見積集計情報パネル内の営業利益率は表示しない
      this.deletePanelItem(estimateInformationSummary, '営業利益率', 'profit_rate');
      // 編集した見積集計情報パネルを設定
      // 例外リストに営業利益が存在しない場合は営業利益合計、営業利益率に値をセットしない
      const deletePanelItemIndex = estimateInformationSummary.findIndex(function(recode) {
        if (recode.name == 'transfer_amount_price') {
          return recode;
        }
      });
      const estimateInformationSummaryData =
        deletePanelItemIndex !== -1
          ? {
              0: 0,
              1: 0,
              2: 0,
              3: 0,
              4:
                this.estimateInformationResult.field_values.sales_tax_rate.value !== null
                  ? this.estimateInformationResult.field_values.sales_tax_rate.value
                  : 10,
              5: 0,
              6: 0,
              7: 0,
              8: 0 + '%'
            }
          : {
              0: 0,
              1: 0,
              2: 0,
              3: 0,
              4:
                this.estimateInformationResult.field_values.sales_tax_rate.value !== null
                  ? this.estimateInformationResult.field_values.sales_tax_rate.value
                  : 10,
              5: 0,
              6: 0
            };
      this.estimateInformationSummaryTaxAmount();

      this.getHeaderData(estimateInformationSummaryData, this.estimateInformationSummary);

      // 税率毎のサマリを作成
      if (this.estimateTabData[1].estimateInformationData.estimateDetailList.isEstimateAddItemButtonFlag === false) {
        const mergeDetails = this.estimateTabData[0].configurationTableData.partsList.tableParameters[
          'body'
        ].concat(
          this.estimateTabData[0].configurationTableData.detailAddList.tableParameters['body'],
          this.estimateTabData[1].estimateInformationData.estimateDetailList.tableParameters['body']
        );
        this.taxData = this.createGroupByTaxClassificationId(mergeDetails);
        this.estimateDetailSummary.datas[0].props.value = this.taxData.reduce(
          (previousValue, currentValue) => Number(previousValue) + Number(currentValue.amount),
          0
        );
        this.estimateDetailSummary.datas[1].props.value = this.taxData.reduce(
          (previousValue, currentValue) => Number(previousValue) + Number(currentValue.tax),
          0
        );
        this.estimateDetailSummary.datas[2].props.value =
          this.estimateDetailSummary.datas[0].props.value +
          this.estimateDetailSummary.datas[1].props.value;
        this.$set(
          this.estimateTabData[1].estimateInformationData.createTaxSummary,
          'taxData',
          this.taxData
        );
      } else {
        const mergeDetails = this.estimateTabData[0].configurationTableData.partsList.tableParameters[
          'body'
        ].concat(
          this.estimateTabData[0].configurationTableData.detailAddList.tableParameters['body'],
          this.estimateTabData[1].estimateInformationData.estimateDetailList.tableParameters['body']
        );
        this.taxData = this.createGroupByTaxClassificationId(mergeDetails);
        this.estimateDetailSummary.datas[0].props.value = this.taxData.reduce(
          (previousValue, currentValue) => Number(previousValue) + Number(currentValue.amount),
          0
        );
        this.estimateDetailSummary.datas[1].props.value = this.taxData.reduce(
          (previousValue, currentValue) => Number(previousValue) + Number(currentValue.tax),
          0
        );
        this.estimateDetailSummary.datas[2].props.value =
          this.estimateDetailSummary.datas[0].props.value +
          this.estimateDetailSummary.datas[1].props.value;
        this.$set(
          this.estimateTabData[1].estimateInformationData.createTaxSummary,
          'taxData',
          this.taxData
        );
      }
      // ■上の段
      // ①定価金額（構成表）
      this.estimateInformationSummary.datas[0].props.value = this.estimateInformationSummaryTotalValues(
        'noEstimateDetailList',
        'sale_price'
      );
      this.registData.item[
        'composition_table_list_price_total'
      ] = this.estimateInformationSummary.datas[0].props.value;
      // ③値引額
      // 種別マスタのtypeが「値引」の明細に加え、「端数調整値引」の明細も値引額に合算
      this.estimateInformationSummary.datas[2].props.value =
        this.calculationModel.totalValues([
          {
            tableData: this.estimateTabData[1].estimateInformationData.estimateDetailList
              .tableParameters.body,
            itemName: 'sale_price',
            sumItem: {
              display_id: 'type_id',
              targetName: '値引'
            }
          }
        ]) +
        this.calculationModel.totalValues([
          {
            tableData: this.estimateTabData[1].estimateInformationData.estimateDetailList
              .tableParameters.body,
            itemName: 'sale_price',
            sumItem: {
              display_id: 'type_id',
              targetName: '端数調整値引'
            }
          }
        ]);
      this.estimateInformationSummary.datas[2].show = false;
      // ②小計(構成表＋見積明細)※元の見積合計金額
      this.estimateInformationSummary.datas[1].props.value =
        this.estimateInformationSummaryTotalValues('', 'sale_price') -
        this.estimateInformationSummary.datas[2].props.value;
      this.registData.item['total_sales_amount'] = this.estimateDetailSummary.datas[0].props.value;
      this.registData.item[
        'discount_amount'
      ] = this.estimateInformationSummary.datas[2].props.value;
      this.estimateInformationSummary.datas[1].show = false;
      // ④見積合計金額(税別)
      this.estimateInformationSummary.datas[3].props.value =
        this.estimateInformationSummary.datas[1].props.value +
        this.estimateInformationSummary.datas[2].props.value;
      this.registData.item[
        'estimated_tax_excluded'
      ] = this.estimateInformationSummary.datas[3].props.value;
      // ■下の段
      // ⑤消費税率、⑥消費税額、⑦合計金額(税込)
      this.estimateInformationSummaryTaxAmount();
      this.registData.item['sales_tax_rate'] = Number(
        this.estimateInformationSummary.datas[4].props.value
      );
      this.registData.item['consumption_tax'] = this.estimateDetailSummary.datas[1].props.value;
      this.registData.item['total_tax_included'] = this.estimateDetailSummary.datas[2].props.value;
      this.estimateInformationSummary.datas[4].show = false;
      // ⑧営業利益合計
      // 営業利益合計(例外リストに存在し、項目が表示されてる場合は計算する)
      if (this.exceptionHeaderItem.includes('transfer_amount_price')) {
        this.estimateInformationSummary.datas[7].props.value = this.estimateInformationSummaryTotalValues(
          '',
          'operating_income'
        );
        this.registData.item[
          'total_operating_profit'
        ] = this.estimateInformationSummary.datas[7].props.value;
      }
      // ⑨営業利益率
      // 営業利益率(例外リストに存在し、項目が表示されてる場合は計算する)
      if (this.exceptionHeaderItem.includes('profit_rate')) {
        this.estimateInformationSummary.datas[8].props.value = this.operatingProfitMargin();
        const strIndex = this.estimateInformationSummary.datas[8].props.value.indexOf('%');
        const str = this.estimateInformationSummary.datas[8].props.value.substring(0, strIndex);
        this.registData.item['operating_profit_margin'] = Number(str);
      }
      // 月額リース料の計算
      switch (this.screenStructureType) {
        case '1': {
          // OAリース
          if (this.fractionRoundingFlag || this.isEstimateConfirmed) {
            // 端数処理実施済みまたは見積確定ステータスであれば計算しない
            this.registData.item['monthly_lease_fee'] = Number(
              this.estimateInformationPanel.datas[8].props.value
            );
            this.fractionValue = 0;
          } else {
            // 端数処理未実施であれば計算
            if (this.estimateDetailSummary.datas[0].props.value !== 0) {
              const rateItem = this.estimateInformationPanel.datas[7].props.value;
              if (rateItem !== undefined) {
                const cost = this.calculationModel.monthlyLeaseCost(
                  this.estimateDetailSummary.datas[0].props.value,
                  rateItem
                );
                this.estimateInformationPanel.datas[8].props.value = cost;
                this.fractionValue = this.calculationModel.fractionProcess(cost);
              }
              this.registData.item['monthly_lease_fee'] = Number(
                this.estimateInformationPanel.datas[8].props.value
              );
              // ※初期表示時は事前与信との比較を行わない
            }
          }
          break;
        }
      }
    } catch (e) {
      console.log(e);
      // エラーをキャッチした際共通エラーダイアログにセット
      if (e instanceof Error) {
        this.setError(e.message);
      } else if (typeof e === 'string') {
        this.setError(e);
      }
    } finally {
      this.$store.commit('hexabase/setIsLoading', false);
      // 初期表示で「編集する」ボタン押下時の画面表示にするかappState値で判定
      // ※事前与信チェックダイアログで「キャンセル」が押下された場合
      if (appState.options['初期表示切替']['見積詳細']['edit_initial_view'] > 0) {
        // 該当appState値を初期値0に戻す
        const options = appState.getOptions;
        options['初期表示切替']['見積詳細']['edit_initial_view'] = 0;
        appState.setOptions(options);

        this.buttonAction('estimate_basic_info_OA_registering_update');
      }
    }
  }

  /**
   * 例外リストに指定された項目名が存在しない場合は指定されたパネル内項目を削除する
   * @module deletePanelItem
   * @param {panelItemList} - パネル内項目情報
   * @param {deleteItemName} - 指定されたパネル内項目名
   * @param {exceptionHeaderItemName} - 指定された項目名
   */
  private deletePanelItem(
    panelItemList: FieldChildrenProp[],
    deleteItemName: string,
    exceptionHeaderItemName: string
  ) {
    const deletePanelItemIndex = panelItemList.findIndex(function(recode) {
      if (recode.name == deleteItemName) {
        return recode;
      }
    });
    if (deletePanelItemIndex !== -1) {
      if (!this.exceptionHeaderItem.includes(exceptionHeaderItemName)) {
        panelItemList.splice(deletePanelItemIndex, 1);
      }
    }
  }

  /**
   * フィールド情報を取得して、指定の場所に設定する
   * @module setHeaderListColumn
   */
  private setHeaderListColumn(
    inputFields: any,
    baseListColumn: any,
    setItem: any,
    setArea: string,
    exceptionColumnItem: Array<string> = []
  ) {
    const listColumn = JSON.parse(JSON.stringify(baseListColumn));
    // header内容の書き換え
    this.listHeaderCreate(inputFields, listColumn, exceptionColumnItem);
    this.$set(setItem, setArea, listColumn);
  }

  /**
   * フィールド情報とカラム情報を突き合わせて、不要なカラムを削除
   * @module listHeaderCreate
   */
  private listHeaderCreate(
    listInputField: any,
    listColumn: any,
    exceptionColumnItem: any = []
  ): any {
    const noHeaderName: any = [];
    for (const index in listColumn) {
      const searchItem: any = listColumn[index];
      let setHeaderItem: any;
      Object.keys(listInputField.fields).forEach(key => {
        // 振替・仕入単位の項目がある場合に合計となる振替・仕入金額(参照用も含む)、、営業利益、利益率を表示する為、
        // 例外リスト表示項目を追加する際に追加済のチェックを行い、存在しない場合は追加する
        if ('transfer_unit_price' === listInputField.fields[key].display_id) {
          if (!exceptionColumnItem.includes('reference_transfer_unit_price')) {
            exceptionColumnItem.push('reference_transfer_unit_price');
          }
          if (!exceptionColumnItem.includes('transfer_amount_price')) {
            exceptionColumnItem.push('transfer_amount_price');
          }
          if (!exceptionColumnItem.includes('operating_income')) {
            exceptionColumnItem.push('operating_income');
          }
          if (!exceptionColumnItem.includes('profit_rate')) {
            exceptionColumnItem.push('profit_rate');
          }
        } else if ('purchase_unit_price' === listInputField.fields[key].display_id) {
          if (!exceptionColumnItem.includes('reference_purchase_unit_price')) {
            exceptionColumnItem.push('reference_purchase_unit_price');
          }
          if (!exceptionColumnItem.includes('purchasing_price')) {
            exceptionColumnItem.push('purchasing_price');
          }
          if (!exceptionColumnItem.includes('operating_income')) {
            exceptionColumnItem.push('operating_income');
          }
          if (!exceptionColumnItem.includes('profit_rate')) {
            exceptionColumnItem.push('profit_rate');
          }
        }

        if (listInputField.fields[key].display_id === listColumn[index].value) {
          setHeaderItem = listColumn[index];
          return;
        }
      });

      if (setHeaderItem === undefined) {
        // トランやマスタに入っていない
        const exceptionItem = exceptionColumnItem.find(function(item: any) {
          if (searchItem.value === item) {
            return item;
          }
        });

        if (exceptionItem === undefined) {
          noHeaderName.push(listColumn[index].value);
        }
      }
    }
    for (const index in noHeaderName) {
      const searchIndex = listColumn.findIndex(function(item: any) {
        if (item.value === noHeaderName[index]) {
          return item;
        }
      });
      if (searchIndex !== -1) {
        listColumn.splice(searchIndex, 1);
      }
    }
    return noHeaderName;
  }

  inputCheckItem(data: any, flag: boolean) {
    for (const index in data) {
      data[index].props.isReadonly = flag;
      data[index].props.isDisabled = flag;
      if (data[index].component === 'DatePickerArea' || data[index].component === 'SelectArea') {
        data[index].props.isDisabled = flag;
      } else if (data[index].component === 'MasterSelectMultiSetControl') {
        data[index].props.isBtnVisible = flag === true ? false : true;
      }
    }
  }

  /**
   * 見積コピーで関連データを登録用に加工
   * @module modifyDetailItems
   * @param {linkedData} - 関連データ
   * @param {crudType} - ステータスのcrudType
   * @return {array} - 登録用に整形したデータ
   */
  modifyDetailItems(
    linkedData: { [k: string]: any },
    crudType?: string,
    deleteEstimateIdCheckFlag?: boolean
  ) {
    if (deleteEstimateIdCheckFlag === true) {
      for (const index in linkedData.items) {
        linkedData.items[index]['estimate_id'] = '';
      }
    }
    const result: { [k: string]: Array<{ [k: string]: any }> } = {};
    if (linkedData['d_id'] === undefined) return {};
    result[linkedData['d_id']] = [];
    const items: Array<{ [k: string]: any }> = linkedData.items;
    items.forEach((element, index) => {
      if (element.lookup_items !== undefined) {
        Object.keys(element.lookup_items).forEach(db => {
          if (element[db] !== undefined) {
            element[db] = element.lookup_items[db].i_id;
          }
        });
      }
      const itemId = element.i_id;
      const revNo = Number(element.rev_no);
      switch (crudType) {
        case '4': {
          Object.entries(element).forEach(([key, value]) => {
            const fieldInfo: { [k: string]: string } = linkedData.fields[key];
            if (fieldInfo !== undefined && linkedData.fields[key].dataType !== 'autonum') {
              if (result[linkedData['d_id']][index] === undefined) {
                const initial: { [k: string]: any } = {
                  operation: 1,
                  item: {}
                };
                initial.item[fieldInfo['display_id']] =
                  linkedData.fields[key].dataType === 'number' ? Number(value) : value;
                result[linkedData['d_id']].push(initial);
              } else {
                result[linkedData['d_id']][index]['item'][fieldInfo['display_id']] =
                  linkedData.fields[key].dataType === 'number' ? Number(value) : value;
              }
            }
          });
          break;
        }
        default: {
          Object.entries(element).forEach(([key, value]) => {
            const fieldInfo: { [k: string]: string } = linkedData.fields[key];
            if (fieldInfo !== undefined && linkedData.fields[key].dataType !== 'autonum') {
              if (result[linkedData['d_id']][index] === undefined) {
                const initial: { [k: string]: any } = {
                  operation: 2,
                  i_id: itemId,
                  rev_no: revNo,
                  item: {}
                };
                initial.item[fieldInfo['display_id']] =
                  linkedData.fields[key].dataType === 'number' ? Number(value) : value;
                result[linkedData['d_id']].push(initial);
              } else {
                result[linkedData['d_id']][index]['item'][fieldInfo['display_id']] =
                  linkedData.fields[key].dataType === 'number' ? Number(value) : value;
              }
            }
          });
          result[linkedData['d_id']][index].i_id = element.i_id;
          result[linkedData['d_id']][index].rev_no = Number(element.rev_no);
        }
      }
    });
    return result;
  }

  /**
   * ルーター設定ファイルよりパンくずリスト取得
   * @module getBreadCrumbs
   * @return {array} - breadcrumbs 情報
   */
  private getBreadCrumbs(): [] {
    if (this.$route.matched.some(obj => obj.meta.breadcrumbs)) {
      return this.$route.meta.breadcrumbs;
    }
    return [];
  }

  /**
   * inputFieldsで入力項目の状態を変更
   * @module inputFieldChange
   * @param {itemDatas} - 項目情報
   * @param {inputFields} - フィールド情報
   */
  private async inputFieldChange(
    itemDatas: any,
    inputFields: GetInputFieldsActons,
    checkIsShowOnly?: boolean
  ) {
    const fieldItems: any = [];
    for (const index in inputFields.action_fields) {
      for (const indexB in itemDatas) {
        if (inputFields.action_fields[index].display_id === itemDatas[indexB].display_id) {
          Object.keys(inputFields.action_field_settings).forEach(key => {
            if (
              inputFields.action_field_settings[key].field_id ===
              inputFields.action_fields[index].field_id
            ) {
              fieldItems.push({
                action_field_settings: inputFields.action_field_settings[key],
                action_fields: inputFields.action_fields[index]
              });
            }
          });
        }
      }
    }

    for (const index in fieldItems) {
      itemDatas.find((recode: any) => {
        if (fieldItems[index].action_fields.display_id === recode.display_id) {
          if (
            fieldItems[index].action_field_settings.show !== null ||
            fieldItems[index].action_field_settings.show !== undefined
          ) {
            recode.show = fieldItems[index].action_field_settings.show;
          }
          if (checkIsShowOnly !== true) {
            if (fieldItems[index].action_field_settings.mandatory === true) {
              recode.props.rules = 'required';
            }
          }
          if (
            fieldItems[index].action_field_settings.update !== null ||
            fieldItems[index].action_field_settings.update !== undefined
          ) {
            recode.props.isReadonly =
              fieldItems[index].action_field_settings.update === true ? false : true;
            recode.props.isDisabled =
              fieldItems[index].action_field_settings.update === true ? false : true;
          }
          if (recode.component === 'DatePickerArea' || recode.component === 'SelectArea') {
            recode.props.isDisabled =
              fieldItems[index].action_field_settings.update === true ? false : true;
          } else if (recode.component === 'MasterSelectMultiSetControl') {
            recode.props.isBtnVisible = fieldItems[index].action_field_settings.update;
          }
        }
        if (recode.component === 'Button') {
          if (this.btnDisabledStatus.includes(this.estimateInformationResult.field_values.Status.value)) {
            recode.props.isDisabled = true;
          } else {
            recode.props.isDisabled =
            fieldItems[index].action_field_settings.update === true ? true : false;
          }
        }
      });
    }
    this.estimateInformationSummary.datas[1].show = false;
    this.estimateInformationSummary.datas[2].show = false;
    this.estimateInformationSummary.datas[4].show = false;

    // 表示項目をフィルタする
    const showField = itemDatas.filter((field: any) => field.show === true);
    // 表示項目のデータが持つ行番号を控える
    const rowGroupArray = [];
    for (const key in showField) {
      rowGroupArray.push(showField[key].row);
    }
    const rowGroupRecord: Array<any> = [];
    Array.from(new Set(rowGroupArray)).forEach(function(element, index) {
      rowGroupRecord[index] = showField.filter((field: any) => field.row === element);
    });
    for (const row in rowGroupRecord) {
      // col順でソートする
      rowGroupRecord[row].sort(function(a: any, b: any) {
        return a.col - b.col;
      });
      let previousCol = 0;
      let previousSizeX = 0;
      for (const key in rowGroupRecord[row]) {
        // 前項目のcol+sizeXの値が現在のcolと等しくない場合は、col+sizeXの値に変更する
        if (previousCol + previousSizeX !== rowGroupRecord[row][key].col) {
          rowGroupRecord[row][key].col = previousCol + previousSizeX;
        }
        previousCol = rowGroupRecord[row][key].col;
        previousSizeX = rowGroupRecord[row][key].sizeX;
      }
    }
  }

  private optionItemDataSearch(itemDatas: any, searchString: string) {
    const searchItem = itemDatas.find(function(item: any) {
      if (searchString === item.display_id) {
        return item;
      }
    });
    return searchItem;
  }

  /**
   * アクションパネルのボタンを押下した際の次処理を進める
   * @param {string} - イベント情報として押下したボタン種類が返ってくる
   */
  private async buttonAction(type: any) {
    try {
      // 全要素ReadOnlyアクションか判定
      const isReadOnly = estimateApplyAbove.includes(type);
      const targetButton = this.statusButton.find(v => v.display_id === type);
      this.buttonCrudType = targetButton!.crud_type;
      this.estimateTabData[0].configurationTableData.partsList.tableParameters.isDisabledFormOutputButton = true;
      this.estimateTabData[1].estimateInformationData.estimateDetailList.tableParameters.isDisabledFormOutputButton = true;

      // 関連データも登録する場合使用する
      // this.registData.related_ds_items = this.modifyDetailItems(this.basicResult.linked_items[this.relatedDsId], crudType);

      const setDiseble = this.mtempleteSelectDataOption.length <= 0 ? true : false;

      // ローディングをセット
      this.$store.commit('hexabase/setIsLoading', true);

      // アクション毎の見出し要素入力制限反映
      const copy = this.estimate.modifyButtonProp(this.execAllowActions, type);
      if (copy !== undefined && copy.length > 0) {
        this.execAllowActions.splice(0, copy.length, ...copy);
      }
      const execAction = this.execAllowActions.find(action => action.display_id === type);
      if (execAction !== undefined) {
        this.selectActionDisplayId = type;
        if (execAction.action_name === '料率変更する') {
          this.estimateTabData[1].estimateInformationData.isEstimateFixedDisabled = true;
          // 「料率変更する」アクションフラグを立てる
          this.isRateUpadateAction = true;
        }
        if (execAction.action_name === '編集する') {
          this.estimateTabData[1].estimateInformationData.isEstimateFixedDisabled = true;
          this.editMode = true;
          // 編集可・不可フラグ(edit_material_flag)のチェック
          for (const index in this.estimateTabData[0].configurationTableData.partsList.tableParameters.body) {
            this.estimateTabData[0].configurationTableData.partsList.tableParameters.body[index]['edit_material_flag']
              = this.registMaterialItemData[index].item['edit_material_flag'].toLowerCase() === 'true' ? true : false;
            this.estimateTabData[0].configurationTableData.partsList.tableParameters.body[index]['buttonDisabled']
              = this.registMaterialItemData[index].item['edit_material_flag'].toLowerCase() === 'true' ? false : true;

            this.estimateTabData[0].configurationTableData.partsList.tableParameters.body[index]['edit_price_flag']
              = this.registMaterialItemData[index].item['edit_price_flag'].toLowerCase() === 'true' ? true : false;
          }
        }
        this.selectAction = execAction.display_id;
        this.styleData = this.setStyleData;
        if (!isReadOnly) {
          // 編集するの場合は入力可能項目を表示
          // 見積基本情報OAまたは見積基本情報汎用トランの必須入力チェック
          // 構成表一覧の入力項目フォーマット
          const partsListInputFormat = EstimateListDisplayInputFormatItemsPartsList;
          // 明細追加入力一覧の入力項目フォーマット
          const detailAddListInputFormat = EstimateListDisplayInputFormatItemsDetailAddList;
          // 見積明細一覧の入力項目フォーマット
          const estimateDatailListInputFormat = EstimateListDisplayInputFormatItemsEstimateDetailList;

          const initialAction = this.estimate.getFormDisplayAction(this.statusAction, type);
          const response = await Promise.all([
            this.estimate
              .getFieldsByActionId(this.estimateDsId, initialAction!.action_id)
              .then(response => {
                const inputFields = response;
                this.setRegistFieldType(inputFields, this.registFieldType);
                this.inputFieldChange(this.estimateHeaderData.datas, inputFields);
                this.inputFieldChange(this.estimateSubjectData.datas, inputFields);
                this.inputFieldChange(this.estimateInformationPanel.datas, inputFields);
                this.inputFieldChange(this.estimateInformationSummary.datas, inputFields);
                // 商材マスタの必須入力チェック
                for (const index in inputFields.action_fields) {
                  if (inputFields.action_fields[index].display_id === 'commodity_id') {
                    Object.keys(inputFields.action_field_settings).forEach(key => {
                      if (
                        inputFields.action_field_settings[key].field_id ===
                        inputFields.action_fields[index].field_id
                      ) {
                        if (
                          inputFields.action_field_settings[key].show !== null ||
                          inputFields.action_field_settings[key].show !== undefined
                        ) {
                          this.$set(
                            this.estimateTabData[0].configurationTableData
                              .masterSelectDataCommodity,
                            'isShow',
                            inputFields.action_field_settings[key].show
                          );
                        }
                        if (
                          inputFields.action_field_settings[key].update !== null ||
                          inputFields.action_field_settings[key].update !== undefined
                        ) {
                          this.$set(
                            this.estimateTabData[0].configurationTableData
                              .masterSelectDataCommodity,
                            'isBtnVisible',
                            inputFields.action_field_settings[key].update
                          );
                        }
                        if (
                          inputFields.action_field_settings[key].mandatory !== null ||
                          inputFields.action_field_settings[key].mandatory !== undefined
                        ) {
                          if (inputFields.action_field_settings[key].mandatory === true) {
                            this.commodityRules = 'required';
                            this.$set(
                              this.estimateTabData[0].configurationTableData
                                .masterSelectDataCommodity,
                              'rules',
                              this.commodityRules
                            );
                          }
                        }
                      }
                    });
                  }
                }
                return response;
              }),
            this.estimate
              .getNewActionList(hexabaseState.datastoreIds['構成表'])
              .then(response => {
                const actionItem = response.actions.find(function(recode: any) {
                  // 見積の新規登録画面では各一覧(構成表、見積明細、明細追加入力)の
                  // アイテムアクションから「登録する(register)」を参照アクションとする
                  if ('register' === recode.display_id) {
                    return recode;
                  }
                });
                this.estimate.getFieldsByActionId(
                  hexabaseState.datastoreIds['構成表'],
                  actionItem!.action_id
                );
                return response;
              })
              .then(response => {
                this.listInputFieldRuleCheck(partsListInputFormat, response);
                this.setRegistFieldType(response, this.registPartsListFieldType);
                this.estimateTabData[0].configurationTableData.partsList.tableParameters.buttonItems = EstimateListDisplayButtonItems;
                this.estimateTabData[0].configurationTableData.partsList.tableParameters.inputItems = partsListInputFormat;
                this.estimateTabData[0].configurationTableData.partsList.tableParameters.isDisabledNoteEdit = false;
                return response;
              }),
            this.estimate
              .getNewActionList(hexabaseState.datastoreIds['明細追加入力'])
              .then(response => {
                const actionItem = response.actions.find(function(recode: any) {
                  // 見積の新規登録画面では各一覧(構成表、見積明細、明細追加入力)の
                  // アイテムアクションから「登録する(register)」を参照アクションとする
                  if ('register' === recode.display_id) {
                    return recode;
                  }
                });
                this.estimate.getFieldsByActionId(
                  hexabaseState.datastoreIds['明細追加入力'],
                  actionItem!.action_id
                );
                return response;
              })
              .then(response => {
                this.listInputFieldRuleCheck(detailAddListInputFormat, response);
                this.setRegistFieldType(response, this.registDetailAddListCFieldType);
                this.estimateTabData[0].configurationTableData.detailAddList.tableParameters.buttonItems = EstimateListDisplayButtonItems;
                this.estimateTabData[0].configurationTableData.detailAddList.tableParameters.inputItems = detailAddListInputFormat;
                this.estimateTabData[0].configurationTableData.detailAddList.tableParameters.isDisabledNoteEdit = false;
                this.estimateTabData[0].configurationTableData.detailAddList.tableParameters.isDisabledAddItemButtonFlag = false;
                return response;
              }),
            this.estimate
              .getNewActionList(hexabaseState.datastoreIds['見積明細'])
              .then(response => {
                const actionItem = response.actions.find(function(recode: any) {
                  // 見積の新規登録画面では各一覧(構成表、見積明細、明細追加入力)の
                  // アイテムアクションから「登録する(register)」を参照アクションとする
                  if ('register' === recode.display_id) {
                    return recode;
                  }
                });
                this.estimate.getFieldsByActionId(
                  hexabaseState.datastoreIds['見積明細'],
                  actionItem!.action_id
                );
                return response;
              })
              .then(response => {
                this.listInputFieldRuleCheck(estimateDatailListInputFormat, response);
                this.setRegistFieldType(response, this.registEstimateDetailListFieldType);
                this.estimateTabData[1].estimateInformationData.estimateDetailList.tableParameters.buttonItems = EstimateListDisplayButtonItems;
                this.estimateTabData[1].estimateInformationData.estimateDetailList.tableParameters.inputItems = estimateDatailListInputFormat;
                this.estimateTabData[1].estimateInformationData.estimateDetailList.tableParameters.isDisabledNoteEdit = false;
                this.estimateTabData[1].estimateInformationData.estimateDetailList.tableParameters.isDisabledAddItemButtonFlag = false;
                return response;
              }),
            // ボックスをを活性
            this.$set(
              this.estimateTabData[0].configurationTableData.vmSelectDataTemplete,
              'isDisabled',
              setDiseble
            )
          ]);
          // 画面項目制御
          switch (this.screenStructureType) {
            case '1':
              // OAリース
              if (execAction.action_name === '編集する') {
                if (this.fractionRoundingFlag) {
                  // 端数調整済みであれば端数調整解除ボタンの有効化
                  this.estimateTabData[1].estimateInformationData.estimateRateData.isUndoFractionRoundingDisabled = false;
                  // 金額変更項目の無効化
                  this.disableAmountChange();
                } else {
                  // 端数調整未実施であれば端数調整ボタンの有効化
                  this.estimateTabData[1].estimateInformationData.estimateRateData.isFractionRoundingDisabled = false;
                }
              } else if (this.isRateUpadateAction) {
                // 金額調整ボタンの有効化
                this.estimateTabData[1].estimateInformationData.estimateRateData.isRecalcDisabled = false;
                // 料率以外の金額変更項目の無効化
                this.enableAmountChangeRateOnly();
              }
              break;
            case '2':
            case '99':
            default:
              break;
          }
        }
      }
    } catch (error) {
      if (error instanceof Error) {
        this.setError(error.message);
      } else if (typeof error === 'string') {
        this.setError(error);
      }
    } finally {
      this.statusButton = [
        ...this.estimate.statusButtonList(this.execAllowActions, this.currentData, type)
      ];
      this.$store.commit('hexabase/setIsLoading', false);
    }
  }

  private setRegistFieldType(inputFields: ApiData, registFieldType: any) {
    for (const key in inputFields.action_fields) {
      registFieldType[inputFields.action_fields[key].display_id] =
        inputFields.action_fields[key].dataType;
    }
  }

  /**
   * 新規作成アクションメニュー一覧を取得して、ルール追加を行う
   * @module listInputFieldRuleCheck
   * @param {dbName} - 取得先のDB名
   * @param {setFormatData} - 一覧内入力フォーマット情報
   */
  private async setListInputFormat(
    dbName: string,
    setFormatData: Array<{ [k: string]: string | number | boolean | Array<string> }>
  ) {
    const actionList = await this.estimate.getNewActionList(dbName);
    const actionItem = actionList.actions.find(function(recode: any) {
      // 見積の新規登録画面では各一覧(構成表、見積明細、明細追加入力)の
      // アイテムアクションから「登録する(register)」を参照アクションとする
      if ('register' === recode.display_id) {
        return recode;
      }
    });
    const inputFields = await this.estimate.getFieldsByActionId(dbName, actionItem!.action_id);
    this.listInputFieldRuleCheck(setFormatData, inputFields);
    return inputFields;
  }

  /**
   * 一覧内入力フォーマットにルール追加
   * @module listInputFieldRuleCheck
   * @param {setFormatData} - 一覧内入力フォーマット情報
   * @param {inputFields} - フィールド情報
   */
  private listInputFieldRuleCheck(
    setFormatData: Array<{ [k: string]: any }>,
    inputFields: ApiData
  ) {
    for (const index in inputFields.action_fields) {
      for (const indexB in setFormatData) {
        if (inputFields.action_fields[index].display_id === setFormatData[indexB].name) {
          if (inputFields.action_field_settings[index].mandatory === true) {
            setFormatData[indexB].rules.push('table_input_item_required');
          }
        }
      }
    }
  }

  /**
   * アクションパネルのボタンを押下した際の次処理を進める
   * @param {string} - イベント情報として押下したボタン種類が返ってくる
   */
  private async execAction(type: string) {
    switch (type) {
      case 'cancel': {
        this.$router.go(0);
        break;
      }
      case 'exec': {
        // 「料率変更する」アクションで料率変更後に金額調整を行っていない場合はアラート表示
        if (this.isRateUpadateAction && this.rateChangeFlag) {
          this.alertDialogMessage = EstimateFractionRoundWording.alertNoRecalc.message;
          this.alertDialogTitle = EstimateFractionRoundWording.alertNoRecalc.title;
          this.isAlertDialog = true;
          break;
        }
        // CrudTypeが2の場合で「編集する」のステータスアクションで端数がある場合はワーニング表示
        const checkDeleteActionId = EstimateDeleteActionId.includes(this.selectAction);
        const isReadOnly = estimateApplyAbove.includes(this.selectAction);
        if (
          this.fractionValue !== 0 &&
          this.buttonCrudType === '2' &&
          checkDeleteActionId === false &&
          isReadOnly === false
        ) {
          this.isExecDialog = true;
          this.execActionType = type;
        } else {
          try {
            // ローディングをセット
            this.$store.commit('hexabase/setIsLoading', true);
            this.editText = '';

            if (!isReadOnly) {
              // 編集するの場合は登録データを作成
              this.addRelatedDsItem(
                '構成表',
                this.registMaterialItemData,
                ['standard_unit_price', 'transfer_unit_price', 'quantity'],
                'material_id',
                this.registMaterialItemDeleteData,
                this.registMaterialItemDataBackup
              );
              this.addRelatedDsItem(
                '明細追加入力',
                this.registDatailAddInputItemData,
                ['standard_unit_price', 'purchase_unit_price', 'quantity'],
                'datail_add_input_id',
                this.registDatailAddInputItemDeleteData,
                this.registDatailAddInputItemDataBackup
              );
              this.addRelatedDsItem(
                '見積明細',
                this.registEstimateDetailItemData,
                ['unit_price', 'purchase_unit_price', 'quantity'],
                'estimate_detail_id',
                this.registEstimateDetailItemDeleteData,
                this.registEstimateDetailItemDataBackup
              );

              if (
                JSON.stringify(this.registDataBackup.item) === JSON.stringify(this.registData.item)
              ) {
                this.registData.item = {};
              }
            }

            const deleteAction = EstimateDeleteActionId.includes(this.selectAction);
            if (deleteAction) {
              // コピー元の案件基本情報とコピーして新規登録する見積基本情報(OA・汎用)を関連付ける
              this.registData['related_ds_items'][this.matterServiceDsId] = [
                {
                  'operation': 12,
                  'rev_no': this.revNumber,
                  'i_id': this.projectServiceItemId
                }
              ];
            }

            if (this.buttonCrudType === '4') {
              // 登録中から一時保存中に変更する
              this.registData['action_id'] = 'temporarily_save';
              // 関連データも登録する場合使用する
              this.registData.related_ds_items = Object.assign(
                this.modifyDetailItems(
                  this.estimateInformationResult.linked_items['t_material'],
                  this.buttonCrudType,
                  true
                ),
                this.modifyDetailItems(
                  this.estimateInformationResult.linked_items['t_datail_add_input'],
                  this.buttonCrudType,
                  true
                ),
                this.modifyDetailItems(
                  this.estimateInformationResult.linked_items['t_estimate_detail'],
                  this.buttonCrudType,
                  true
                )
              );
              // コピー元の案件基本情報とコピーして新規登録する見積基本情報(OA・汎用)を関連付ける
              this.registData['related_ds_items'][this.matterServiceDsId] = [
                {
                  'operation': 11,
                  'link_to_parent': true,
                  'i_id': this.projectServiceItemId
                }
              ];

              // 見積番号(見積ID)は空白にする(関連データの見積番号(見積ID)はmodifyDetailItemsで確認)
              this.registData.item['estimate_id'] = '';
              this.registData.item['id'] = '';
            }
            // 見積確定を解除するアクションだった場合の特殊処理
            const estimateConfirmedCancelAction = (() => {
              switch (this.screenStructureType) {
                case '1':
                  return 'estimate_basic_info_OA_estimate_confirmed_cancel';
                case '99':
                  return 'estimate_basic_info_general_estimate_confirmed_cancel';
                case '2':
                  return 'estimate_basic_info_fjapan_estimate_confirmed_cancel';
                default:
              }
            })();

            // const estimateConfirmedCancelAction =
            //   this.screenStructureType === '1'
            //     ? 'estimate_basic_info_OA_estimate_confirmed_cancel'
            //     : 'estimate_basic_info_general_estimate_confirmed_cancel';

            let response:any = {}
            if (this.selectAction === estimateConfirmedCancelAction) {
              // サービス別テーブルのrev_no確認のためAPI実行
              const matterServiceInformationResult = await this.estimate.getLinkedItems(
                hexabaseState.applicationId,
                this.matterServiceDsId,
                this.projectServiceItemId,
                '&use_display_id=true'
              );
              this.registData['related_ds_items'][this.matterServiceDsId] = [
                {
                  'operation': 2,
                  'i_id': this.projectServiceItemId,
                  'rev_no': matterServiceInformationResult.rev_no,
                  'item': this.screenStructureType === '1'
                      ? {
                          'final_estimate_id': '',
                          'final_commodity_id': '',
                          'final_monthly_lease_fee': null,
                          'final_rate': null,
                          'final_contract_months': null,
                          'final_total_sales_amount': null,
                          'final_consumption_tax': null,
                          'final_total_tax_included': null
                        }
                      : {
                          'final_estimate_id': '',
                          'final_commodity_id': '',
                          'final_total_sales_amount': null,
                          'final_consumption_tax': null,
                          'final_total_tax_included': null
                        }
                }
              ];

              // 見積確定の解除で案件基本情報と該当するサービス種別の見積基本情報の見積確定に関する情報を初期化し、
              // 該当するサービス種別の見積基本情報のステータスを更新
              const [matterInformationResult, execStatusActionResult] = await await Promise.all([
                this.estimate.updateItems(
                  hexabaseState.applicationId,
                  hexabaseState.datastoreIds['案件基本情報'],
                  matterServiceInformationResult.linked_items.t_project_basic_infomation.items[0].i_id,
                  {
                    'rev_no': Number(matterServiceInformationResult.linked_items.t_project_basic_infomation.items[0].rev_no),
                    'use_display_id': true,
                    'ensure_transaction': true,
                    'action_id': 'update',
                    'item': {
                      'final_quote_commodity': null,
                      'final_quotation_supplier': null,
                      'final_estimated_selling_cost': null,
                      'final_estimated_sales': null,
                      'final_estimated_gross_profit': null
                    },
                  }
                ),
                this.estimate.execStatusAction(
                  this.registData,
                  hexabaseState.applicationId,
                  this.passedDatastoreId,
                  this.relatedDsId,
                  this.passedItemId,
                  this.execAllowActions,
                  this.execAllowActionsByDetail,
                  this.revNumber,
                  this.selectAction
                )
              ]);
              response = execStatusActionResult;
            } else {
              // 「料率変更する」アクションの場合は案件サービス別OAの更新情報設定
              // ※「見積確定」実行時に更新される項目のうち、料率変更する」アクションで値が変わる項目だけを更新
              if (this.isRateUpadateAction) {
                // サービス別テーブルのrev_no確認のためAPI実行
                const matterServiceInformationResult = await this.estimate.getLinkedItems(
                  hexabaseState.applicationId,
                  this.matterServiceDsId,
                  this.projectServiceItemId,
                  '&use_display_id=true'
                );
                this.registData['related_ds_items'][this.matterServiceDsId] = [
                  {
                    'action_id': 'project_service_OA_valid_update',
                    'operation': 2,
                    'rev_no': matterServiceInformationResult.rev_no,
                    'i_id': this.projectServiceItemId,
                    'item': {
                      'final_rate': this.registData.item['rate'],
                      'final_total_sales_amount': this.registData.item['total_sales_amount'],
                      'final_consumption_tax': this.registData.item['consumption_tax'],
                      'final_total_tax_included': this.registData.item['total_tax_included']
                    }
                  }
                ];
              }
              response =
                this.buttonCrudType !== '4'
                  ? await this.estimate.execStatusAction(
                      this.registData,
                      hexabaseState.applicationId,
                      this.passedDatastoreId,
                      this.relatedDsId,
                      this.passedItemId,
                      this.execAllowActions,
                      this.execAllowActionsByDetail,
                      this.revNumber,
                      this.selectAction
                    )
                  : await this.estimate.registerLinkedItems(
                      hexabaseState.applicationId,
                      this.passedDatastoreId,
                      this.registData
                    );

            }

            if (response !== undefined && response.text !== undefined && response.text.length > 0) {
              this.editText = response.text;
              if (deleteAction) {
                this.buttons.map(v => {
                  // 案件詳細画面へ遷移させる
                  v.name = 'MatterEdit';
                  v.route = '/matter/edit/:id';
                  v.route = String(v.route).replace(':id', this.matterItemId);
                  v.value = '案件詳細画面へ';
                });
              } else {
                this.buttons.map(v => {
                  v.route = String(v.route).replace(':id', this.passedItemId);
                  v.route = String(v.route).replace(':datastoreId', this.passedDatastoreId);
                });
              }
            }
            if (response !== undefined && response.button !== undefined) {
              this.buttons.splice(0);
              this.buttons.push(response.button);
            }
            if (response !== undefined) {
              if (this.buttonCrudType === '4') {
                this.estimate.apiErrorHandle('CREATEITEM', response);
                this.editText = 'コピー完了しました';
                this.nextItemId = response.item_id;
                this.buttons.map(v => {
                  v.route = String(v.route).replace(':id', this.nextItemId);
                  v.route = String(v.route).replace(':datastoreId', this.passedDatastoreId);
                  v.value = 'コピーした見積詳細画面へ';
                });
              }
            }
          } catch (error) {
            this.transitionDialogTitle = '実行エラー';
            this.editText = 'エラーにより処理できませんでした';
            this.buttons.map(v => {
              // 詳細画面へ遷移させる
              v.name = 'EstimateEdit';
              v.route = String(v.route).replace(':id', this.passedItemId);
              v.route = String(v.route).replace(':datastoreId', this.passedDatastoreId);
              v.value = '閉じる';
            });
          } finally {
            this.$store.commit('hexabase/setIsLoading', false);
            this.dialogStatus = true;
          }
        }
        break;
      }
      default: {
        break;
      }
    }
  }

  private addRelatedDsItem(
    dbName: string,
    baseDatas: any,
    registNames: any,
    checkId: string,
    deleteDatas?: any,
    backupDatas?: any
  ) {
    if (baseDatas.length !== 0) {
      // 指定された項目(構成表ID、明細追加入力マスタID、見積明細ID)が存在する場合のみフィルタリング登録対象に含む
      const resultFilterItem = baseDatas.filter(function(recode: any) {
        if (recode.item[checkId] !== null && recode.item[checkId] !== undefined) {
          return recode;
        }
      });

      // バックアップの内容と同内容のアイテムに非更新フラグを立てる
      for (const index in resultFilterItem) {
        if (resultFilterItem[index].item['estimate_id'] !== this.registData.item['estimate_id']) {
          resultFilterItem[index].item['estimate_id'] = this.registData.item['estimate_id'];
        }

        for (const indexBackupDatas in backupDatas) {
          if (
            JSON.stringify(resultFilterItem[index]) ===
            JSON.stringify(backupDatas[indexBackupDatas])
          ) {
            resultFilterItem[index].noUpdate = true;
          }
        }
      }
      // 更新可能なアイテムをフィルタリングする
      const resultItem = resultFilterItem.filter(function(recode: any) {
        if (recode.noUpdate !== true) {
          return recode;
        }
      });

      if (resultItem.length !== 0) {
        this.registData['related_ds_items'][hexabaseState.datastoreIds[dbName]] = [];
      }

      for (const index in resultItem) {
        if (resultItem[index]['operation'] !== undefined) {
          // 登録用に値を型変換
          for (const indexB in registNames) {
            resultItem[index].item[registNames[indexB]] = Number(
              resultItem[index].item[registNames[indexB]]
            );
          }

          // API用登録データに追加
          this.registData['related_ds_items'][hexabaseState.datastoreIds[dbName]].push(
            resultItem[index]
          );
        } else {
          // 登録用に値を型変換
          for (const indexB in registNames) {
            resultItem[index].item[registNames[indexB]] = Number(
              resultItem[index].item[registNames[indexB]]
            );
          }

          // API用登録データに追加
          this.registData['related_ds_items'][hexabaseState.datastoreIds[dbName]].push({
            'operation': 1,
            'link_to_parent': true,
            'item': resultItem[index].item
          });
        }
      }
    }

    if (
      deleteDatas.length !== 0 &&
      this.registData['related_ds_items'][hexabaseState.datastoreIds[dbName]] === undefined
    ) {
      this.registData['related_ds_items'][hexabaseState.datastoreIds[dbName]] = [];
    }
    // 加工済の削除データを追加する
    for (const indexC in deleteDatas) {
      this.registData['related_ds_items'][hexabaseState.datastoreIds[dbName]].push(
        deleteDatas[indexC]
      );
    }
  }

  /**
   * アイテムを登録後ダイアログ表示等を初期化します
   * @returns {void} - 内部プロパティ変更
   */
  private registerFinish(): void {
    this.dialogStatus = false;
    this.isLoading = false;
    // 詳細画面から詳細画面など同じidなどの画面への遷移はエラーになるのでキャンセルと同様に再読み込み
    if (
      this.buttons[0].value === 'コピーした見積詳細画面へ' ||
      this.buttons[0].value === '詳細画面へ' ||
      this.buttons[0].value === '閉じる'
    ) {
      let next: any = {};
      if (this.prevRoute) {
        next = { name: this.prevRoute.name, params: this.prevRoute.params, query: {} };
      }
      next.name = 'EstimateEdit';
      next.params = { datastoreId: this.passedDatastoreId, id: this.nextItemId };
      this.$router.push(next);
    }
  }

  /**
   * 戻る処理
   */
  private backPreviousPage() {
    const beforeRoute = { name: this.prevRoute.name, params: this.prevRoute.params, query: {} };
    if (this.prevRoute) {
      const paths = this.prevRoute.fullPath.split('/');
      if (['list', 'searchlist'].includes(paths[paths.length - 1].toLowerCase())) {
        beforeRoute.query = { searchConditions: 'true' };
      }
    }
    this.$router.push(beforeRoute);
  }

  private setError(errorMessage: string): void {
    if (typeof errorMessage === 'object') errorMessage = this.estimate.getDefaultErrorMessage();
    // エラーをキャッチした際共通エラーダイアログにセット
    this.$store.commit('hexabase/setIsError', true);
    this.$store.commit('hexabase/setErrorMessage', errorMessage);
  }

  /**
   * 案件基本情報パネル内入力イベント
   * @param {string} - イベント情報として押下したボタン種類が返ってくる
   */
  private catchHeaderInput(response: any) {
    const item = this.estimateHeaderData.datas.find(function(recode: any) {
      if (recode.display_id === response.name) {
        return recode;
      }
    });
    item.props.value = response.value;
    this.registData.item[response.name] = response.value;
  }

  /**
   * 見積基本情報(見積件名、見積版名)パネル内入力イベント
   * @param {string} - イベント情報として押下したボタン種類が返ってくる
   */
  private catchInputEstimateSubject(response: any) {
    const item = this.estimateSubjectData.datas.find(function(recode: any) {
      if (recode.display_id === response.name) {
        return recode;
      }
    });
    item.props.value = response.value;
    this.registData.item[response.name] = response.value;
  }

  /**
   * タブ内パネル入力イベント
   * @param {string} - イベント情報として押下したボタン種類が返ってくる
   */
  private async tabChildrenEvent(response: any) {
    let buttonName = '';
    let listName = '';
    switch (response.functionName) {
      case 'clickCheckBoxEventRelay': {
        // チェックボックスの状態に合わせて、
        // 構成表内の各項目で数量がゼロの行を表示・非表示にする
        this.checkBoxsStatus = response.zero_visible;
        if (this.checkBoxsStatus === true) {
          this.partsListViewData = this.filterDataItem(
            JSON.parse(JSON.stringify(this.partsListBaseData)),
            'quantity',
            0,
            false
          );
          if (this.editMode === true) {
            for (const index in this.partsListViewData) {
              this.partsListViewData[index]['No'] = Number(index) + 1;
              this.partsListViewData[index]['edit_material_flag']
                = this.registMaterialItemData[index].item['edit_material_flag'].toLowerCase() === 'true' ? true : false;
              this.partsListViewData[index]['buttonDisabled']
                = this.registMaterialItemData[index].item['edit_material_flag'].toLowerCase() === 'true' ? false : true;

              this.partsListViewData[index]['edit_price_flag']
                = this.registMaterialItemData[index].item['edit_price_flag'].toLowerCase() === 'true' ? true : false;
            }
          }
        } else {
          this.partsListViewData = JSON.parse(JSON.stringify(this.partsListBaseData));
          // 編集可・不可のチェックをする
          if (this.editMode === true) {
            for (const index in this.partsListViewData) {
              this.partsListViewData[index]['edit_material_flag']
                = this.registMaterialItemData[index].item['edit_material_flag'].toLowerCase() === 'true' ? true : false;
              this.partsListViewData[index]['buttonDisabled']
                = this.registMaterialItemData[index].item['edit_material_flag'].toLowerCase() === 'true' ? false : true;

              this.partsListViewData[index]['edit_price_flag']
                = this.registMaterialItemData[index].item['edit_price_flag'].toLowerCase() === 'true' ? true : false;
            }
          }
        }

        this.$set(
          this.estimateTabData[0].configurationTableData.partsList.tableParameters,
          'body',
          this.partsListViewData
        );
        break;
      }
      case 'getdataRelay':
      case 'clickItemAdditionButtonRelay': {
        if (response.buttonName || response.listName) {
          buttonName = response.buttonName;
          listName = response.listName;
        } else if (response.selectRowData.buttonName) {
          buttonName = response.selectRowData.buttonName;
          listName = response.selectRowData.listName;
        }
        switch (listName) {
          case '構成明細': {
            switch (buttonName) {
              case 'taxClassificationButton': {
                const item = this.estimateTabData[0].configurationTableData.partsList
                  .tableParameters['body'][response.selectRowData.itemIndex];
                item['tax_classification_id'] = response.selectData['i_id'];
                item['tax_classification'] = response.selectData['name'];
                item['tax_rate'] = response.selectData['tax_rate'];
                this.registMaterialItemData[response.selectRowData.itemIndex].item[
                  'tax_classification_id'
                ] = response.selectData['i_id'];
                break;
              }
              default: {
                const item = JSON.parse(
                  JSON.stringify(
                    this.estimateTabData[0].configurationTableData.partsList.tableParameters[
                      'body'
                    ][response.itemIndex]
                  )
                );
                if (response.inputName === 'remarks') {
                  if (response.inputValue !== null) {
                    item[response.inputName] = String(response.inputValue);
                  } else {
                    item[response.inputName] = '';
                  }
                } else {
                  item[response.inputName] = Number(response.inputValue);
                }
                item['sale_price'] = item['standard_unit_price'] * item['quantity'];
                item['transfer_amount_price'] = item['transfer_unit_price'] * item['quantity'];
                item['operating_income'] = this.calculationModel.operatingIncome(
                  item['sale_price'],
                  item['transfer_amount_price']
                );
                item['profit_rate'] = this.calculationModel.profitRate(
                  this.calculationModel.operatingIncome(
                    item['sale_price'],
                    item['transfer_amount_price']
                  ),
                  item['sale_price'],
                  this.defaultRoundingType
                );

                this.$set(
                  this.estimateTabData[0].configurationTableData.partsList.tableParameters['body'],
                  response.itemIndex,
                  item
                );
                // 構成表のベースデータにも反映する
                const index = this.dataFindIndex(this.partsListBaseData, 'id', item.id);
                if (index !== -1) {
                  this.partsListBaseData[index] = item;
                }
                // 登録データに追加
                this.registMaterialItemData[index].item[response.inputName] = response.inputValue;
                break;
              }
            }
            // 見積明細のサマリ更新
            this.updateEstimateDetailSummary();
            break;
          }

          case '明細追加入力一覧': {
            switch (buttonName) {
              case 'copyButton': {
                const itemLimit = Number(appState.options['見積詳細']['明細追加入力一覧']['追加上限数'])
                const itemAmount = this.estimateTabData[0].configurationTableData.detailAddList
                  .tableParameters['body'].length;
                if (itemAmount < itemLimit) {
                  const items = this.estimateTabData[0].configurationTableData.detailAddList
                    .tableParameters['body'];
                  const item = JSON.parse(JSON.stringify(items[response.itemIndex]));
                  items.splice(response.itemIndex, 0, item);
                  // 登録用データ
                  if (this.registDatailAddInputItemData[response.itemIndex] !== undefined) {
                    const registItem = JSON.parse(
                      JSON.stringify(this.registDatailAddInputItemData[response.itemIndex])
                    );
                    // コピーするアイテム情報のみ抜き出す('operation': 1などの追加は登録時に行う)
                    const copyItem = {'item': registItem.item}
                    this.registDatailAddInputItemData.splice(response.itemIndex + 1, 0, copyItem);
                    for (const index in this.registDatailAddInputItemData) {
                      // display_orderの振りなおし
                      this.registDatailAddInputItemData[index].item['display_order'] =
                        Number(index) + 1;
                    }
                  }
                  // 表示用Noとidの振りなおし
                  for (const index in items) {
                    items[index]['No'] = Number(index) + 1;
                    items[index]['id'] = Number(index) + 1;
                  }
                } else {
                  this.alertDialogMessage = EstimateFractionRoundWording.alertOverAddItems.message;
                  this.alertDialogTitle = EstimateFractionRoundWording.alertOverAddItems.title;
                  this.isAlertDialog = true;
                }
                break;
              }
              case 'deleteButton': {
                // 明細追加入力一覧の削除用データ作成(既存の登録済データのみ対象用)
                if (this.registDatailAddInputItemData.length !== 0) {
                  if (this.registDatailAddInputItemData[response.itemIndex].i_id !== undefined) {
                    if (
                      this.registDatailAddInputItemData[response.itemIndex].item
                        .datail_add_input_id !== undefined
                    ) {
                      this.registDatailAddInputItemDeleteData.push({
                        'operation': 2,
                        'action_id': 'datail_add_input_valid_delete',
                        'rev_no': Number(
                          this.estimateTabData[0].configurationTableData.detailAddList
                            .tableParameters['body'][response.itemIndex]['rev_no']
                        ),
                        'i_id': this.estimateTabData[0].configurationTableData.detailAddList
                          .tableParameters['body'][response.itemIndex]['i_id']
                      });
                      this.registDatailAddInputItemDeleteData.push({
                        'operation': 12,
                        'rev_no': Number(
                          this.estimateTabData[0].configurationTableData.detailAddList
                            .tableParameters['body'][response.itemIndex]['rev_no']
                        ),
                        'i_id': this.estimateTabData[0].configurationTableData.detailAddList
                          .tableParameters['body'][response.itemIndex]['i_id']
                      });
                    }
                  }
                  this.registDatailAddInputItemData.splice(response.itemIndex, 1);
                  for (const index in this.registDatailAddInputItemData) {
                    this.registDatailAddInputItemData[index].item['display_order'] =
                      Number(index) + 1;
                  }
                }

                // 明細追加入力一覧の表示データ削除
                this.estimateTabData[0].configurationTableData.detailAddList.tableParameters[
                  'body'
                ].splice(response.itemIndex, 1);
                const items = this.estimateTabData[0].configurationTableData.detailAddList
                  .tableParameters['body'];
                for (const index in this.estimateTabData[0].configurationTableData.detailAddList
                  .tableParameters['body']) {
                  items[index]['No'] = Number(index) + 1;
                  items[index]['id'] = Number(index) + 1;
                  items[index]['display_order'] = Number(index) + 1;
                }
                break;
              }
              case 'selectButtonIndex': {
                const item = this.estimateTabData[0].configurationTableData.detailAddList
                  .tableParameters['body'][response.selectRowData.itemIndex];
                item['display_datail_add_input_id'] =
                  response.selectData['display_datail_add_input_id'];
                item['item_code'] = response.selectData['item_code'];
                item['item'] = response.selectData['item'];
                item['standard_unit_price'] = response.selectData['standard_unit_price'];
                if (response.selectData['purchase_unit_price'] !== undefined) {
                  item['reference_purchase_unit_price'] = JSON.parse(
                    JSON.stringify(response.selectData['purchase_unit_price'])
                  );
                }
                item['purchase_unit_price'] = response.selectData['purchase_unit_price'];
                item['classification_id'] = response.selectData['classification_id'];
                item['classification'] = response.selectData['classification_id'];
                item['type_id'] = response.selectData['type_id'];
                item['type'] = response.selectData['type_id'];
                item['remarks'] = response.selectData['remarks'];
                item['input_flag'] = JSON.parse(response.selectData['input_flag'].toLowerCase());
                // 計算関係の値も初期化
                item['quantity'] = 0;
                item['sale_price'] = item['standard_unit_price'] * item['quantity'];
                item['purchasing_price'] = item['purchase_unit_price'] * item['quantity'];
                item['operating_income'] = 0;
                item['profit_rate'] = '0%';
                item['display_order'] = Number(response.selectRowData.itemIndex) + 1;

                item['tax_classification_id'] = this.defaultTaxData.i_id;
                item['tax_classification'] = this.defaultTaxData.name;
                item['tax_rate'] = this.defaultTaxData.tax_rate;
                // 課税区分編集可否フラグ
                item['tax_classification_edit_flag'] = response.selectData['tax_classification_edit_flag'];
                // 明細追加入力一覧用登録データの作成
                this.registDatailAddInputItemData[response.selectRowData.itemIndex].item = {
                  'display_order': Number(response.selectRowData.itemIndex) + 1,
                  'item': item['item'],
                  'datail_add_input_id': response.selectData['i_id'],
                  'standard_unit_price': Number(item['standard_unit_price']),
                  'purchase_unit_price': Number(item['purchase_unit_price']),
                  'quantity': Number(item['quantity']),
                  'remarks': item['remarks'],
                  'tax_classification_id': this.defaultTaxData.i_id
                };
                break;
              }
              case 'addListItem': {
                const itemLimit = Number(appState.options['見積詳細']['明細追加入力一覧']['追加上限数'])
                const itemAmount = this.estimateTabData[0].configurationTableData.detailAddList
                  .tableParameters['body'].length;
                if (itemAmount < itemLimit) {
                  const items = this.estimateTabData[0].configurationTableData.detailAddList
                    .tableParameters['body'];
                  const estimateDatailAddInputItem = JSON.parse(
                    JSON.stringify(EstimateDatailAddInputBaseFormat)
                  );
                  estimateDatailAddInputItem['No'] = Number(items.length) + 1;
                  estimateDatailAddInputItem['id'] = Number(items.length) + 1;
                  estimateDatailAddInputItem['display_order'] = Number(items.length) + 1;
                  estimateDatailAddInputItem['tax_classification_id'] = this.defaultTaxData.i_id;
                  estimateDatailAddInputItem['tax_classification'] = this.defaultTaxData.name;
                  estimateDatailAddInputItem['tax_rate'] = this.defaultTaxData.tax_rate;
                  this.estimateTabData[0].configurationTableData.detailAddList.tableParameters[
                    'body'
                  ].push(estimateDatailAddInputItem);
                  // 明細追加入力一覧用登録データの作成
                  this.registDatailAddInputItemData.push({
                    item: {
                      'display_order': Number(this.registDatailAddInputItemData) + 1,
                      'item': '',
                      'standard_unit_price': 0,
                      'purchase_unit_price': 0,
                      'quantity': 0,
                      'remarks': '',
                      'tax_classification_id': this.defaultTaxData.i_id
                    }
                  });
                } else {
                  this.alertDialogMessage = EstimateFractionRoundWording.alertOverAddItems.message;
                  this.alertDialogTitle = EstimateFractionRoundWording.alertOverAddItems.title;
                  this.isAlertDialog = true;
                }
                break;
              }
              case 'taxClassificationButton': {
                const item = JSON.parse(
                  JSON.stringify(
                    this.estimateTabData[0].configurationTableData.detailAddList.tableParameters[
                      'body'
                    ][response.selectRowData.itemIndex]
                  )
                );
                item['tax_classification_id'] = response.selectData['i_id'];
                item['tax_classification'] = response.selectData['name'];
                item['tax_rate'] = response.selectData['tax_rate'];
                this.$set(
                  this.estimateTabData[0].configurationTableData.detailAddList.tableParameters[
                    'body'
                  ],
                  response.selectRowData.itemIndex,
                  item
                );
                this.registDatailAddInputItemData[response.selectRowData.itemIndex].item[
                  'tax_classification_id'
                ] = response.selectData['i_id'];
                break;
              }
              default: {
                const item = JSON.parse(
                  JSON.stringify(
                    this.estimateTabData[0].configurationTableData.detailAddList.tableParameters[
                      'body'
                    ][response.itemIndex]
                  )
                );
                if (response.inputName === 'remarks' || response.inputName === 'item') {
                  if (response.inputValue !== null) {
                    item[response.inputName] = String(response.inputValue);
                  } else {
                    item[response.inputName] = '';
                  }
                } else {
                  item[response.inputName] = Number(response.inputValue);
                }
                item['sale_price'] = item['standard_unit_price'] * item['quantity'];
                item['purchasing_price'] = item['purchase_unit_price'] * item['quantity'];
                item['operating_income'] = this.calculationModel.operatingIncome(
                  item['sale_price'],
                  item['purchasing_price']
                );
                item['profit_rate'] = this.calculationModel.profitRate(
                  this.calculationModel.operatingIncome(
                    item['sale_price'],
                    item['purchasing_price']
                  ),
                  item['sale_price'],
                  this.defaultRoundingType
                );

                this.$set(
                  this.estimateTabData[0].configurationTableData.detailAddList.tableParameters[
                    'body'
                  ],
                  response.itemIndex,
                  item
                );
                // 選択から明細追加入力マスタの内容が選ばれてない場合は登録しない
                if (this.registDatailAddInputItemData.length !== 0) {
                  this.registDatailAddInputItemData[response.itemIndex].item[response.inputName] =
                    response.inputValue;
                }
                break;
              }
            }
            // 見積明細のサマリ更新
            this.updateEstimateDetailSummary();
            break;
          }
          case '見積表': {
            switch (buttonName) {
              case 'copyButton': {
                const items = this.estimateTabData[1].estimateInformationData.estimateDetailList
                  .tableParameters['body'];
                const item = JSON.parse(JSON.stringify(items[response.itemIndex]));
                items.splice(response.itemIndex, 0, item);
                // 登録用データ
                if (
                  this.registEstimateDetailItemData[
                    response.itemIndex - this.estimateDetailSummaryLength
                  ] !== undefined
                ) {
                  const registItem = JSON.parse(
                    JSON.stringify(
                      this.registEstimateDetailItemData[
                        response.itemIndex - this.estimateDetailSummaryLength
                      ]
                    )
                  );
                  // コピーするアイテム情報のみ抜き出す('operation': 1などの追加は登録時に行う)
                  const copyItem = {'item': registItem.item}
                  this.registEstimateDetailItemData.splice(response.itemIndex + 1, 0, copyItem);
                  for (const index in this.registEstimateDetailItemData) {
                    // display_orderの振りなおし
                    this.registEstimateDetailItemData[index].item['display_order'] =
                      Number(index) + 1;
                  }
                }
                // 表示用Noとidの振りなおし
                for (const index in items) {
                  items[index]['No'] = Number(index) + 1;
                  items[index]['id'] = Number(index) + 1;
                }
                break;
              }
              case 'deleteButton': {
                // 見積表の削除用データ作成(既存の登録済データのみ対象用)
                if (this.registEstimateDetailItemData.length !== 0) {
                  if (
                    this.registEstimateDetailItemData[
                      response.itemIndex - this.estimateDetailSummaryLength
                    ].i_id !== undefined
                  ) {
                    if (
                      this.registEstimateDetailItemData[
                        response.itemIndex - this.estimateDetailSummaryLength
                      ].item.estimate_detail_id !== undefined
                    ) {
                      this.registEstimateDetailItemDeleteData.push({
                        'operation': 2,
                        'action_id': 'estimate_detail_valid_delete',
                        'rev_no': Number(
                          this.estimateTabData[1].estimateInformationData.estimateDetailList
                            .tableParameters['body'][response.itemIndex]['rev_no']
                        ),
                        'i_id': this.estimateTabData[1].estimateInformationData.estimateDetailList
                          .tableParameters['body'][response.itemIndex]['i_id']
                      });
                      this.registEstimateDetailItemDeleteData.push({
                        'operation': 12,
                        'rev_no': Number(
                          this.estimateTabData[1].estimateInformationData.estimateDetailList
                            .tableParameters['body'][response.itemIndex]['rev_no']
                        ),
                        'i_id': this.estimateTabData[1].estimateInformationData.estimateDetailList
                          .tableParameters['body'][response.itemIndex]['i_id']
                      });
                    }
                  }
                  this.registEstimateDetailItemData.splice(response.itemIndex, 1);
                  for (const index in this.registEstimateDetailItemData) {
                    this.registEstimateDetailItemData[index].item['display_order'] =
                      Number(index) + 1;
                  }
                }
                this.estimateTabData[1].estimateInformationData.estimateDetailList.tableParameters[
                  'body'
                ].splice(response.itemIndex, 1);
                const items = this.estimateTabData[1].estimateInformationData.estimateDetailList
                  .tableParameters['body'];
                for (const index in this.estimateTabData[1].estimateInformationData
                  .estimateDetailList.tableParameters['body']) {
                  items[index]['No'] = Number(index) + 1;
                  items[index]['id'] = Number(index) + 1;
                  items[index]['display_order'] = Number(index) + 1;
                }
                break;
              }
              case 'selectButtonIndex': {
                const item = this.estimateTabData[1].estimateInformationData.estimateDetailList
                  .tableParameters['body'][response.selectRowData.itemIndex];
                item['display_estimate_detail_id'] =
                  response.selectData['display_estimate_detail_id'];
                item['classification_id'] = response.selectData['classification_id'];
                item['classification'] = response.selectData['classification_id'];
                item['type_id'] = response.selectData['type_id'];
                item['type'] = response.selectData['type_id'];
                item['item'] = response.selectData['item'];
                item['unit_price'] = response.selectData['unit_price'];
                if (response.selectData['purchase_unit_price'] !== undefined) {
                  item['reference_purchase_unit_price'] = JSON.parse(
                    JSON.stringify(response.selectData['purchase_unit_price'])
                  );
                }
                item['purchase_unit_price'] = response.selectData['purchase_unit_price'];
                item['remarks'] =
                  response.selectData['remarks'] !== undefined
                    ? response.selectData['remarks']
                    : '';
                item['input_flag'] = JSON.parse(response.selectData['input_flag'].toLowerCase());
                // 課税区分編集可否フラグ
                item['tax_classification_edit_flag'] = response.selectData['tax_classification_edit_flag'];
                // 計算関係の値も初期化
                item['quantity'] = 0;
                item['sale_price'] = item['unit_price'] * item['quantity'];
                item['purchasing_price'] = item['purchase_unit_price'] * item['quantity'];
                item['operating_income'] = 0;
                item['profit_rate'] = '0%';
                item['display_order'] = Number(response.selectRowData.itemIndex) + 1 - this.estimateDetailSummaryLength;

                // 見積表用登録データの作成
                this.registEstimateDetailItemData[response.selectRowData.itemIndex - this.estimateDetailSummaryLength].item = {
                  'display_order': Number(response.selectRowData.itemIndex) + 1 - this.estimateDetailSummaryLength,
                  'item': item['item'],
                  'estimate_detail_id': response.selectData['i_id'],
                  'unit_price': Number(item['unit_price']),
                  'purchase_unit_price': Number(item['purchase_unit_price']),
                  'quantity': Number(item['quantity']),
                  'remarks': item['remarks']
                };
                break;
              }
              case 'addListItem': {
                const items = this.estimateTabData[1].estimateInformationData.estimateDetailList
                  .tableParameters['body'];
                const estimateDatailInputItem = JSON.parse(
                  JSON.stringify(EstimateDatailBaseFormat)
                );
                estimateDatailInputItem['No'] = Number(items.length) + 1;
                estimateDatailInputItem['id'] = Number(items.length) + 1;
                estimateDatailInputItem['display_order'] = Number(items.length) + 1;
                estimateDatailInputItem['tax_classification_id'] = this.defaultTaxData.i_id;
                estimateDatailInputItem['tax_classification'] = this.defaultTaxData.name;
                estimateDatailInputItem['tax_rate'] = this.defaultTaxData.tax_rate;
                this.estimateTabData[1].estimateInformationData.estimateDetailList.tableParameters[
                  'body'
                ].push(estimateDatailInputItem);
                // 見積表用登録データの作成
                this.registEstimateDetailItemData.push({
                  item: {
                    'display_order': Number(this.registEstimateDetailItemData) + 1,
                    'item': '',
                    'unit_price': 0,
                    'purchase_unit_price': 0,
                    'quantity': 0,
                    'remarks': '',
                    'tax_classification_id': this.defaultTaxData.i_id
                  }
                });
                break;
              }
              case 'taxClassificationButton': {
                const item = JSON.parse(
                  JSON.stringify(
                    this.estimateTabData[1].estimateInformationData.estimateDetailList
                      .tableParameters['body'][response.selectRowData.itemIndex]
                  )
                );
                item['tax_classification_id'] = response.selectData['i_id'];
                item['tax_classification'] = response.selectData['name'];
                item['tax_rate'] = response.selectData['tax_rate'];
                this.$set(
                  this.estimateTabData[1].estimateInformationData.estimateDetailList
                    .tableParameters['body'],
                  response.selectRowData.itemIndex,
                  item
                );
                this.registEstimateDetailItemData[
                  response.selectRowData.itemIndex - this.estimateDetailSummaryLength
                ].item['tax_classification_id'] = response.selectData['i_id'];
                break;
              }
              default: {
                const item = JSON.parse(
                  JSON.stringify(
                    this.estimateTabData[1].estimateInformationData.estimateDetailList
                      .tableParameters['body'][response.itemIndex]
                  )
                );
                if (response.inputName === 'remarks' || response.inputName === 'item') {
                  if (response.inputValue !== null) {
                    item[response.inputName] = String(response.inputValue);
                  } else {
                    item[response.inputName] = '';
                  }
                } else {
                  item[response.inputName] = Number(response.inputValue);
                }
                item['sale_price'] = item['unit_price'] * item['quantity'];
                item['purchasing_price'] = item['purchase_unit_price'] * item['quantity'];
                item['operating_income'] = this.calculationModel.operatingIncome(
                  item['sale_price'],
                  item['purchasing_price']
                );
                item['profit_rate'] = this.calculationModel.profitRate(
                  this.calculationModel.operatingIncome(
                    item['sale_price'],
                    item['purchasing_price']
                  ),
                  item['sale_price'],
                  this.defaultRoundingType
                );

                this.$set(
                  this.estimateTabData[1].estimateInformationData.estimateDetailList
                    .tableParameters['body'],
                  response.itemIndex,
                  item
                );

                // 選択から明細追加入力マスタの内容が選ばれてない場合は登録しない
                if (this.registEstimateDetailItemData.length !== 0) {
                  this.registEstimateDetailItemData[
                    response.itemIndex - this.estimateDetailSummaryLength
                  ].item[response.inputName] = response.inputValue;
                }
                break;
              }
            }
            break;
          }
        }
        // 税率毎のサマリを作成
        if (this.estimateTabData[1].estimateInformationData.estimateDetailList.isEstimateAddItemButtonFlag === false) {
          let mergeDetails =[]
          // 見積書に項目追加できないので見積書データは含めない
          mergeDetails = this.estimateTabData[0].configurationTableData.partsList.tableParameters[
            'body'
          ].concat(
            this.estimateTabData[0].configurationTableData.detailAddList.tableParameters['body'],
          );
          this.taxData = this.createGroupByTaxClassificationId(mergeDetails);
          this.estimateDetailSummary.datas[0].props.value = this.taxData.reduce(
            (previousValue, currentValue) => Number(previousValue) + Number(currentValue.amount),
            0
          );
          this.estimateDetailSummary.datas[1].props.value = this.taxData.reduce(
            (previousValue, currentValue) => Number(previousValue) + Number(currentValue.tax),
            0
          );
          this.estimateDetailSummary.datas[2].props.value =
            this.estimateDetailSummary.datas[0].props.value +
            this.estimateDetailSummary.datas[1].props.value;
          this.$set(
            this.estimateTabData[1].estimateInformationData.createTaxSummary,
            'taxData',
            this.taxData
          );
        } else {
          const mergeDetails = this.estimateTabData[0].configurationTableData.partsList.tableParameters[
            'body'
          ].concat(
            this.estimateTabData[0].configurationTableData.detailAddList.tableParameters['body'],
            this.estimateTabData[1].estimateInformationData.estimateDetailList.tableParameters['body']
          );
          this.taxData = this.createGroupByTaxClassificationId(mergeDetails);
          this.estimateDetailSummary.datas[0].props.value = this.taxData.reduce(
            (previousValue, currentValue) => Number(previousValue) + Number(currentValue.amount),
            0
          );
          this.estimateDetailSummary.datas[1].props.value = this.taxData.reduce(
            (previousValue, currentValue) => Number(previousValue) + Number(currentValue.tax),
            0
          );
          this.estimateDetailSummary.datas[2].props.value =
            this.estimateDetailSummary.datas[0].props.value +
            this.estimateDetailSummary.datas[1].props.value;
          this.$set(
            this.estimateTabData[1].estimateInformationData.createTaxSummary,
            'taxData',
            this.taxData
          );
        }
        break;
      }
      case 'masterSelectEventRelay': {
        this.$store.commit('hexabase/setIsLoading', true);
        try {
          // 商材マスタから選択された商材を構成明細に表示する
          if (this.partsListBaseData.length !== 0) {
            // 削除するアイテム
            for (const index in this.partsListBaseData) {
              // 見積ID(estimate_id)が存在する場合はトランに存在するアイテムなので
              // 商材変更時は削除
              if (this.partsListBaseData[index].estimate_id !== undefined) {
                this.deletePartsListData.push({
                  'operation' : 3,
                  'i_id' : this.partsListBaseData[index].i_id
                });
              }
            }
            // 商材マスタから選択された商材を構成明細に表示する
            this.partsListViewData = [];
            this.partsListBaseData = [];
            this.$set(
              this.estimateTabData[0].configurationTableData.partsList.tableParameters,
              'body',
              []
            );
            // 登録データも初期化
            this.registMaterialItemData = [];
          }
          const commodityItem = this.masterCommoditySelectData.find(function(recode: any) {
            if (recode.i_id === response.value) {
              return recode;
            }
          });

          if (commodityItem !== undefined) {
            this.registData.item['commodity_id'] = commodityItem['i_id'];
          }

          const selectItemResult = this.masterData['m_material'].body.filter(function(recode) {
            if (commodityItem?.commodity === recode.commodity_id) {
              return recode;
            }
          });

          for (const key in selectItemResult) {
            const baseItems = JSON.parse(JSON.stringify(selectItemResult[key]));
            baseItems['No'] = Number(key) + 1;
            baseItems['quantity'] = 0;
            baseItems['sale_price'] = baseItems['standard_unit_price'] * baseItems['quantity'];
            baseItems['transfer_amount_price'] =
              baseItems['transfer_unit_price'] * baseItems['quantity'];
            baseItems['operating_income'] = this.calculationModel.operatingIncome(
              baseItems['sale_price'],
              baseItems['transfer_amount_price']
            );
            baseItems['profit_rate'] = this.calculationModel.profitRate(
              this.calculationModel.operatingIncome(
                baseItems['sale_price'],
                baseItems['transfer_amount_price']
              ),
              baseItems['sale_price'],
              this.defaultRoundingType
            );
            this.partsListBaseData.push(baseItems);

            // 構成明細用登録データの作成
            this.registMaterialItemData.push({
              'item':{
                'service_type_id': this.serviceTypeItemId,
                'material_id': baseItems.lookup_items.material_id.i_id,
                'standard_unit_price': Number(baseItems['standard_unit_price']),
                'transfer_unit_price': Number(baseItems['transfer_unit_price']),
                'quantity': Number(baseItems['quantity']),
                'remarks': baseItems['remarks'],
                "display_order": Number(key) + 1
              }
            });
          }

          this.partsListViewData = JSON.parse(JSON.stringify(this.partsListBaseData));
          this.$set(
            this.estimateTabData[0].configurationTableData.partsList.tableParameters,
            'body',
            this.partsListViewData
          );
          //テンプレートをセレクトボックスにロードする
          const getBody = this.masterData['m_materialtemplate'].body.filter(
            v => v.commodity_id === commodityItem['commodity']
          );
          if (getBody !== undefined && getBody.length > 0) {
            this.mtempleteSelectDataOption.splice(0, this.mtempleteSelectDataOption.length);
            getBody.forEach(v => {
              this.mtempleteSelectDataOption.push({ text: v.template_name, value: v.i_id });
            });
            // ボックスをを活性
            this.$set(
              this.estimateTabData[0].configurationTableData.vmSelectDataTemplete,
              'isDisabled',
              false
            );
          }
        } catch (e) {
          console.log(e);
          // エラーをキャッチした際共通エラーダイアログにセット
          if (e instanceof Error) {
            this.setError(e.message);
          } else if (typeof e === 'string') {
            this.setError(e);
          }
        } finally {
          this.$store.commit('hexabase/setIsLoading', false);
        }
        break;
      }
      case 'catchInputRelay': {
        switch (response.name) {
          case 'order_accuracy': {
            if (response.text !== '') {
              const item = this.selectOptions['orderAccuracy']['options'].find(
                (recode: any) => recode.text === response.text
              );
              // 登録用にoption_idをセット
              this.registData.item['order_accuracy'] = item.option_id;
            }
            break;
          }
          case 'leasing_company_id': {
            const item = this.mastermEstimateRateData.find(
              (recode: any) => recode.i_id === response.value
            );
            this.estimateInformationPanel.datas[5].props.value = response.value;
            this.estimateInformationPanel.datas[6].props.value =
              item['contract_months_calculation'];
            this.estimateInformationPanel.datas[7].props.value = item['rate'];
            this.estimateInformationPanel.datas[8].props.value = this.calculationModel.monthlyLeaseCost(
              this.estimateInformationSummary.datas[6].props.value,
              Number(item['rate'])
            );
            const leasingCompanyItem = this.masterData['m_leasing_company'].body.find(
              (recode: any) => recode['leasing_company'] === item['leasing_company_id']
            );
            if (leasingCompanyItem !== undefined) {
              this.registData.item['leasing_company_id'] = leasingCompanyItem['i_id'];
            }
            this.registData.item['contract_months'] = item['contract_months_calculation'];
            this.registData.item['rate'] = item['rate'];
            break;
          }
          case 'monthly_lease_fee': {
            this.registData.item['monthly_lease_fee'] = response.value;
            break;
          }
          case 'contract_months': {
            this.registData.item['contract_months'] = response.value;
            break;
          }
          case 'rate': {
            this.estimateInformationPanel.datas[7].props.value = response.value;
            this.registData.item['rate'] = response.value;
            // 「料率変更する」アクションか判定
            if (this.isRateUpadateAction) {
              // 料率が変更された場合は料率変更フラグを立てる
              this.rateChangeFlag = true;
            }
            break;
          }

          case 'estimate_expiration_date': {
            this.estimateInformationPanel.datas[0].props.value = response.value;
            this.registData.item['estimate_expiration_date'] = response.value;
            break;
          }
          case 'estimate_registration_date': {
            this.estimateInformationPanel.datas[2].props.value = response.value;
            this.registData.item['estimate_registration_date'] = response.value;
            break;
          }
          case 'estimate_update_date': {
            this.estimateInformationPanel.datas[3].props.value = response.value;
            this.registData.item['estimate_update_date'] = response.value;
            break;
          }
          default: {
            break;
          }
        }
        break;
      }
      case 'clickDownloadButtonEventRelay': {
        switch (response.listName) {
          case '構成明細': {
            this.displayFormDialog('構成表出力');
            break;
          }
          case '見積表': {
            this.displayFormDialog('見積書出力');
            break;
          }
          default: {
            break;
          }
        }
        break;
      }
      case 'changeSelectTemplete': {
        switch (response.name) {
          case 'materialTemplate': {
            // 構成表テンプレート選択時の処理
            const materialDsId = hexabaseState.datastoreIds['構成表マスタ'];
            let dispMesseage = '';
            const getTempId: string = response.value.value || '';
            const getBody = this.masterData['m_materialtemplate'].body.find(v => v.i_id === getTempId);
            const getIlinks1: any = getBody !== undefined ? getBody['item_links'] : undefined;
            const getIlinks2: [{ d_id: string; item_count: number; items: any }] = getIlinks1 !== undefined ? getIlinks1.links : undefined;
            const getIlinks3: [{ i_id: string; type: string }] =
              getIlinks2 !== undefined ? getIlinks2.find(v => v.d_id === hexabaseState.datastoreIds['構成表テンプレート明細'])?.items : undefined;
            const findListB: Array<PartsListDataFormat> = this.partsListBaseData;

            getIlinks3.forEach(v1 => {
              const getRecode = this.masterData['m_materialtemplate_detail'].body.find(v2 => v2.i_id === v1.i_id);
              const getRecodeFormat: any = getRecode !== undefined ? getRecode : undefined;
              const getRecodewk0: [{ d_id: string; item_count: number; items: [{ i_id: string; type: string }] }] =
                getRecodeFormat !== undefined ? getRecodeFormat.item_links.links : undefined;
              const IndexB1 = getRecodewk0.findIndex(v5 => v5.d_id === materialDsId);
              const findIndexB = findListB.findIndex(v3 => v3.lookup_items.material_id.i_id === getRecodewk0[IndexB1].items[0].i_id);
              const setQuantity: number = getRecodeFormat.quantity !== undefined ? Number(getRecodeFormat.quantity) : 0;

              //数量下限、上限
              const setQuantityLowerLimit: number = getRecodeFormat.quantity_lower_limit !== undefined ? Number(getRecodeFormat.quantity_lower_limit) : 0;
              const setQuantityUpperLimit: number = getRecodeFormat.quantity_upper_limit !== undefined ? Number(getRecodeFormat.quantity_upper_limit) : 0;

              //単価下限、上限
              const setUnitLowerLimit: number = getRecodeFormat.unit_lower_limit !== undefined ? Number(getRecodeFormat.unit_lower_limit) : 0;
              const setUnitUpperLimit: number = getRecodeFormat.unit_upper_limit !== undefined ? Number(getRecodeFormat.unit_upper_limit) : 0;

              // 構成表テンプレート明細のソート順をワークに格納
              const setNo: number =
                getRecodeFormat.sort_no !== undefined ? Number(getRecodeFormat.sort_no) : 0;

              if (findIndexB !== undefined && findIndexB !== -1) {
                // セット ＆ 再計算！！！！
                const itembase: PartsListDataFormat = this.partsListBaseData[findIndexB];
                itembase.quantity = setQuantity;
                itembase.quantity_lower_limit = setQuantityLowerLimit;
                itembase.quantity_upper_limit = setQuantityUpperLimit;
                itembase.unit_lower_limit = setUnitLowerLimit;
                itembase.unit_upper_limit = setUnitUpperLimit;
                itembase.sale_price = itembase.standard_unit_price * itembase.quantity;
                itembase.transfer_amount_price = itembase.transfer_unit_price * itembase.quantity;
                itembase.operating_income = this.calculationModel.operatingIncome(itembase.sale_price, itembase.transfer_amount_price);
                itembase.profit_rate = this.calculationModel.profitRate(
                  this.calculationModel.operatingIncome(itembase.sale_price, itembase.transfer_amount_price),
                  itembase.sale_price,
                  this.defaultRoundingType
                );
                itembase.No = setNo;
                // テンプレートに設定された編集可・不可フラグから行内の入力項目、ボタンを制御
                if (getRecode !== undefined) {
                  itembase.edit_material_flag = getRecode.edit_material_flag === 'true' ? true : false;
                  itembase.buttonDisabled = getRecode.edit_material_flag === 'true' ? false : true;
                  itembase.edit_price_flag = getRecode.edit_price_flag === 'true' ? true : false;
                }
                this.partsListBaseData.splice(findIndexB, 1, itembase);
                // 登録データに追加
                this.$set(this.registMaterialItemData[findIndexB].item, 'quantity', setQuantity);
                this.$set(this.registMaterialItemData[findIndexB].item, 'quantity_lower_limit', setQuantityLowerLimit);
                this.$set(this.registMaterialItemData[findIndexB].item, 'quantity_upper_limit', setQuantityUpperLimit);
                this.$set(this.registMaterialItemData[findIndexB].item, 'unit_lower_limit', setUnitLowerLimit);
                this.$set(this.registMaterialItemData[findIndexB].item, 'unit_upper_limit', setUnitUpperLimit);
                this.$set(this.registMaterialItemData[findIndexB].item, 'edit_material_flag', String(itembase.edit_material_flag));
                this.$set(this.registMaterialItemData[findIndexB].item, 'edit_price_flag', String(itembase.edit_price_flag));
                this.$set(this.registMaterialItemData[findIndexB].item, 'display_order', setNo);
              } else {
                // テンプレートが構成とマッチしない、警告を出す！
                dispMesseage = TemplateWarningMessage;
                // マッチしないデータを商品名でマッチングする
                const findIndexB2 = findListB.findIndex(v3 => v3.item === getRecodeFormat.ref_item);
                if (findIndexB2 !== undefined && findIndexB2 !== -1) {
                  const itembase2: PartsListDataFormat = this.partsListBaseData[findIndexB2];
                  itembase2.quantity = setQuantity;
                  itembase2.quantity_lower_limit = setQuantityLowerLimit;
                  itembase2.quantity_upper_limit = setQuantityUpperLimit;
                  itembase2.unit_lower_limit = setUnitLowerLimit;
                  itembase2.unit_upper_limit = setUnitUpperLimit;
                  itembase2.sale_price = itembase2.standard_unit_price * itembase2.quantity;
                  itembase2.transfer_amount_price = itembase2.transfer_unit_price * itembase2.quantity;
                  itembase2.operating_income = this.calculationModel.operatingIncome(itembase2.sale_price, itembase2.transfer_amount_price);
                  itembase2.profit_rate = this.calculationModel.profitRate(
                    this.calculationModel.operatingIncome(itembase2.sale_price, itembase2.transfer_amount_price),
                    itembase2.sale_price,
                    this.defaultRoundingType
                  );
                  itembase2.No = setNo;
                  // 編集可にする
                  itembase2.edit_material_flag = true;
                  itembase2.buttonDisabled = false;
                  itembase2.edit_price_flag = true;

                  this.partsListBaseData.splice(findIndexB2, 1, itembase2);
                  // 登録データに追加
                  this.$set(this.registMaterialItemData[findIndexB2].item, 'quantity', setQuantity);
                  this.$set(this.registMaterialItemData[findIndexB2].item, 'quantity_lower_limit', setQuantityLowerLimit);
                  this.$set(this.registMaterialItemData[findIndexB2].item, 'quantity_upper_limit', setQuantityUpperLimit);
                  this.$set(this.registMaterialItemData[findIndexB2].item, 'unit_lower_limit', setUnitLowerLimit);
                  this.$set(this.registMaterialItemData[findIndexB2].item, 'unit_upper_limit', setUnitUpperLimit);
                  this.$set(this.registMaterialItemData[findIndexB2].item, 'edit_material_flag', String(true));
                  this.$set(this.registMaterialItemData[findIndexB2].item, 'edit_price_flag', String(true));
                  this.$set(this.registMaterialItemData[findIndexB2].item, 'display_order', setNo);
                }
              }
            });

            // 警告メッセージの表示
            if (dispMesseage.length > 0) {
              this.$set(this.estimateTabData[0].configurationTableData.vmSelectDataTemplete, 'displayInfomation', dispMesseage);
            }

            // partsListBaseDataをNoの昇順で並べ替え（構成表テンプレート明細のソート順で並べ替え）
            this.partsListBaseData.sort((a: { No: number }, b: { No: number }) => a.No - b.No);
            // 登録データもdisplay_orderの昇順で並べ替え（構成表テンプレート明細のソート順で並べ替え）
            this.registMaterialItemData.sort(
              (a: any, b: any) => a.item.display_order - b.item.display_order
            );

            // リストデータを表示として再セット
            if (this.checkBoxsStatus === true) {
              this.partsListViewData = this.filterDataItem(JSON.parse(JSON.stringify(this.partsListBaseData)), 'quantity', 0, false);
              for (const index in this.partsListViewData) {
                this.partsListViewData[index]['No'] = Number(index) + 1;
              }
            } else {
              this.partsListViewData = JSON.parse(JSON.stringify(this.partsListBaseData));
            }
            this.$set(this.estimateTabData[0].configurationTableData.partsList.tableParameters, 'body', this.partsListViewData);
            break;
          }
        }
        this.updateEstimateDetailSummary();
        // 税率毎のサマリを作成
        const mergeDetails = this.estimateTabData[0].configurationTableData.partsList.tableParameters[
          'body'
        ].concat(
          this.estimateTabData[0].configurationTableData.detailAddList.tableParameters['body'],
          this.estimateTabData[1].estimateInformationData.estimateDetailList.tableParameters['body']
        );
        this.taxData = this.createGroupByTaxClassificationId(mergeDetails);
        this.estimateDetailSummary.datas[0].props.value = this.taxData.reduce(
          (previousValue, currentValue) => Number(previousValue) + Number(currentValue.amount),
          0
        );
        this.estimateDetailSummary.datas[1].props.value = this.taxData.reduce(
          (previousValue, currentValue) => Number(previousValue) + Number(currentValue.tax),
          0
        );
        this.estimateDetailSummary.datas[2].props.value =
          this.estimateDetailSummary.datas[0].props.value +
          this.estimateDetailSummary.datas[1].props.value;
        this.$set(
          this.estimateTabData[1].estimateInformationData.createTaxSummary,
          'taxData',
          this.taxData
        );
        break;
      }
      case 'clickFixedMatterEvent': {
        // 見積確定ボタン押下
        switch (response.name) {
          case 'clickFixedMatter': {
            switch (this.screenStructureType) {
              case '1':
                // OAリース
                if (this.fractionRoundingFlag === false && this.fractionValue !== 0) {
                  // 端数処理未実施かつ端数が存在する場合のアラートダイアログ表示
                  this.alertDialogMessage = EstimateFractionRoundWording.alertFixedMatter.message;
                  this.alertDialogTitle = EstimateFractionRoundWording.alertFixedMatter.title;
                  this.isAlertDialog = true;
                } else {
                  // 実行確認ダイアログ表示
                  this.fixedMatterDialogMessage = `この見積の内容を案件「${this.estimateHeaderData.datas[2].props.value}」の確定見積として採用しますか？`;
                  this.isFixedMatterDialog = true;
                }
                break;
              default:
                // OA以外
                this.fixedMatterDialogMessage = `この見積の内容を案件「${this.estimateHeaderData.datas[2].props.value}」の確定見積として採用しますか？`;
                this.isFixedMatterDialog = true;
                break;
            }
          }
        }
        break;
      }
      case 'clickFractionRoundingEvent': {
        // 端数調整ボタン押下
        this.$store.commit('hexabase/setIsLoading', true);
        try {
          // 月額リース料が0で無い且つ端数が存在する場合に端数調整を実施
          if (
            Number(this.estimateInformationPanel.datas[8].props.value) !== 0 &&
            this.fractionValue !== 0
          ) {
            // 端数切捨て値を取得
            const roundingValue = this.calculationModel.fractionRounding(
              this.estimateInformationPanel.datas[8].props.value
            );
            // 端数切捨て値をセット
            this.estimateInformationPanel.datas[8].props.value = roundingValue;
            this.registData.item['monthly_lease_fee'] = roundingValue;

            // 調整金額算出
            this.adjustmentAmount = this.calculationModel.adjustmentAmount(
              this.estimateDetailSummary.datas[0].props.value,
              this.estimateInformationPanel.datas[7].props.value,
              this.estimateInformationPanel.datas[8].props.value
            );

            // 金額変更項目の無効化
            this.disableAmountChange();

            // 差額調整見積明細を作成
            const itemsLength = this.estimateTabData[1].estimateInformationData.estimateDetailList
              .tableParameters['body'].length;

            const addItem = JSON.parse(JSON.stringify(EstimateDatailBaseFormat));
            addItem['No'] = itemsLength + 1;
            addItem['id'] = itemsLength + 1;
            addItem['display_order'] = itemsLength + 1 - this.estimateDetailSummaryLength;
            // 税率はデフォルト値をセット
            addItem['tax_classification_id'] = this.defaultTaxData.i_id;
            addItem['tax_classification'] = this.defaultTaxData.name;
            addItem['tax_rate'] = this.defaultTaxData.tax_rate;
            // 数量:1、販売単価:調整金額、仕入単価:0 をセット
            addItem['quantity'] = 1;
            addItem['unit_price'] = this.adjustmentAmount;
            addItem['sale_price'] = this.adjustmentAmount;
            addItem['purchase_unit_price'] = 0;
            addItem['purchasing_price'] = 0;
            // 端数調整値引き用見積明細マスタの情報をセット
            addItem['item'] = this.mastermEstimateDetailFractionDiscount.item;
            addItem['remarks'] = this.mastermEstimateDetailFractionDiscount.remarks;
            // 項目名の入力可否はDB登録値で可変
            addItem['input_flag'] = JSON.parse(
              this.mastermEstimateDetailFractionDiscount.input_flag.toLowerCase()
            );
            addItem['classification_id'] = this.mastermEstimateDetailFractionDiscount.classification_id;
            addItem['classification'] = this.mastermEstimateDetailFractionDiscount.classification_id;
            addItem['type_id'] = this.mastermEstimateDetailFractionDiscount.type_id;
            addItem['type'] = this.mastermEstimateDetailFractionDiscount.type_id;

            // 各種ボタンは使用不可
            addItem['isDisabledAddButton'] = true;
            addItem['isDisabledInput'] = true;

            // 営業利益、利益率の計算
            addItem['operating_income'] = this.calculationModel.operatingIncome(
              addItem['sale_price'],
              addItem['purchasing_price']
            );
            addItem['profit_rate'] = this.calculationModel.profitRate(
              addItem['operating_income'],
              addItem['sale_price'],
              this.defaultRoundingType
            );
            this.estimateTabData[1].estimateInformationData.estimateDetailList.tableParameters[
              'body'
            ].push(addItem);

            // 差額調整見積明細用登録データの作成
            this.registEstimateDetailItemData.push({
              item: {
                display_order: Number(this.registEstimateDetailItemData.length) + 1,
                item: this.mastermEstimateDetailFractionDiscount.item,
                estimate_detail_id: this.mastermEstimateDetailFractionDiscount.i_id,
                unit_price: this.adjustmentAmount,
                purchase_unit_price: this.mastermEstimateDetailFractionDiscount.purchase_unit_price,
                quantity: 1,
                remarks: this.mastermEstimateDetailFractionDiscount.remarks,
                tax_classification_id: this.defaultTaxData.i_id
              }
            });
            // 金額再計算
            this.recalculateAmount();

            // 端数値に0をセット
            this.fractionValue = 0;

            // 端数調整実施フラグを立てる
            this.fractionRoundingFlag = true;
            this.registData.item['fraction_rounding_flag'] = this.fractionRoundingFlag.toString();

            // ボタン使用可/不可切替
            this.estimateTabData[1].estimateInformationData.estimateRateData.isFractionRoundingDisabled = true;
            this.estimateTabData[1].estimateInformationData.estimateRateData.isUndoFractionRoundingDisabled = false;
          } else {
            // 端数調整不要のダイアログメッセージ設定、表示
            this.alertDialogMessage = EstimateFractionRoundWording.alertFractionNotRequired.message;
            this.alertDialogTitle = EstimateFractionRoundWording.alertFractionNotRequired.title;
            this.isAlertDialog = true;
          }
        } catch (e) {
          console.log(e);
          // エラーをキャッチした際共通エラーダイアログにセット
          if (e instanceof Error) {
            this.setError(e.message);
          } else if (typeof e === 'string') {
            this.setError(e);
          }
        } finally {
          this.$store.commit('hexabase/setIsLoading', false);
        }
        break;
      }
      case 'clickUndoFractionRoundingEvent': {
        // 端数調整解除ボタン押下
        this.$store.commit('hexabase/setIsLoading', true);
        try {
          // 見積明細の末尾要素を取得（末尾が差額調整見積明細）
          const displayItem = this.estimateTabData[1].estimateInformationData.estimateDetailList
            .tableParameters['body'][
            this.estimateTabData[1].estimateInformationData.estimateDetailList.tableParameters[
              'body'
            ].length - 1
          ];
          // 見積表用登録データの末尾要素を取得（末尾が差額調整見積明細）
          const registItem = this.registEstimateDetailItemData[
            this.registEstimateDetailItemData.length - 1
          ];

          // 差額調整見積明細が既存の登録済データであれば見積明細の削除用データ作成
          if (registItem.i_id !== undefined) {
            if (registItem.item.estimate_detail_id !== undefined) {
              this.registEstimateDetailItemDeleteData.push({
                operation: 2,
                action_id: 'estimate_detail_valid_delete',
                rev_no: Number(displayItem['rev_no']),
                i_id: displayItem['i_id']
              });
              this.registEstimateDetailItemDeleteData.push({
                operation: 12,
                rev_no: Number(displayItem['rev_no']),
                i_id: displayItem['i_id']
              });
            }
          }

          // 見積明細、見積表用登録データの末尾要素を削除
          this.estimateTabData[1].estimateInformationData.estimateDetailList.tableParameters[
            'body'
          ].pop();
          this.registEstimateDetailItemData.pop();

          // 金額再計算
          this.recalculateAmount();

          // 金額変更項目の有効化
          this.enableAmountChange();

          // 端数調整実施フラグを下す
          this.fractionRoundingFlag = false;
          this.registData.item['fraction_rounding_flag'] = this.fractionRoundingFlag.toString();

          // ボタン使用可/不可切替
          this.estimateTabData[1].estimateInformationData.estimateRateData.isFractionRoundingDisabled = false;
          this.estimateTabData[1].estimateInformationData.estimateRateData.isUndoFractionRoundingDisabled = true;
        } catch (e) {
          console.log(e);
          // エラーをキャッチした際共通エラーダイアログにセット
          if (e instanceof Error) {
            this.setError(e.message);
          } else if (typeof e === 'string') {
            this.setError(e);
          }
        } finally {
          this.$store.commit('hexabase/setIsLoading', false);
        }
        break;
      }
      case 'clickRecalcEvent': {
        // 金額調整ボタン押下
        this.isRecalcDialog = true;
        break;
      }
    }

    // ■上の段
    // ①定価金額（構成表）
    this.estimateInformationSummary.datas[0].props.value = this.estimateInformationSummaryTotalValues(
      'noEstimateDetailList',
      'sale_price'
    );
    this.registData.item[
      'composition_table_list_price_total'
    ] = this.estimateInformationSummary.datas[0].props.value;
    // ③値引額
    // 種別マスタのtypeが「値引」の明細に加え、「端数調整値引」の明細も値引額に合算
    this.estimateInformationSummary.datas[2].props.value =
      this.calculationModel.totalValues([
        {
          tableData: this.estimateTabData[1].estimateInformationData.estimateDetailList
            .tableParameters.body,
          itemName: 'sale_price',
          sumItem: {
            display_id: 'type_id',
            targetName: '値引'
          }
        }
      ]) +
      this.calculationModel.totalValues([
        {
          tableData: this.estimateTabData[1].estimateInformationData.estimateDetailList
            .tableParameters.body,
          itemName: 'sale_price',
          sumItem: {
            display_id: 'type_id',
            targetName: '端数調整値引'
          }
        }
      ]);
    this.estimateInformationSummary.datas[2].show = false;
    // ②小計(構成表＋見積明細)※元の見積合計金額
    this.estimateInformationSummary.datas[1].props.value =
      this.estimateInformationSummaryTotalValues('', 'sale_price') -
      this.estimateInformationSummary.datas[2].props.value;
    this.registData.item['total_sales_amount'] = this.estimateDetailSummary.datas[0].props.value;
    this.registData.item['discount_amount'] = this.estimateInformationSummary.datas[2].props.value;
    this.estimateInformationSummary.datas[1].show = false;
    // ④見積合計金額(税別)
    this.estimateInformationSummary.datas[3].props.value =
      this.estimateInformationSummary.datas[1].props.value +
      this.estimateInformationSummary.datas[2].props.value;
    this.registData.item[
      'estimated_tax_excluded'
    ] = this.estimateInformationSummary.datas[3].props.value;
    // ■下の段
    // ⑤消費税率、⑥消費税額、⑦合計金額(税込)
    this.estimateInformationSummaryTaxAmount();
    this.registData.item['sales_tax_rate'] = Number(
      this.estimateInformationSummary.datas[4].props.value
    );
    this.registData.item['consumption_tax'] = this.estimateDetailSummary.datas[1].props.value;
    this.registData.item['total_tax_included'] = this.estimateDetailSummary.datas[2].props.value;
    this.estimateInformationSummary.datas[4].show = false;
    // ⑧営業利益合計
    // 営業利益合計(例外リストに存在し、項目が表示されてる場合は計算する)
    if (this.exceptionHeaderItem.includes('transfer_amount_price')) {
      this.estimateInformationSummary.datas[7].props.value = this.estimateInformationSummaryTotalValues(
        '',
        'operating_income'
      );
      this.registData.item[
        'total_operating_profit'
      ] = this.estimateInformationSummary.datas[7].props.value;
    }
    // ⑨営業利益率
    // 営業利益率(例外リストに存在し、項目が表示されてる場合は計算する)
    if (this.exceptionHeaderItem.includes('profit_rate')) {
      this.estimateInformationSummary.datas[8].props.value = this.operatingProfitMargin();
      const strIndex = this.estimateInformationSummary.datas[8].props.value.indexOf('%');
      const str = this.estimateInformationSummary.datas[8].props.value.substring(0, strIndex);
      this.registData.item['operating_profit_margin'] = Number(str);
    }
    // 月額リース料の計算
    if (this.screenStructureType === '1') {
      // OAリース
      if (
        this.estimateDetailSummary.datas[0].props.value !== 0 &&
        this.fractionRoundingFlag === false &&
        this.isEstimateConfirmed === false
      ) {
        // 計算前の値を退避
        const beforeCalcValue = this.registData.item['monthly_lease_fee'];
        const rateItem = this.estimateInformationPanel.datas[7].props.value;
        if (rateItem !== undefined) {
          const cost = this.calculationModel.monthlyLeaseCost(
            this.estimateDetailSummary.datas[0].props.value,
            rateItem
          );
          this.estimateInformationPanel.datas[8].props.value = cost;
          this.fractionValue = this.calculationModel.fractionProcess(cost);
        }
        this.registData.item['monthly_lease_fee'] = Number(
          this.estimateInformationPanel.datas[8].props.value
        );

        // 以下の条件を満たした場合に承認事前与信との比較
        // ・事前与信チェックダイアログ未表示
        // ・リース会社選択済み
        // ・「承認」案件与信OAデータ情報あり
        // ・月額リース料が変わった
        if (
          this.isCreditCheckDialogDisplayed === false &&
          this.registData.item['leasing_company_id'] &&
          this.approvedProjectCreditOaItems.length > 0 &&
          beforeCalcValue !== this.registData.item['monthly_lease_fee']
        ) {
          // リース会社が合致し、月額リース料が編集画面の値より小さい承認事前与信を抽出
          const hitItems = this.approvedProjectCreditOaItems.filter(
            (v: { leasing_company_id: string; approval_monthly_lease_fee: number }) =>
              v.leasing_company_id === this.registData.item['leasing_company_id'] &&
              v.approval_monthly_lease_fee < this.registData.item['monthly_lease_fee']
          );
          if (hitItems.length > 0) {
            // 抽出されたデータがあれば事前与信チェックダイアログ表示
            // ※事前与信チェックダイアログは初回だけ表示
            this.isCreditCheckDialog = true;
            this.isCreditCheckDialogDisplayed = true;
          }
        }
      }
    }
  }

  private getHeaderFields(formData: any) {
    const baseData = {
      cols: {},
      datas: {} as { [k: string]: any }
    };
    try {
      baseData.cols = this.estimate.getGridStatus(formData);
      baseData.datas = formData;
    } catch (errorMessage) {
      if (errorMessage instanceof Error) {
        this.setError(errorMessage.message);
      } else if (typeof errorMessage === 'string') {
        this.setError(errorMessage);
      }
    }
    return baseData;
  }

  private getHeaderData(setData: { [key: string]: any }, baseData: any) {
    try {
      Object.keys(setData).map((key: string) => {
        baseData.datas[key].props['value'] = setData[key];
      });
    } catch (errorMessage) {
      if (errorMessage instanceof Error) {
        this.setError(errorMessage.message);
      } else if (typeof errorMessage === 'string') {
        this.setError(errorMessage);
      }
    }
  }

  private estimateInformationSummaryTotalValues(formatType: string, str: string) {
    const totalBaseData = [];
    const partsList = {
      tableData: this.estimateTabData[0].configurationTableData.partsList.tableParameters.body,
      itemName: str
    };

    const detailAddList = {
      tableData: this.estimateTabData[0].configurationTableData.detailAddList.tableParameters.body,
      itemName: str
    };

    const estimateNotDupData = [];
    for (const index in this.estimateTabData[1].estimateInformationData.estimateDetailList.tableParameters.body) {
        const baseItems = this.estimateTabData[1].estimateInformationData.estimateDetailList.tableParameters.body[
          index
        ];
        if (baseItems['classification'] !== undefined) {
          estimateNotDupData.push(baseItems);
        }
    }

    const estimateDetailList = {
      tableData: estimateNotDupData,
      itemName: str
    };

    totalBaseData.push(partsList);
    totalBaseData.push(detailAddList);
    if (formatType !== 'noEstimateDetailList') {
      totalBaseData.push(estimateDetailList);
    }
    const total = this.calculationModel.totalValues(totalBaseData);
    return total;
  }

  private estimateInformationSummaryTaxAmount() {
    this.estimateInformationSummary.datas[5].props.value = this.calculationModel.taxAmount(
      this.estimateInformationSummary.datas[4].props.value,
      this.estimateInformationSummary.datas[3].props.value,
      'taxOnly',
      { calculationType: 'floor' }
    );
    this.estimateInformationSummary.datas[6].props.value = this.calculationModel.taxAmount(
      this.estimateInformationSummary.datas[4].props.value,
      this.estimateInformationSummary.datas[3].props.value,
      'taxIncluded',
      { calculationType: 'floor' }
    );
  }

  private operatingProfitMargin() {
    let sum = 0;
    let marginCount = 0;
    let baseArray = [];
    if (this.estimateTabData[1].estimateInformationData.estimateDetailList.isEstimateAddItemButtonFlag === false) {
      baseArray = [
        this.estimateTabData[0].configurationTableData.partsList.tableParameters.body,
        this.estimateTabData[0].configurationTableData.detailAddList.tableParameters.body,
      ];
    } else {
      baseArray = [
        this.estimateTabData[0].configurationTableData.partsList.tableParameters.body,
        this.estimateTabData[0].configurationTableData.detailAddList.tableParameters.body,
        this.estimateTabData[1].estimateInformationData.estimateDetailList.tableParameters.body
      ];
    }

    for (const indexA in baseArray) {
      for (const indexB in baseArray[indexA]) {
        const strIndex = baseArray[indexA][indexB]['profit_rate'].indexOf('%');
        const str = baseArray[indexA][indexB]['profit_rate'].substring(0, strIndex);
        if (baseArray[indexA][indexB]['profit_rate'] !== undefined && Number(str) !== 0) {
          sum += Number(str);
          marginCount++;
        }
      }
    }

    sum = sum / marginCount;
    if (isNaN(sum) || isFinite(sum) === false || '-Infinity' === String(sum)) {
      sum = 0;
    }
    sum = this.calculationModel.roundingProcess(sum, { calculationType: 'decimalRound', digit: 1 });
    return String(sum) + '%';
  }

  /**
   * 前画面に戻る
   */
  private movePrevious() {
    this.$router.replace({ name: 'MatterEdit', params: { id: this.matterItemId } });
  }

  /**
   * 帳票出力ダイアログ表示
   */
  private async displayFormDialog(searchScene: string): Promise<void> {
    try {
      this.pushFormButtonType = searchScene;
      this.$store.commit('hexabase/setIsLoading', true);
      // ダイアログ要素初期化
      this.isAlert = false;
      this.alertMessage = '';
      this.formOutputFieldsData = [];

      this.formOutputFieldsData = await this.estimate.outputFormDialogFieldData(
        searchScene,
        this.projectId,
        this.formOutputDsId,
        searchScene === '構成表出力' ? materialOptionalOutPutFormPO : optionalOutPutFormPO
      );
      const ex = optionalOutPutFormPO.find(
        (data: { display_id: string }) => data.display_id === 'issued_date'
      ) as any;
      this.formOutputFieldsData.push(ex);
      this.formType = this.formOutputFieldsData
        .map(field => {
          return field.display_id === inputNames.type ? field.props!.selectData.options : undefined;
        })
        .filter(value => value)[0];
      this.formTemplateList = this.formOutputFieldsData
        .map(field => {
          return field.display_id === inputNames.templateName
            ? field.props!.selectData.options
            : undefined;
        })
        .filter(value => value)[0];
      this.formOutputDialogStatus = true;
    } catch (error) {
      console.log(error);
      // エラーをキャッチした際共通エラーダイアログにセット
      if (error instanceof Error) {
        this.setError(error.message);
      } else if (typeof error === 'string') {
        this.setError(error);
      }
    } finally {
      this.$store.commit('hexabase/setIsLoading', false);
    }
  }

  /**
   * 帳票出力処理
   * @returns void
   */
  private async formOutputDialog(input: { [k: string]: any }) {
    if (!input.isAgree && input.isOutSide === undefined) {
      this.formOutputDialogStatus = false;
      input.data = [];
    } else if (input.isAgree) {
      try {
        this.isformOutputLoading = true;
        // 現在のデータを再取得
        const estimateInformationResult = await this.estimate.getLinkedItems(
          hexabaseState.applicationId,
          this.passedDatastoreId,
          this.passedItemId,
          '&use_display_id=true'
        );
        // 構成表取得
        const partsListData = [];
        estimateInformationResult.linked_items['t_material'].items.sort(
          (a: any, b: any) => a.display_order - b.display_order
        );
        for (const index in estimateInformationResult.linked_items['t_material'].items) {
          const baseItems = estimateInformationResult.linked_items['t_material'].items[index];
          baseItems['No'] = Number(index) + 1;
          // lookup_itemsから各データを設定
          baseItems['item'] = baseItems.lookup_items.material_id.item;
          baseItems['model_number'] = baseItems.lookup_items.material_id.model_number;
          baseItems['classification_id'] =
            baseItems.lookup_items.material_id.lookup_items.classification_id.classification;
          baseItems['classification'] =
            baseItems.lookup_items.material_id.lookup_items.classification_id.classification;
          baseItems['type_id'] = baseItems.lookup_items.material_id.lookup_items.type_id.type;
          baseItems['type'] = baseItems.lookup_items.material_id.lookup_items.type_id.type;
          baseItems['item_code'] = baseItems.lookup_items.material_id.item_code;
          if (baseItems.lookup_items.material_id.transfer_unit_price !== undefined) {
            baseItems['reference_transfer_unit_price'] = baseItems.lookup_items.material_id.transfer_unit_price;
          }
          // 計算
          baseItems['sale_price'] = baseItems['standard_unit_price'] * baseItems['quantity'];
          baseItems['transfer_amount_price'] =
            baseItems['transfer_unit_price'] * baseItems['quantity'];
          baseItems['operating_income'] = this.calculationModel.operatingIncome(
            baseItems['sale_price'],
            baseItems['transfer_amount_price']
          );
          baseItems['profit_rate'] = this.calculationModel.profitRate(
            this.calculationModel.operatingIncome(
              baseItems['sale_price'],
              baseItems['transfer_amount_price']
            ),
            baseItems['sale_price'],
            this.defaultRoundingType
          );
          partsListData.push(baseItems);
        }
        // 構成表 構成明細
        let partsListDataParse = [];
        for (const key in partsListData) {
          partsListDataParse.push({
            classification: partsListData[key].classification,
            type: partsListData[key].type,
            item: partsListData[key].item,
            item_code: partsListData[key].item_code,
            model_number: partsListData[key].model_number,
            standard_unit_price: partsListData[key].standard_unit_price,
            unit_price: partsListData[key].standard_unit_price,
            quantity: partsListData[key].quantity,
            sale_price: partsListData[key].sale_price,
            remarks: partsListData[key].remarks,
            transfer_unit_price: partsListData[key].transfer_unit_price,
            tax_rate: partsListData[key].lookup_items.tax_classification_id.tax_rate
          });
        }

        // 明細追加入力一覧の作成
        const detailAddListData = [];
        estimateInformationResult.linked_items['t_datail_add_input'].items.sort(
          (a: any, b: any) => a.display_order - b.display_order
        );

        for (const index in estimateInformationResult.linked_items['t_datail_add_input'].items) {
          const baseItems =
            estimateInformationResult.linked_items['t_datail_add_input'].items[index];
          baseItems['No'] = Number(index) + 1;
          // lookup_itemsから各データを設定
          baseItems['classification_id'] =
            baseItems.lookup_items.datail_add_input_id.lookup_items.classification_id.classification;
          baseItems['classification'] =
            baseItems.lookup_items.datail_add_input_id.lookup_items.classification_id.classification;
          baseItems['type_id'] =
            baseItems.lookup_items.datail_add_input_id.lookup_items.type_id.type;
          baseItems['type'] = baseItems.lookup_items.datail_add_input_id.lookup_items.type_id.type;
          baseItems['item_code'] = baseItems.lookup_items.datail_add_input_id.item_code;
          if (baseItems.lookup_items.datail_add_input_id.purchase_unit_price !== undefined) {
            baseItems['reference_purchase_unit_price'] = JSON.parse(
              JSON.stringify(baseItems.lookup_items.datail_add_input_id.purchase_unit_price)
            );
          }
          baseItems['tax_rate'] = baseItems.lookup_items.tax_classification_id.tax_rate;
          // 計算
          baseItems['sale_price'] = baseItems['standard_unit_price'] * baseItems['quantity'];
          baseItems['purchasing_price'] = baseItems['purchase_unit_price'] * baseItems['quantity'];
          baseItems['operating_income'] = this.calculationModel.operatingIncome(
            baseItems['sale_price'],
            baseItems['purchasing_price']
          );
          baseItems['profit_rate'] = this.calculationModel.profitRate(
            this.calculationModel.operatingIncome(
              baseItems['sale_price'],
              baseItems['purchasing_price']
            ),
            baseItems['sale_price'],
            this.defaultRoundingType
          );
          detailAddListData.push(baseItems);
        }

        // 構成表 明細追加入力
        let detailAddListDataParse = detailAddListData.map((list: any) => ({...list}));

        // 見積表の作成
        const estimateDetailListData = [];
        estimateInformationResult.linked_items['t_estimate_detail'].items.sort(
          (a: any, b: any) => a.display_order - b.display_order
        );
        for (const index in estimateInformationResult.linked_items['t_estimate_detail'].items) {
          const baseItems =
            estimateInformationResult.linked_items['t_estimate_detail'].items[index];
          baseItems['No'] = Number(index) + 1;
          // lookup_itemsから各データを設定
          baseItems['classification_id'] =
            baseItems.lookup_items.estimate_detail_id.lookup_items.classification_id.classification;
          baseItems['classification'] =
            baseItems.lookup_items.estimate_detail_id.lookup_items.classification_id.classification;
          baseItems['type_id'] =
            baseItems.lookup_items.estimate_detail_id.lookup_items.type_id.type;
          baseItems['type'] = baseItems.lookup_items.estimate_detail_id.lookup_items.type_id.type;
          baseItems['item_code'] = baseItems.lookup_items.estimate_detail_id.item_code;
          if (baseItems.lookup_items.estimate_detail_id.purchase_unit_price !== undefined) {
            baseItems['reference_purchase_unit_price'] = JSON.parse(
              JSON.stringify(baseItems.lookup_items.estimate_detail_id.purchase_unit_price)
            );
          }
          // 計算
          baseItems['sale_price'] = baseItems['unit_price'] * baseItems['quantity'];
          baseItems['purchasing_price'] = baseItems['purchase_unit_price'] * baseItems['quantity'];
          baseItems['operating_income'] = this.calculationModel.operatingIncome(
            baseItems['sale_price'],
            baseItems['purchasing_price']
          );
          baseItems['profit_rate'] = this.calculationModel.profitRate(
            this.calculationModel.operatingIncome(
              baseItems['sale_price'],
              baseItems['purchasing_price']
            ),
            baseItems['sale_price'],
            this.defaultRoundingType
          );
          estimateDetailListData.push(baseItems);
        }

        // 見積表 見積明細
        const estimateDetailListDataParse = [];
        // 種別「値引」または数量0を除いた見積明細行を対象としてデータ整形する
        const targetEstimateDetailListData = estimateDetailListData.filter(
          (v: { type: string; quantity: number }) => v.type !== '値引' && Number(v.quantity) !== 0
        );
        for (const key in targetEstimateDetailListData) {
          estimateDetailListDataParse.push({
            classification: targetEstimateDetailListData[key].classification,
            type: targetEstimateDetailListData[key].type,
            item: targetEstimateDetailListData[key].item,
            unit_price: targetEstimateDetailListData[key].unit_price,
            quantity: targetEstimateDetailListData[key].quantity,
            sale_price: targetEstimateDetailListData[key].sale_price
          });
        }
        // 種別「値引」かつ数量0でない項目を対象としてデータ整形する
        const estimateDetailDiscountListDataParse = [];
        const targetEstimateDetailDiscountListData = estimateDetailListData.filter(
          (v: { type: string; quantity: number }) => v.type === '値引' && Number(v.quantity) !== 0
        );
        for (const key in targetEstimateDetailDiscountListData) {
          estimateDetailDiscountListDataParse.push({
            classification: targetEstimateDetailDiscountListData[key].classification,
            type: targetEstimateDetailDiscountListData[key].type,
            item: targetEstimateDetailDiscountListData[key].item,
            unit_price: targetEstimateDetailDiscountListData[key].unit_price,
            quantity: targetEstimateDetailDiscountListData[key].quantity,
            sale_price: targetEstimateDetailDiscountListData[key].sale_price
          });
        }
        // 帳票マスタのファイルを取得
        const formMasterRecord = await this.estimate.getLinkedItems(
          hexabaseState.applicationId,
          hexabaseState.datastoreIds['帳票マスタ'],
          input.data.form_type.value,
          '&use_display_id=true'
        );
        let templateFileId = '';
        if (formMasterRecord.field_values.docurain_template_file.value.length > 0) {
          templateFileId = formMasterRecord.field_values.docurain_template_file.value[0].file_id;
        } else {
          throw new Error('作成帳票にテンプレートファイルが登録されていません');
        }

        // 選択された帳票種別を判定
        // 選択された帳票種別からグループ化マスタのデータをAPIから取得
        const groupingRule = await this.estimate.getItemList(
          hexabaseState.applicationId,
          hexabaseState.datastoreIds['グループ化マスタ'],
          {
            conditions: [
              {
                id: 'form_id',
                search_value: [input.data.form_type.value]
              }
            ],
            page: 1,
            per_page: 0,
            use_display_id: true,
            return_number_value: true,
            include_lookups: true
          }
        );

        // 構成表出力する場合に使用する
        const kouseihyoListData = partsListDataParse.concat(detailAddListDataParse);

        // グループ化マスタに対象の帳票が含まれている場合、取得した定義に基づいたグルーピング処理を実行
        if (groupingRule.length > 0) {
          // 帳票マスタの帳票出力構成表グルーピングフラグからグルーピング出力の可否
          if (formMasterRecord.field_values['output_form_parts_list_grouping_flag'].value === 'true' ) {
            this.addGroupId(
              partsListDataParse,
              groupingRule.filter(v => v.item_classification === '構成表')
            );
            partsListDataParse = this.createGroupByGroupId(partsListDataParse).filter(
              (v: { sale_price: number }) => v.sale_price !== 0
            );
          }

          // 帳票マスタの帳票出力明細追加入力グルーピングフラグからグルーピング出力の可否
          if (formMasterRecord.field_values['output_form_detail_add_list_grouping_flag'].value === 'true' ) {
            this.addGroupId(
              detailAddListDataParse,
              groupingRule.filter(v => v.item_classification === '明細追加入力')
            );
            detailAddListDataParse = this.createGroupByGroupId(detailAddListDataParse).filter(
              (v: { sale_price: number }) => v.sale_price !== 0
            );
          } else {
            for (const index in detailAddListDataParse) {
              // 見積表の単価が販売単価(unit_price)なので追加明細入力の標準単価(standard_unit_price)を転記
              detailAddListDataParse[index]['unit_price'] = detailAddListDataParse[index]['standard_unit_price'];
              // 見積表の単価が振替単価(transfer_unit_price)なので追加明細入力の仕入単価(purchase_unit_price)を転記
              detailAddListDataParse[index]['transfer_unit_price'] =  detailAddListDataParse[index]['purchase_unit_price'];
            }
          }
        }

        const customer = this.matterServiceInformationResult.linked_items.t_project_basic_infomation
          .items[0].lookup_items.customer_id;
        const customerDepartment = this.matterServiceInformationResult.linked_items
          .t_project_basic_infomation.items[0].lookup_items.department_delivery_destination_id;
        // 複数項目から住所を生成
        let str = customerDepartment.prefectures ? String(customerDepartment.prefectures): '';
        str += customerDepartment.municipalities ? String(customerDepartment.municipalities): '';
        str += customerDepartment.machimura_street_address
          ? String(customerDepartment.machimura_street_address)
          : '';
        const installation_address = str;
        const building_name = customerDepartment.building_name ? String(customerDepartment.building_name) : '';
        // 複数項目から担当者の住所を生成
        const estimatorData = this.matterServiceInformationResult.linked_items[
          't_project_basic_infomation'
        ].items[0].lookup_items.manager_id;
        let set_estimator_jusyo_str = estimatorData.prefectures ? String(estimatorData.prefectures) : '';
        set_estimator_jusyo_str += estimatorData.municipalities ? String(estimatorData.municipalities) : '';
        set_estimator_jusyo_str += estimatorData.machimura_street_address
          ? String(estimatorData.machimura_street_address)
          : '';
        const estimator_jusyo_str = set_estimator_jusyo_str;
        const estimator_jusyo_building_name = estimatorData.building_name ? String(estimatorData.building_name) : '';
        const estimator_telephone_number = estimatorData.telephone_number;
        // formTypeに応じてroot_listの内容を変更
        // 見積書の場合
        if (this.estimateTabData[1].estimateInformationData.estimateDetailList.isEstimateAddItemButtonFlag === false) {
          // 帳票出力するアイテムデータの初期化
          this.outputDataItems = [];
          for (const index in partsListDataParse) {
            this.outputDataItems.push(partsListDataParse[index]);
          }
          for (const index in detailAddListDataParse) {
            this.outputDataItems.push(detailAddListDataParse[index]);
          }
        } else {
          this.outputDataItems =
            (groupingRule.length > 0
              ? this.createGroupByGroupId(
                  partsListDataParse.concat(detailAddListDataParse)
                )
              : kouseihyoListData.filter(
                  (v: { quantity: number }) => Number(v.quantity) !== 0
                )
            ).concat(estimateDetailListDataParse)
        }

        const taxDatas: any = this.taxData;
        this.modifyTaxDatas(taxDatas);

        const kouseihyoTaxDatas = this.createGroupByTaxClassificationId(
          this.estimateTabData[0].configurationTableData.partsList.tableParameters['body'].concat(
            this.estimateTabData[0].configurationTableData.detailAddList.tableParameters['body']
          )
        );
        this.modifyTaxDatas(kouseihyoTaxDatas);

        const payload =
          this.pushFormButtonType === '見積書出力'
            ? {
                root_list: [
                  {
                    mitsumorisho: {
                      postal_code: customerDepartment.postal_code,
                      jusyo: installation_address,
                      billding_name: building_name,
                      department_name:
                        customerDepartment.head_office_judgment_flag === '本社'
                          ? customer.customer_name
                          : `${customer.customer_name} ${customerDepartment.department_name}`,
                      manager: customerDepartment.manager,
                      issued_date: input.data.issued_date.value,
                      estimate_id: this.estimateInformationResult.field_values.estimate_id.value,
                      estimated_tax_excluded: this.estimateInformationResult.field_values
                        .estimated_tax_excluded.value,
                      monthly_lease_fee: this.estimateInformationResult.field_values
                        .monthly_lease_fee
                        ? this.estimateInformationResult.field_values.monthly_lease_fee.value
                        : '',
                      leasing_company_id:
                        this.estimateInformationResult.field_values.leasing_company_id &&
                        this.estimateInformationResult.field_values.leasing_company_id.value
                          ? this.estimateInformationResult.field_values.leasing_company_id
                              .value.title
                          : '',
                      discount_amount: this.estimateInformationResult.field_values.discount_amount
                        .value,
                      consumption_tax: this.estimateInformationResult.field_values.consumption_tax
                        .value,
                      total_tax_included: this.estimateInformationResult.field_values
                        .total_tax_included.value,
                      contract_months_calculation_disp: this.estimateInformationResult.field_values
                        .contract_months
                        ? Number(
                            this.estimateInformationResult.field_values.contract_months.value
                          ) /
                            12 +
                          '年' +
                          this.estimateInformationResult.field_values.contract_months.value +
                          '回'
                        : '',
                      items: this.outputDataItems,
                      discount_items: estimateDetailDiscountListDataParse,
                      tax_classification_items: taxDatas,
                      estimator_name: estimatorData.name,
                      estimator_jusyo: estimator_jusyo_str,
                      estimator_jusyo_building_name: estimator_jusyo_building_name,
                      estimator_telephone_number: estimator_telephone_number
                    }
                  }
                ]
              }
            : {
                root_list: [
                  {
                    kouseihyo: {
                      title: this.estimateInformationResult.field_values.commodity_id.value.title,
                      items: kouseihyoListData,
                      tax_classification_items: kouseihyoTaxDatas
                    }
                  }
                ]
              };
        const fileName = this.pushFormButtonType === '見積書出力' ? '見積書' : '構成表';
        const resultList = await this.estimate.getForm(
          this.projectId,
          this.estimateDsId,
          this.passedItemId,
          'output',
          input.data.output_format.value,
          templateFileId,
          payload,
          fileName
        );

        if (this.pushFormButtonType === '見積書出力') {
          // 見積書発行履歴payloadを設定
          const estimateIssuanceHistoryPayload = {
            action_id: 'insert',
            item: {
              estimate_id: this.estimateInformationResult.field_values.estimate_id.value,
              issuer: userState.getUserName,
              issue_datetime: DateTime.local().toString()
            },
            related_ds_items: {},
            return_item_result: true
          };
          // 親見積への関連を設定
          const relatedEstimateInformation = {
            i_id: this.passedItemId,
            link_to_parent: true,
            operation: 11
          };
          this.$set(estimateIssuanceHistoryPayload.related_ds_items, this.passedDatastoreId, [
            relatedEstimateInformation
          ]);
          // 見積書発行履歴に追加
          await this.estimate.registerLinkedItems(
            hexabaseState.applicationId,
            hexabaseState.datastoreIds['見積書発行履歴'],
            estimateIssuanceHistoryPayload
          );
        }
        this.formOutputDialogStatus = false;
        input.data = [];
      } catch (error) {
        this.isAlert = true;
        if (error instanceof Error) {
          this.alertMessage = error.message;
        } else if (typeof error === 'string') {
          this.alertMessage = error;
        }
      } finally {
        this.isformOutputLoading = false;
      }
    }
  }

  /**
   * 見積明細のサマリ更新処理
   */
  private async updateEstimateDetailSummary() {
    let partsListDataParse = this.estimateTabData[0].configurationTableData.partsList.tableParameters.body
    let detailAddListDataParse = [] as any;
    for (const key in this.estimateTabData[0].configurationTableData.detailAddList.tableParameters.body) {
      detailAddListDataParse.push(this.estimateTabData[0].configurationTableData.detailAddList.tableParameters.body[key]);
      detailAddListDataParse['unit_price'] = this.estimateTabData[0].configurationTableData.detailAddList.tableParameters.body[key].standard_unit_price
      detailAddListDataParse['transfer_unit_price'] = this.estimateTabData[0].configurationTableData.detailAddList.tableParameters.body[key].standard_unit_price
    }

    detailAddListDataParse = detailAddListDataParse.filter((items: any) => {
      return items.item !== '';
    });

    const groupingRule = this.groupingRule;
    // グループ化マスタに対象の帳票が含まれている場合、取得した定義に基づいたグルーピング処理を実行
    if (groupingRule.length > 0) {
      // 帳票マスタの帳票出力構成表グルーピングフラグからグルーピング出力の可否
      if (this.serviceTypeItems.estimate_list_in_parts_list_grouping_flag === 'true' ) {
        this.addGroupId(
          partsListDataParse,
          groupingRule.filter((v:any) => v.item_classification === '構成表')
        );
        partsListDataParse = this.createGroupByGroupId(partsListDataParse).filter(
          (v: { sale_price: number }) => v.sale_price !== 0
        );
      }

      // 帳票マスタの帳票出力明細追加入力グルーピングフラグからグルーピング出力の可否
      if (this.serviceTypeItems.estimate_list_in_detail_add_list_grouping_flag === 'true' ) {
        this.addGroupId(
          detailAddListDataParse,
          groupingRule.filter((v:any) => v.item_classification === '明細追加入力')
        );
        detailAddListDataParse = this.createGroupByGroupId(detailAddListDataParse).filter(
          (v: { sale_price: number }) => v.sale_price !== 0
        );
      } else {
        for (const index in detailAddListDataParse) {
          // 見積表の単価が販売単価(unit_price)なので追加明細入力の標準単価(standard_unit_price)を転記
          detailAddListDataParse[index]['unit_price'] = detailAddListDataParse[index]['standard_unit_price'];
          // 見積表の単価が振替単価(transfer_unit_price)なので追加明細入力の仕入単価(purchase_unit_price)を転記
          detailAddListDataParse[index]['transfer_unit_price'] =  detailAddListDataParse[index]['purchase_unit_price'];
        }
      }
    }
    const kouseihyoListData = JSON.parse(JSON.stringify(partsListDataParse.concat(detailAddListDataParse)));
    partsListDataParse = kouseihyoListData;

    if (this.estimateTabData[1].estimateInformationData.estimateDetailList.isEstimateAddItemButtonFlag === false) {
      this.detailListData.splice(0);
      for (const index in partsListDataParse) {
        const baseData = JSON.parse(JSON.stringify(partsListDataParse[index]));
        baseData.No = Number(index) + 1;
        baseData.profit_rate = "0%";
        baseData.input_flag = false;
        baseData.isDisabledAddButton = true;
        baseData.isDisabledInput = true;

        this.detailListData.push(baseData);
      }
    }
  }

  private addGroupId(listData: Array<any>, groupingRule: Array<any>) {
    // 各レコードの区分と種別を確認し、グループ化マスタのIDを付与する
    for (const key in listData) {
      // グループ化マスタと突き合わせ
      for (const groupKey in groupingRule) {
        if (
          listData[key].classification === groupingRule[groupKey].classification_id &&
          listData[key].type === groupingRule[groupKey].type_id
        ) {
          listData[key].group_id = groupingRule[groupKey].category;
          listData[key].item_name = groupingRule[groupKey].item_name;
          break;
        }
        if (
          listData[key].classification === groupingRule[groupKey].classification_id &&
          groupingRule[groupKey].type_id === 'その他'
        ) {
          listData[key].group_id = groupingRule[groupKey].category;
          listData[key].item_name = groupingRule[groupKey].item_name;
          break;
        }
        if (
          groupingRule[groupKey].classification_id === 'その他' &&
          listData[key].type === groupingRule[groupKey].type_id
        ) {
          listData[key].group_id = groupingRule[groupKey].category;
          listData[key].item_name = groupingRule[groupKey].item_name;
          break;
        }
        if (
          groupingRule[groupKey].classification_id === 'その他' &&
          groupingRule[groupKey].type_id === 'その他'
        ) {
          listData[key].group_id = groupingRule[groupKey].category;
          listData[key].item_name = groupingRule[groupKey].item_name;
          break;
        }
      }
    }
  }

  private createGroupByGroupId(listData: Array<any>) {
    // グルーピング処理
    const group = listData.reduce(function(result, current) {
      const element = result.find(function(p: { group_id: string }) {
        return p.group_id === current.group_id;
      });
      if (element) {
        element.unit_price +=
          Number(
            current.unit_price !== undefined ? current.unit_price : current.standard_unit_price
          ) * Number(current.quantity);
        element.sale_price += Number(current.sale_price);
        element.purchasing_price += Number(current.transfer_unit_price);
        element.purchase_unit_price += Number(current.transfer_unit_price);
        element.reference_purchase_unit_price += Number(current.transfer_unit_price);
      } else {
        result.push({
          group_id: current.group_id,
          item: current.item_name ? current.item_name : current.item,
          quantity: 1,
          unit_price:
            Number(
              current.unit_price !== undefined ? current.unit_price : current.standard_unit_price
            ) * Number(current.quantity),
          sale_price: Number(current.sale_price),
          purchasing_price: Number(current.transfer_unit_price),
          purchase_unit_price: Number(current.transfer_unit_price),
          reference_purchase_unit_price: Number(current.transfer_unit_price)
        });
      }
      return result;
    }, []);
    return group;
  }

  private createGroupByTaxClassificationId(listData: Array<any>) {
    const group = listData.reduce(function(result: any, current: any) {
      const element = result.find(function(p: { tax_classification_id: string }) {
        return p.tax_classification_id === current.tax_classification_id;
      });
      if (element) {
        element.amount +=
          Number(
            current.unit_price !== undefined ? current.unit_price : current.standard_unit_price
          ) * Number(current.quantity);
      } else {
        if (current.tax_classification && Number(current.quantity) !== 0) {
          result.push({
            name: current.tax_classification,
            tax_classification_id: current.tax_classification_id,
            tax_rate: current.tax_rate ? current.tax_rate : 0,
            amount:
              Number(
                current.unit_price !== undefined ? current.unit_price : current.standard_unit_price
              ) * Number(current.quantity)
          });
        }
      }
      return result;
    }, []);
    for (const key in group) {
      // 小数点以下の消費税は切り捨て
      group[key].tax = Math.floor(
        (Number(group[key].amount) * Number(group[key].tax_rate ? group[key].tax_rate : 0)) / 100
      );
      group[key].tax_included_amount = Number(group[key].amount) + Number(group[key].tax);
    }
    return group;
  }

  private async clearExecDialog(response: any) {
    if (response !== undefined && response.isAgree) {
      // 端数有で更新の確認ができたので登録を行う
      this.fractionValue = 0;
      this.execAction(this.execActionType);
    }
    this.isExecDialog = false;
  }

  private dataFindItem(
    findData: any,
    findDataString: string,
    findConditionsItem: string | number,
    isEquivalent = true
  ) {
    const item = findData.find((item: any) => {
      if (isEquivalent === true) {
        if (item[findDataString] === findConditionsItem) {
          return item;
        }
      } else {
        if (item[findDataString] !== findConditionsItem) {
          return item;
        }
      }
    });
    return item;
  }

  private dataFindIndex(
    findData: any,
    findDataString: string,
    findConditionsItem: string | number,
    isEquivalent = true
  ) {
    const index = findData.findIndex((item: any) => {
      if (isEquivalent === true) {
        if (item[findDataString] === findConditionsItem) {
          return item;
        }
      } else {
        if (item[findDataString] !== findConditionsItem) {
          return item;
        }
      }
    });
    return index;
  }

  private filterDataItem(
    filterData: any,
    filterDataString: string,
    filterConditionsItem: string | number,
    isEquivalent = true
  ) {
    const item = filterData.filter((item: any) => {
      if (isEquivalent === true) {
        if (item[filterDataString] === filterConditionsItem) {
          return item;
        }
      } else {
        if (item[filterDataString] !== filterConditionsItem) {
          return item;
        }
      }
    });
    return item;
  }

  /**
   * タブ内パネル入力イベント
   * @param {string} - イベント情報として押下したボタン種類が返ってくる
   */
  private async clickFixedMatterEvent(response: any) {
    if (response.isAgree) {
      this.isFixedMatterLoading = true;

      const matterServiceInformationResult = await this.estimate.getLinkedItems(
        hexabaseState.applicationId,
        this.matterServiceDsId,
        this.projectServiceItemId,
        '&use_display_id=true'
      );
      // 他に見積確定されているアイテムがあるか確認
      // サービス種別によって参照先テーブルを変更
      const estimateBasicDsDisplayId: any = (() => {
        switch (this.screenStructureType) {
          case '1':
            return 't_estimate_basic_infomation_OA';
          case '99':
            return 't_estimate_basic_infomation_general';
          case '2':
            return 't_estimate_basic_infomation_fjapan';
          default:
        }
      })();

      // const estimateBasicDsDisplayId =
      //   this.screenStructureType === '1'
      //     ? 't_estimate_basic_infomation_OA'
      //     : 't_estimate_basic_infomation_general';
      // 親案件に紐づいていて、ステータスが見積確定かつ自身以外のアイテムを抽出
      const estimateConfirmedItems = matterServiceInformationResult.linked_items[
        estimateBasicDsDisplayId
      ].items.filter(
        (v: { Status: string; i_id: string }) =>
          v.Status === '見積確定' && v.i_id !== this.passedItemId
      );
      // 対象の他見積確定ステータスの見積について「見積確定を解除する」アクション実行
      await Promise.all(
        estimateConfirmedItems.map(async (item: { [k: string]: string }) => {
          const estimateConfirmedCancel: any = (() => {
            switch (this.screenStructureType) {
              case '1':
                return 'estimate_basic_info_OA_estimate_confirmed_cancel';
              case '99':
                return 'estimate_basic_info_general_estimate_confirmed_cancel';
              case '2':
                return 'estimate_basic_info_fjapan_estimate_confirmed_cancel';
              default:
            }
          })();
          await this.estimate.changeStatus(
            hexabaseState.applicationId,
            estimateBasicDsDisplayId,
            item.i_id,
            estimateConfirmedCancel,
            // this.screenStructureType === '1'
            //   ? 'estimate_basic_info_OA_estimate_confirmed_cancel'
            //   : 'estimate_basic_info_general_estimate_confirmed_cancel',
            {
              item: {},
              use_display_id: true,
              return_item_result: true,
              rev_no: Number(item.rev_no)
            }
          );
        })
      );
      // 見積確定のアイテムを設定
      const actionId: any = (() => {
        switch (this.screenStructureType) {
          case '1':
            return 'project_service_OA_valid_update';
          case '99':
            return 'project_service_general_valid_update';
          case '2':
            return 'project_service_fjapan_valid_update';
          default:
        }
      })();
      this.registData['related_ds_items'][this.matterServiceDsId] = [
        {
          'action_id': actionId,
          // 'action_id': this.screenStructureType === '1' ? "project_service_OA_valid_update": "project_service_general_valid_update",
          'operation': 2,
          'rev_no': matterServiceInformationResult.rev_no,
          'i_id': this.projectServiceItemId,
          item:
            this.screenStructureType === '1'
              ? {
                  'final_estimate_id': this.passedItemId,
                  'final_commodity_id': this.estimateInformationResult.field_values.commodity_id.value.item_id,
                  'final_monthly_lease_fee': this.estimateInformationResult.field_values.monthly_lease_fee.value,
                  'final_rate': this.estimateInformationResult.field_values.rate.value,
                  'final_contract_months': this.estimateInformationResult.field_values.contract_months.value,
                  'final_total_sales_amount': this.estimateInformationResult.field_values.total_sales_amount.value,
                  'final_consumption_tax': this.estimateInformationResult.field_values.consumption_tax.value,
                  'final_total_tax_included': this.estimateInformationResult.field_values.total_tax_included.value
                }
              : {
                  'final_estimate_id': this.passedItemId,
                  'final_commodity_id': this.estimateInformationResult.field_values.commodity_id.value.item_id,
                  'final_total_sales_amount': this.estimateInformationResult.field_values.total_sales_amount.value,
                  'final_consumption_tax': this.estimateInformationResult.field_values.consumption_tax.value,
                  'final_total_tax_included': this.estimateInformationResult.field_values.total_tax_included.value
                }
        }
      ];

      const buttonType = 'estimate_confirmed';

      // 構成表、明細追加入力、見積表の販売原価(振替単価または仕入単価)と販売売上を加算して、合計値を計算
      let finalEstimatedSellingCost = 0;
      let finalEstimatedSales = 0;
      for (const indexA in this.registMaterialItemData) {
        const baseItemA = this.registMaterialItemData[indexA].item;
        finalEstimatedSellingCost += baseItemA.transfer_unit_price * baseItemA.quantity;
        finalEstimatedSales += baseItemA.standard_unit_price * baseItemA.quantity;
      }
      for (const indexB in this.registDatailAddInputItemData) {
        const baseItemB = this.registDatailAddInputItemData[indexB].item;
        finalEstimatedSellingCost += baseItemB.purchase_unit_price * baseItemB.quantity;
        finalEstimatedSales += baseItemB.standard_unit_price * baseItemB.quantity;
      }
      for (const indexC in this.registEstimateDetailItemData) {
        const baseItemC = this.registEstimateDetailItemData[indexC].item;
        finalEstimatedSellingCost += baseItemC.purchase_unit_price * baseItemC.quantity;
        finalEstimatedSales += baseItemC.unit_price * baseItemC.quantity;
      }

      // 見積確定で案件基本情報と該当するサービス種別の見積基本情報の関連する内容を更新する
      const [matterInformationResult, execStatusActionResult] = await await Promise.all([
        this.estimate.updateItems(
          hexabaseState.applicationId,
          hexabaseState.datastoreIds['案件基本情報'],
          matterServiceInformationResult.linked_items.t_project_basic_infomation.items[0].i_id,
          {
            'rev_no': Number(matterServiceInformationResult.linked_items.t_project_basic_infomation.items[0].rev_no),
            'use_display_id': true,
            'ensure_transaction': true,
            'action_id': 'update',
            'item': {
              'final_quote_commodity': this.estimateInformationResult.field_values.commodity_id.value.item_id,
              'final_quotation_supplier': this.estimateInformationResult.field_values.commodity_id.value.lookup_item.lookup_items.supplier_id.i_id,
              'final_estimated_selling_cost': finalEstimatedSellingCost,
              'final_estimated_sales': finalEstimatedSales,
              'final_estimated_gross_profit': (finalEstimatedSales - finalEstimatedSellingCost)
            },
          }
        ),
        this.estimate.execStatusAction(
          this.registData,
          hexabaseState.applicationId,
          this.passedDatastoreId,
          this.relatedDsId,
          this.passedItemId,
          this.itemActions,
          this.detailItemActions,
          this.revNumber,
          buttonType
        )
      ]);

      this.isFixedMatterLoading = false;
      this.transitionDialogTitle = '実行完了';
      this.editText = '見積を確定しました';
      this.buttons.map(v => {
        v.route = String(v.route).replace(':id', this.passedItemId);
        v.route = String(v.route).replace(':datastoreId', this.passedDatastoreId);
      });
      this.dialogStatus = true;
    }
    this.isFixedMatterDialog = false;
  }

  /**
   * 任意の桁で切り捨てする関数
   * @param {number} value 切り捨てする数値
   * @param {number} base どの桁で切り捨てするか（10→10の位、0.1→小数第１位）
   * @return {number} 切り捨てした値
   */
  private orgFloor(value: number, base: number) {
    return Math.floor(value * base) / base;
  }

  /**
   * 金額再計算
   */
  private recalculateAmount() {
    // 税率毎のサマリを作成
    const mergeDetails = this.estimateTabData[0].configurationTableData.partsList.tableParameters[
      'body'
    ].concat(
      this.estimateTabData[0].configurationTableData.detailAddList.tableParameters['body'],
      this.estimateTabData[1].estimateInformationData.estimateDetailList.tableParameters['body']
    );
    this.taxData = this.createGroupByTaxClassificationId(mergeDetails);
    this.estimateDetailSummary.datas[0].props.value = this.taxData.reduce(
      (previousValue, currentValue) => Number(previousValue) + Number(currentValue.amount),
      0
    );
    this.estimateDetailSummary.datas[1].props.value = this.taxData.reduce(
      (previousValue, currentValue) => Number(previousValue) + Number(currentValue.tax),
      0
    );
    this.estimateDetailSummary.datas[2].props.value =
      this.estimateDetailSummary.datas[0].props.value +
      this.estimateDetailSummary.datas[1].props.value;
    this.$set(
      this.estimateTabData[1].estimateInformationData.createTaxSummary,
      'taxData',
      this.taxData
    );
  }

  /**
   * 金額変更項目の有効化（OAリース専用）
   */
  private enableAmountChange() {
    // ステータスアクションの「編集する」アクション（登録中／一時保存中）
    // ステータスアクションボタン押下時の選択アクションIDを参照
    const targetAction = this.estimate.getFormDisplayAction(
      this.statusAction,
      this.selectActionDisplayId
    );
    this.amountChange(targetAction!.action_id, false);
  }

  /**
   * 金額変更項目の無効化（OAリース専用）
   */
  private disableAmountChange() {
    // データ操作アクションの「端数処理後の更新」アクション
    // ('fraction_rounding_after_update')を参照
    const targetAction = this.estimate.getFormDisplayAction(
      this.itemActions,
      'fraction_rounding_after_update'
    );
    this.amountChange(targetAction!.action_id, true);
  }

  /**
   * 料率以外の金額変更項目の無効化（OAリース専用）
   */
  private enableAmountChangeRateOnly() {
    // ステータスアクションの「料率変更する」アクション（見積確定のみ）
    // ステータスアクションボタン押下時の選択アクションIDを参照
    const targetAction = this.estimate.getFormDisplayAction(
      this.statusAction,
      this.selectActionDisplayId
    );
    this.amountChange(targetAction!.action_id, true);
  }

  /**
   * 金額変更項目の有効／無効切替（OAリース専用）
   * @param {string} actionId 金額変更項目以外の項目の有効／無効情報を取得するためのアクションID
   * @param {boolean} isDisabledFlag true:無効化、false:有効化
   */
  private amountChange(actionId: string, isDisabledFlag: boolean) {
    // 見積情報タブの入力制御
    // 1.見積基本情報OA項目
    this.estimate.getFieldsByActionId(this.estimateDsId, actionId).then(response => {
      const inputFields = response;
      this.setRegistFieldType(inputFields, this.registFieldType);
      this.inputFieldChange(this.estimateInformationPanel.datas, inputFields, true);
      return response;
    });

    // 2.見積表一覧
    this.estimateTabData[1].estimateInformationData.estimateDetailList.isEstimateAddItemButtonFlag = isDisabledFlag
      ? false
      : true;
    const estimateDetailItems = this.estimateTabData[1].estimateInformationData.estimateDetailList
      .tableParameters.body;
    for (const index in this.estimateTabData[1].estimateInformationData.estimateDetailList
      .tableParameters.body) {
      // 種別IDが設定されていない明細は構成明細の集計結果明細なので有効／無効切替の対象外
      if (
        estimateDetailItems[index].type_id !== undefined &&
        estimateDetailItems[index].type_id !== ''
      ) {
        this.$set(estimateDetailItems[index], 'isDisabledAddButton', isDisabledFlag);
        this.$set(estimateDetailItems[index], 'isDisabledInput', isDisabledFlag);
      }
    }

    // 構成表タブの入力制御
    // 1.テンプレート設定
    this.$set(
      this.estimateTabData[0].configurationTableData.vmSelectDataTemplete,
      'isDisabled',
      isDisabledFlag
    );

    // 2.構成明細一覧
    if (isDisabledFlag) {
      // inputItemsを退避して削除
      this.saveMaterialInputItems = this.estimateTabData[0].configurationTableData.partsList.tableParameters.inputItems;
      this.estimateTabData[0].configurationTableData.partsList.tableParameters.inputItems = [];
    } else if (this.saveMaterialInputItems !== undefined) {
      // 退避からinputItemsの再設定
      this.estimateTabData[0].configurationTableData.partsList.tableParameters.inputItems = this.saveMaterialInputItems;
    }
    const materialItems = this.estimateTabData[0].configurationTableData.partsList.tableParameters.body;
    for (const index in this.estimateTabData[0].configurationTableData.partsList.tableParameters
      .body) {
      this.$set(materialItems[index], 'isDisabledAddButton', isDisabledFlag);
    }
    // ベースの構成表も設定（「数量がゼロの行を非表示」チェックボックス押下対応）
    for (const index in this.partsListBaseData) {
      this.$set(this.partsListBaseData[index], 'isDisabledAddButton', isDisabledFlag);
    }

    // 3.明細追加入力一覧
    if (isDisabledFlag) {
      // inputItemsを退避して削除
      this.saveDetailAddInputItems = this.estimateTabData[0].configurationTableData.detailAddList.tableParameters.inputItems;
      this.estimateTabData[0].configurationTableData.detailAddList.tableParameters.inputItems = [];
    } else if (this.saveDetailAddInputItems !== undefined) {
      // 退避からinputItemsの再設定
      this.estimateTabData[0].configurationTableData.detailAddList.tableParameters.inputItems = this.saveDetailAddInputItems;
    }
    this.estimateTabData[0].configurationTableData.detailAddList.tableParameters.isDisabledAddItemButtonFlag = isDisabledFlag;
    const datailAddItems = this.estimateTabData[0].configurationTableData.detailAddList.tableParameters.body;
    for (const index in this.estimateTabData[0].configurationTableData.detailAddList.tableParameters
      .body) {
      this.$set(datailAddItems[index], 'isDisabledAddButton', isDisabledFlag);
    }
  }

  /**
   * アラートダイアログボタンクリック時処理
   * @param {any} response 押下ボタン情報
   */
  private async clickAlertDialog(response: any) {
    if (response !== undefined && response.isAgree) {
      this.isAlertDialog = false;
    }
  }

  /**
   * 金額調整実行確認ダイアログボタンクリック時処理
   * @param {any} response 押下ボタン情報
   */
  private async clickRecalcDialog(response: any) {
    if (response !== undefined && response.isAgree) {
      // 端数調整金額
      let discountAmount = 0;

      if (this.fractionRoundingFlag) {
        // 端数調整済みの場合
        // 見積明細の末尾要素を取得（末尾が差額調整見積明細）
        const displayItemIndex =
          this.estimateTabData[1].estimateInformationData.estimateDetailList.tableParameters['body']
            .length - 1;
        const displayItem = this.estimateTabData[1].estimateInformationData.estimateDetailList
          .tableParameters['body'][displayItemIndex];
        // 現時点での端数調整金額を取得
        discountAmount = Number(displayItem['sale_price']);

        // 端数調整前の税抜合計額から調整金額を算出
        this.adjustmentAmount = this.calculationModel.adjustmentAmount(
          this.estimateDetailSummary.datas[0].props.value - discountAmount,
          this.estimateInformationPanel.datas[7].props.value,
          this.estimateInformationPanel.datas[8].props.value
        );
      } else {
        // 端数調整なしの場合
        // そのまま税抜合計額から調整金額を算出
        this.adjustmentAmount = this.calculationModel.adjustmentAmount(
          this.estimateDetailSummary.datas[0].props.value,
          this.estimateInformationPanel.datas[7].props.value,
          this.estimateInformationPanel.datas[8].props.value
        );
      }

      if (this.adjustmentAmount !== discountAmount) {
        // 増額・値引き共通処理

        if (this.fractionRoundingFlag) {
          // 端数調整済みの場合、見積明細の末尾要素を一旦削除（差額調整見積明細は末尾）
          this.estimateTabData[1].estimateInformationData.estimateDetailList.tableParameters[
            'body'
          ].pop();
        }
        // 見積明細追加要素を作成
        const itemsLength = this.estimateTabData[1].estimateInformationData.estimateDetailList
          .tableParameters['body'].length;
        const addItem = JSON.parse(JSON.stringify(EstimateDatailBaseFormat));
        addItem['No'] = itemsLength + 1;
        addItem['id'] = itemsLength + 1;
        addItem['display_order'] = itemsLength + 1 - this.estimateDetailSummaryLength;
        // 税率はデフォルト値をセット
        addItem['tax_classification_id'] = this.defaultTaxData.i_id;
        addItem['tax_classification'] = this.defaultTaxData.name;
        addItem['tax_rate'] = this.defaultTaxData.tax_rate;
        // 数量:1、販売単価:調整金額、仕入単価:0 をセット
        addItem['quantity'] = 1;
        addItem['unit_price'] = this.adjustmentAmount;
        addItem['sale_price'] = this.adjustmentAmount;
        addItem['purchase_unit_price'] = 0;
        addItem['purchasing_price'] = 0;
        // 各種ボタンは使用不可
        addItem['isDisabledAddButton'] = true;
        addItem['isDisabledInput'] = true;

        if (this.adjustmentAmount > 0) {
          // 増額調整の場合

          // 増額用見積明細マスタの情報をセット
          addItem['item'] = this.mastermEstimateDetailFractionIncrease.item;
          addItem['remarks'] = this.mastermEstimateDetailFractionIncrease.remarks;
          // 項目名の入力可否はDB登録値で可変
          addItem['input_flag'] = JSON.parse(
            this.mastermEstimateDetailFractionIncrease.input_flag.toLowerCase()
          );
          addItem['classification_id'] = this.mastermEstimateDetailFractionIncrease.classification_id;
          addItem['classification'] = this.mastermEstimateDetailFractionIncrease.classification_id;
          addItem['type_id'] = this.mastermEstimateDetailFractionIncrease.type_id;
          addItem['type'] = this.mastermEstimateDetailFractionIncrease.type_id;
          // 営業利益、利益率の計算
          addItem['operating_income'] = this.calculationModel.operatingIncome(
            addItem['sale_price'],
            addItem['purchasing_price']
          );
          addItem['profit_rate'] = this.calculationModel.profitRate(
            addItem['operating_income'],
            addItem['sale_price'],
            this.defaultRoundingType
          );

          if (this.fractionRoundingFlag) {
            // 端数調整済みの場合
            // 見積表用登録データの差額調整見積明細データを書き替え
            const registItemIndex = this.registEstimateDetailItemData.length - 1;
            this.registEstimateDetailItemData[registItemIndex].item[
              'estimate_detail_id'
            ] = this.mastermEstimateDetailFractionIncrease.i_id;
            this.registEstimateDetailItemData[registItemIndex].item['item'] = addItem['item'];
            this.registEstimateDetailItemData[registItemIndex].item['unit_price'] = addItem['unit_price'];
            this.registEstimateDetailItemData[registItemIndex].item['purchase_unit_price'] = addItem['purchase_unit_price'];
            this.registEstimateDetailItemData[registItemIndex].item['quantity'] = addItem['quantity'];
            this.registEstimateDetailItemData[registItemIndex].item['remarks'] = addItem['remarks'];
            this.registEstimateDetailItemData[registItemIndex].item['tax_classification_id'] = addItem['tax_classification_id'];
          } else {
            // 端数調整なしの場合
            // 見積表用登録データの差額調整見積明細データを追加
            this.registEstimateDetailItemData.push({
              item: {
                display_order: Number(this.registEstimateDetailItemData.length) + 1,
                item: addItem['item'],
                estimate_detail_id: this.mastermEstimateDetailFractionIncrease.i_id,
                unit_price: addItem['unit_price'],
                purchase_unit_price: addItem['purchase_unit_price'],
                quantity: addItem['quantity'],
                remarks: addItem['remarks'],
                tax_classification_id: addItem['tax_classification_id']
              }
            });
          }

          // 再計算実行後のダイアログメッセージ設定
          this.alertDialogMessage = EstimateFractionRoundWording.alertRecalcIncreasedAmount.message;
          this.alertDialogTitle = EstimateFractionRoundWording.alertRecalcIncreasedAmount.title;
        } else {
          // 値引き調整の場合

          // 値引き用見積明細マスタの情報をセット
          addItem['item'] = this.mastermEstimateDetailFractionDiscount.item;
          addItem['remarks'] = this.mastermEstimateDetailFractionDiscount.remarks;
          // 項目名の入力可否はDB登録値で可変
          addItem['input_flag'] = JSON.parse(
            this.mastermEstimateDetailFractionDiscount.input_flag.toLowerCase()
          );
          addItem['classification_id'] = this.mastermEstimateDetailFractionDiscount.classification_id;
          addItem['classification'] = this.mastermEstimateDetailFractionDiscount.classification_id;
          addItem['type_id'] = this.mastermEstimateDetailFractionDiscount.type_id;
          addItem['type'] = this.mastermEstimateDetailFractionDiscount.type_id;
          // 営業利益、利益率の計算
          addItem['operating_income'] = this.calculationModel.operatingIncome(
            addItem['sale_price'],
            addItem['purchasing_price']
          );
          addItem['profit_rate'] = this.calculationModel.profitRate(
            addItem['operating_income'],
            addItem['sale_price'],
            this.defaultRoundingType
          );

          if (this.fractionRoundingFlag) {
            // 端数調整済みの場合
            // 見積表用登録データの差額調整見積明細データを書き替え
            const registItemIndex = this.registEstimateDetailItemData.length - 1;
            this.registEstimateDetailItemData[registItemIndex].item[
              'estimate_detail_id'
            ] = this.mastermEstimateDetailFractionDiscount.i_id;
            this.registEstimateDetailItemData[registItemIndex].item['item'] = addItem['item'];
            this.registEstimateDetailItemData[registItemIndex].item['unit_price'] = addItem['unit_price'];
            this.registEstimateDetailItemData[registItemIndex].item['purchase_unit_price'] = addItem['purchase_unit_price'];
            this.registEstimateDetailItemData[registItemIndex].item['quantity'] = addItem['quantity'];
            this.registEstimateDetailItemData[registItemIndex].item['remarks'] = addItem['remarks'];
            this.registEstimateDetailItemData[registItemIndex].item['tax_classification_id'] = addItem['tax_classification_id'];
          } else {
            // 端数調整なしの場合
            // 見積表用登録データの差額調整見積明細データを追加
            this.registEstimateDetailItemData.push({
              item: {
                display_order: Number(this.registEstimateDetailItemData.length) + 1,
                item: addItem['item'],
                estimate_detail_id: this.mastermEstimateDetailFractionDiscount.i_id,
                unit_price: addItem['unit_price'],
                purchase_unit_price: addItem['purchase_unit_price'],
                quantity: addItem['quantity'],
                remarks: addItem['remarks'],
                tax_classification_id: addItem['tax_classification_id']
              }
            });
          }

          // 金額調整実行後のダイアログメッセージ設定
          if (this.adjustmentAmount < discountAmount) {
            // 値引き額が増えた
            this.alertDialogMessage = EstimateFractionRoundWording.alertRecalcIncreasedDiscount.message;
            this.alertDialogTitle = EstimateFractionRoundWording.alertRecalcIncreasedDiscount.title;
          } else {
            // 値引き額が減った
            this.alertDialogMessage = EstimateFractionRoundWording.alertRecalcDecreaseDiscount.message;
            this.alertDialogTitle = EstimateFractionRoundWording.alertRecalcDecreaseDiscount.title;
          }
        }
        // 差額調整見積明細の追加
        this.estimateTabData[1].estimateInformationData.estimateDetailList.tableParameters[
          'body'
        ].push(addItem);

        // 金額再計算
        this.recalculateAmount();

        // 端数調整実施フラグを立てる
        this.fractionRoundingFlag = true;
        this.registData.item['fraction_rounding_flag'] = this.fractionRoundingFlag.toString();
      } else {
        // 調整金額が変わらない場合のダイアログメッセージ設定
        this.alertDialogMessage = EstimateFractionRoundWording.alertRecalcNoChange.message;
        this.alertDialogTitle = EstimateFractionRoundWording.alertRecalcNoChange.title;
      }
      // 料率変更フラグを下す
      this.rateChangeFlag = false;
      // 再計算実行後のメッセージダイアログ表示
      this.isAlertDialog = true;
    }
    this.isRecalcDialog = false;
  }

  /**
   * 事前与信チェックダイアログボタンクリック時処理
   * @param {any} response 押下ボタン情報
   */
  private async clickCreditCheckDialog(response: any) {
    if (response !== undefined && response.isAgree === false) {
      // キャンセル
      // 初期表示時に編集画面表示とするappState値を設定
      const options = appState.getOptions;
      options['初期表示切替']['見積詳細']['edit_initial_view'] = 1;
      appState.setOptions(options);

      this.isCreditCheckDialog = false;
      this.$router.go(0);
    } else {
      // OKはなにもせずクローズ
      this.isCreditCheckDialog = false;
    }
  }
  
  /**
   * 帳票テンプレート用課税区分パラメータ整形処理
   * @param {any} taxDatas 課税区分情報
   */
  private async modifyTaxDatas(taxDatas: any) {
    for (let i = 0; i < taxDatas.length; i++) {
      const taxName = taxDatas[i].name.match(/（.*?）/g);
      if (taxName) {
        taxDatas[i].name = taxDatas[i].name.replace(taxName[0], '');
      }
    }
  }
}
